{
    "logo": "Cephable-Logo",
    "add": "Hinzufügen",
    "all": "Alle",
    "edit": "Bearbeiten",
    "create": "Erstellen",
    "delete": "Löschen",
    "previous": "Vorherige",
    "next": "Nächste",
    "search": "Suchen",
    "loading": "Laden...",
    "reload": "Neu laden",
    "cancel": "Stornieren",
    "copy": "Kopie",
    "save": "Speichern",
    "saveAndFinish": "Speichern und beenden",
    "saveAndContinue": "Speichern und fortfahren",
    "saved": "Gespeichert",
    "done": "Erledigt",
    "back": "Zurück",
    "play": "Spielen",
    "pause": "Pause",
    "success": "Erfolg",
    "continue": "Weitermachen",
    "options": "Optionen",
    "share": "Aktie",
    "finish": "Beenden",
    "finishEdit": "Bearbeitung beenden",
    "advancedOptions": "Erweiterte Optionen anzeigen",
    "authenticating": "Authentifizierung...",
    "skipToMain": "Zum Hauptinhalt springen",
    "skip": "Überspringen",
    "close": "Schließen",
    "notFound": "Seite nicht gefunden",
    "notFoundDescription": "Oh nein! Wir haben das ganze Meer abgesucht und können die Seite nicht finden!",
    "exitSetup": "Setup beenden",
    "experimental": "Experimental",
    "letGetStarted": "Lasst uns anfangen!",
    "exploreInputControls": "Eingabesteuerung erkunden",
    "when": "Wenn ich ...",
    "thenMacro": "Cephable wird ausgeführt ...",
    "controls": "Bedienelemente",
    "welcome": "Willkommen.",
    "beta": "Beta",
    "macroEmpty": "Es gibt keine Makros, die diesen Kriterien entsprechen.",
    "you": "Du",
    "step": "Schritt",
    "steps": "Vorgehensweise",
    "learnMore": "Mehr erfahren",
    "dangerZone": "Gefahrenzone",
    "connected": "Verbunden",
    "notConnected": "Nicht verbunden",
    "connectAndLearn": "Vernetzen und lernen",
    "tryAgain": "Versuchen Sie es erneut",
    "by": "Von: {{value}}",
    "noName": "- kein Name -",
    "details": "Details",
    "controlFeed": "Kontrollvorschub",
    "upgrade": "Aktualisierung",
    "mobileApp": {
        "title": "Mobile App"
    },
    "dashboard": {
        "title": "Armaturenbrett"
    },
    "invalidNumber": "N / A",
    "wifi": {
        "disconnected": "Die WLAN-Verbindung ist getrennt.",
        "connected": "WLAN ist verbunden.",
        "description": "Stellen Sie eine WLAN-Verbindung her, damit Cephable mit Ihren Verbindungen und Ihrer Software funktioniert. Möglicherweise sind Ihre aktuellen Steuerelemente nur eingeschränkt nutzbar."
    },
    "signalR": {
        "disconnected": "Die Synchronisierung ist getrennt.",
        "action": "Neu verbinden",
        "description": "Es scheint ein Problem mit der Cephable-Synchronisierung zu geben. Dies führt zu Problemen beim Speichern Ihrer Einstellungen oder bei der Kommunikation mit anderen Verbindungen.",
        "disconnectedDevice": "Synchronisierung mit {{name}} nicht möglich.",
        "disconnectedDeviceDescription": "Es scheint ein Problem mit der Synchronisierung zu geben, entweder aufgrund der Authentifizierung oder der Internetverbindung. Sie können keine Daten senden oder empfangen. Bitte überprüfen Sie beide Seiten der Verbindung.",
        "connected": "Die Synchronisierung ist verbunden.",
        "connectedDescription": "Cephable synchronisiert ordnungsgemäß und sollte wie erwartet mit Ihren Verbindungen und Erweiterungen kommunizieren.",
        "swap": "Wechseln Sie zur Verbindung mit einem lokalen Gerät.",
        "unlinkedDevice": "Verbindung getrennt.",
        "unlinkedDeviceDescription": "Diese Verbindung wurde von Ihrem Konto getrennt.",
        "featureRestricted": "Die Funktionen „Erstellen“ und „Automatisieren“ sind für Remote-Verbindungen nicht verfügbar.",
        "featureRestrictedDescription": "Diese Funktion ist derzeit für Remote-Verbindungen nicht verfügbar. Bitte wechseln Sie zur lokalen Geräteverbindung, um alle Funktionen zur Erstellung und Automatisierung Ihrer Arbeit nutzen zu können."
    },
    "billing": {
        "title": "Abrechnung",
        "expires": "Nächste Abrechnung: {{value}}",
        "isEmployeeAccess": {
            "title": "Professional",
            "titleLong": "Cephable Profi",
            "short": "Pro",
            "description": "Cephable Professional verleiht Benutzern mehr Produktivität und erweitert die lokale, private KI um generative Fähigkeiten.",
            "supportedFeatures": {
                "tag": "Alles in Plus, plus",
                "features": [
                    "On-Device-KI-Workflows",
                    "Unternehmensorganisationsmanagement",
                    "Unternehmensbeschränkungen",
                    "Unbegrenzte Geräteinstallationen",
                    "Unbegrenzte Anzahl vorkonfigurierter App-Steuerelemente"
                ]
            }
        },
        "isDeveloperAccess": {
            "title": "SDK",
            "titleLong": "Cephable SDK",
            "short": "SDK",
            "description": "Mit Cephable SDKs können Sie leistungsstarke adaptive Steuerelemente – Sprache, Gesicht, Kopf und mehr – mit minimalem Aufwand und maximalem Nutzen in Ihre Software integrieren.",
            "supportedFeatures": {
                "tag": "Alles in Plus, plus",
                "features": [
                    "Windows- und MacOS-Unterstützung",
                    "Leichtgewichtige, einbettbare SDKs für die Offline-Eingabe von Sprache, Gesicht, Kopf und schnellen Aktionen",
                    "API-/Webhook-Unterstützung für benutzerdefinierte Ausgabeaktionen",
                    "Entwicklerdokumente",
                    "Beispielprojekte",
                    "Verwandeln Sie Befehle in Dokumentautomatisierung und -navigation",
                    "Entwicklerportal zur Verwaltung Ihrer Projekte, Authentifizierungsclients, Gerätetypen und mehr"
                ]
            }
        },
        "isStudentAccess": {
            "title": "Student",
            "titleLong": "Cephable-Ausbildung",
            "short": "Bildung",
            "description": "Cephable Education unterstützt personalisiertes Lernen und inklusiven Unterricht. Cephable funktioniert offline, läuft auf dem Gerät und erfordert keine Integration von Drittanbietern.",
            "supportedFeatures": {
                "tag": "Alles in Plus, plus",
                "features": [
                    "Unbegrenzte Geräteinstallationen",
                    "Unbegrenzte vorab trainierte App-Steuerelemente",
                    "Unbegrenztes Teilen von benutzerdefinierten App-Steuerelementen"
                ]
            }
        },
        "viewProducts": "Produkte anzeigen",
        "description": "Verwalten Sie die Abrechnung, Sitze, Abonnement-Upgrades, Verlängerungen oder Kündigungen Ihres Unternehmens.",
        "view": "Abrechnung verwalten",
        "isResellerAccess": {
            "title": "Wiederverkäufer",
            "titleLong": "Cephable-Wiederverkäufer",
            "description": "Cephable Reseller ist eine kostenpflichtige Lizenz, mit der Sie neue Organisationen erstellen und Lizenzschlüssel zuweisen können. Dazu gehört die Verwendung von Cephable mit Ihrer eigenen Software-Suite und die Verbesserung Ihrer Benutzererfahrung.",
            "short": "Wiederverkäufer"
        },
        "error": "Bitte wenden Sie sich zur Verwaltung Ihrer Abrechnung an Ihren Systemadministrator.",
        "included": "In Ihrer {{licenseType}}-Lizenz enthalten.",
        "upgrade": {
            "description": "Führen Sie jetzt ein Upgrade durch und bringen Sie Ihre Steuerung auf die nächste Stufe.",
            "action": "Jetzt upgraden",
            "error": "Fehler bei der Aktualisierung. Bitte versuchen Sie es später erneut.",
            "requiredDetail": "Für diese Funktion ist eine {{licenseType}}-Lizenz erforderlich. Sie können jederzeit in Ihren Kontoeinstellungen ein Upgrade durchführen oder eine kostenlose Testversion starten.",
            "enableTextGeneration": "Erstellen Sie Inhalte mithilfe von KI und Ihrer Stimme.",
            "longDescription": "Aktualisieren Sie auf eine kostenpflichtige Lizenz, um alle Funktionen von Cephable freizuschalten. Von mehreren Geräten über erweiterte Bedienelemente bis hin zu benutzerdefinierten Integrationen bietet Cephable alles, was Sie für ein höheres Produktivitätsniveau benötigen.",
            "compare": "Pläne vergleichen",
            "enableAiDictation": {
                "title": "Upgrade auf intelligentes Diktieren",
                "description": "Aktualisieren Sie, um die KI-gestützte Diktierfunktion freizuschalten. Ich kann Satzzeichen hinzufügen, Groß- und Kleinschreibung korrigieren und mich Ihrem Stil anpassen, damit Ihr Text ohne zusätzlichen Aufwand professionell aussieht."
            },
            "enableAiWorkflows": "Rüsten Sie auf, um Ihre Desktop- und Browseraufgaben mit KI-Workflows zu automatisieren."
        },
        "isPlusAccess": {
            "title": "Plus",
            "titleLong": "Cephable Plus",
            "short": "Plus",
            "description": "Cephable Plus ist für Power-User, die mit intelligenter Stimme, intelligentem Diktiergerät, Hunderten von App-Steuerelementen und mehr mehr erreichen möchten.",
            "supportedFeatures": {
                "tag": "Alles aus Basic, plus",
                "features": [
                    "Intelligente Sprachsteuerung (Natürliche Sprache)",
                    "Intelligente Diktierfunktion (KI-gestützt)",
                    "Intelligente Aufgaben (Generierung, Übersetzung, Umschreibung)",
                    "Hunderte vorkonfigurierte App-Steuerelemente"
                ]
            }
        },
        "personal": {
            "short": "Basic",
            "title": "Basic",
            "titleLong": "Cephable Basic",
            "description": "Cephable Basic ist dauerhaft kostenlos und hilft Ihnen, schneller voranzukommen, sich auszudrücken und Aufgaben zu erledigen – ganz nach Ihren Wünschen. Die in Basic enthaltenen Funktionen stehen allen Nutzern zur Verfügung.",
            "upgrade": {
                "title": "Bringen Sie Ihre Steuerung auf die nächste Stufe",
                "description": "Steigen Sie auf Plus oder Pro um und schalten Sie alle Funktionen frei. Mehr Genauigkeit. Mehr Verbindungen. Mehr Steuerungsmöglichkeiten. Mehr Leistung für maximale Produktivität.",
                "featureHeading": "So kann ich Ihnen helfen:",
                "control": "Ich führe Sie per Sprachbefehl oder Schnellaktionen schneller durch Apps und Tools – ohne Unterbrechungen. Mit Intelligent Voice können wir uns einfach unterhalten.",
                "create": "Ich schreibe, diktiere, generiere und übersetze direkt in Ihren Apps – kein Kopieren, Einfügen oder Umschalten zwischen Bildschirmen erforderlich.",
                "automate": "Ich führe intelligente Aufgaben und schnelle Aktionen aus, die Ihren Arbeitsablauf beschleunigen. Von einfachen Befehlen bis hin zu komplexen Makros – ich übernehme die Routinearbeiten, damit Sie sich auf das Wesentliche konzentrieren können.",
                "local": "Reine lokale KI. Keine Cloud-Verarbeitung."
            }
        },
        "mostPopular": "Am beliebtesten",
        "subscription": {
            "options": "Abonnementoptionen",
            "monthly": "Monatlich bezahlen",
            "billedMonthly": "/Monat",
            "yearly": "Jährliche Zahlung",
            "billedYearly": "/Jahr"
        }
    },
    "organization": {
        "title": "Organisation",
        "titlePlural": "Organisationen",
        "titleLong": "Cephable Professional für Organisationen",
        "description": "Organisationen sind Gruppen von Benutzern, die an Projekten zusammenarbeiten und Ressourcen teilen können. Hier können Sie Ihr Team, Teamprofile, Abrechnungen und mehr verwalten.",
        "noAccess": {
            "title": "Zugriff verweigert.",
            "description": "Ihre Berechtigungen wurden kürzlich geändert und Sie haben keinen Zugriff mehr auf diese Funktion. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Administrator Ihrer Organisation."
        },
        "noOrg": {
            "title": "Keine zugehörige Lizenz.",
            "description": "Sie sind derzeit keiner Lizenz oder Entwicklergruppe zugeordnet. Der Zugriff auf das Portal ist auf Benutzer mit einer kostenpflichtigen Cephable-Lizenz beschränkt. Um das volle Potenzial von Cephable auszuschöpfen, starten Sie eine risikofreie Testversion."
        },
        "member": {
            "title": "Mitglied",
            "titlePlural": "Mitglieder",
            "me": "Meine Mitgliedschaft",
            "description": "Mitglieder sind Benutzer, die Teil Ihrer Organisation sind. Ihnen können verschiedene Rollen zugewiesen werden und sie haben Zugriff auf unterschiedliche Teile der Organisation.",
            "edit": "Mitglieder bearbeiten",
            "removed": "Sie wurden aus einem Team entfernt.",
            "removedDescription": "Sie wurden aus dem Team entfernt. Sie können nicht mehr auf die Organisation zugreifen. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Administrator Ihrer Organisation.",
            "updated": "Erfolg, die Mitgliedschaft von {{value}} wurde aktualisiert.",
            "error": "Fehler beim Aktualisieren der Mitgliedschaft von {{value}}.",
            "delete": "Erfolg, {{value}} wurde entfernt.",
            "deleteError": "Fehler beim Entfernen von {{value}}.",
            "deleteConfirmation": {
                "title": "Möchten Sie dieses Mitglied wirklich entfernen?",
                "description": "Sobald Sie dieses Mitglied entfernen, hat es keinen Zugriff mehr auf die Organisation. Sie können es später jederzeit erneut einladen.",
                "confirm": "Ja, Mitglied entfernen"
            },
            "viewAll": {
                "title": "Alle Mitglieder anzeigen",
                "description": "Zeigen Sie alle Mitglieder Ihrer Organisation an und verwalten Sie ihre Rollen und Berechtigungen."
            },
            "seats": {
                "title": "Mitgliedersitze",
                "description": "Jedes Mitglied in Ihrer Organisation zählt als Sitz. Die Art der Berechtigungen, die sie haben, kann vom Organisationsadministrator geändert werden.",
                "stats": "Sitzplätze von {{value}}",
                "max": "Max Sitzplätze",
                "current": "Aktuelle Sitze",
                "limit": {
                    "title": "Maximale Anzahl an Sitzplätzen erreicht",
                    "description": "Ihr aktueller Plan hat sein Limit von {{ maxSeats }} verfügbaren Plätzen erreicht. Sie können keine weiteren Mitglieder einladen. Wenden Sie sich bitte an Ihren Administrator, um den Plan zu aktualisieren oder Ihre Sitzplatzzuteilung zu verwalten."
                },
                "updateLimit": {
                    "title": "Aktualisieren Sie Ihren Plan, um weitere Plätze hinzuzufügen",
                    "description": "Ihr aktueller Plan hat die maximale Anzahl an Sitzplätzen erreicht: {{ maxSeats }}. Führen Sie jetzt ein Upgrade durch, um zusätzliche Sitzplätze freizuschalten und sicherzustellen, dass Ihr Team nahtlos weiter wachsen kann.",
                    "action": "Upgrade-Plan"
                },
                "maxSeatValue": "Max. Sitzplätze: {{value}}"
            },
            "aboutMe": "Über mich",
            "loadError": "Fehler beim Laden der Organisationsmitglieder.",
            "orgTitle": "Mitglieder von {{value}}",
            "emailExists": "In der Organisation ist bereits eine E-Mail-Adresse vorhanden. Bitte geben Sie eine andere E-Mail-Adresse ein."
        },
        "invite": {
            "title": "Einladen",
            "titlePlural": "Einladungen",
            "description": "Benutzer erhalten Einladungen, Ihrer Organisation beizutreten. Sie können Benutzer einladen, Ihrer Organisation beizutreten und ihnen verschiedene Rollen zuweisen.",
            "edit": "Mitglied hinzufügen",
            "view": "Alle Einladungen anzeigen",
            "viewDescription": "Alle aktuellen Einladungen anzeigen, die nicht angenommen wurden.",
            "new": "Ein Mitglied einladen",
            "emailRequired": "E-Mail ist erforderlich",
            "emailInvalid": "E-Mail ist ungültig. Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            "emailExists": "E-Mail wurde bereits zu einer organisation eingeladen. Bitte geben Sie eine andere E-Mail-Adresse ein.",
            "emailPlaceholder": "E-Mail-Adresse eingeben",
            "expiration": "Läuft ab",
            "delete": "Einladung löschen",
            "confirm": "Möchten Sie diese Einladung wirklich entfernen?",
            "confirmLong": "Sobald Sie diese Einladung löschen, kann der Benutzer der Organisation nicht mehr beitreten. Sie können ihn später jederzeit erneut einladen.",
            "accept": "Einladung annehmen",
            "stat": "aktive Einladungen",
            "noInvites": {
                "title": "Keine Einladungen.",
                "description": "Es sieht so aus, als ob es für Ihre Organisation keine aktiven Einladungen gibt."
            },
            "acceptSuccess": {
                "title": "Willkommen im Team.",
                "description": "Sie sind der Organisation erfolgreich beigetreten.",
                "action": "Zeigen Sie Ihre neue Organisation an"
            },
            "acceptError": {
                "title": "Hoppla. Da liegt offenbar ein Problem vor.",
                "description": "Beim Beitritt zur Organisation ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Administrator Ihrer Organisation.",
                "action": "Zurück zur Homepage"
            },
            "send": {
                "success": "Einladung an {{value}} gesendet.",
                "error": "Fehler beim Senden der Einladung an {{value}}.",
                "title": "Einladung senden"
            },
            "error": "Fehler beim Laden der Einladungen.",
            "orgTitle": "Einladungen von {{value}}",
            "editDescription": "Erstellen Sie eine neue Einladung für einen Benutzer, Ihrer Organisation beizutreten."
        },
        "role": {
            "title": "Rolle",
            "titlePlural": "Rollen",
            "description": "Rollen sind die verschiedenen Zugriffsebenen, die ein Benutzer in Ihrer Organisation haben kann. Sie können Benutzern verschiedene Rollen zuweisen, um zu steuern, was sie tun können."
        },
        "isAdmin": {
            "title": "Verwaltung",
            "description": "Administratoren haben vollen Zugriff auf die Organisation und können alle Aspekte der Organisation verwalten.",
            "conflict": "Dieses Mitglied ist ein Administrator. Sie sind nicht berechtigt, seine Rollen zu bearbeiten."
        },
        "canViewMembers": {
            "title": "Mitglieder anzeigen",
            "description": "Benutzer mit dieser Berechtigung können alle Mitglieder der Organisation anzeigen."
        },
        "canInviteMembers": {
            "title": "Mitglieder einladen",
            "description": "Benutzer mit dieser Berechtigung können neue Mitglieder zur Organisation einladen und bestehende Einladungen verwalten."
        },
        "canChangeMemberPermissions": {
            "title": "Mitgliederrollen ändern",
            "description": "Benutzer mit dieser Berechtigung können die Rolle anderer Mitglieder in der Organisation ändern."
        },
        "canRemoveMembers": {
            "title": "Mitglieder entfernen",
            "titleSingle": "Mitglied entfernen",
            "action": "Entfernen",
            "description": "Benutzer mit dieser Berechtigung können andere Mitglieder aus der Organisation entfernen.",
            "confirm": "Möchten Sie dieses Mitglied wirklich aus der Organisation entfernen?",
            "confirmLong": "Sobald Sie dieses Mitglied entfernen, hat es keinen Zugriff mehr auf die Organisation. Sie können es später jederzeit erneut einladen."
        },
        "canCreateAuthClients": {
            "title": "Projekte erstellen",
            "description": "Benutzer mit dieser Berechtigung können neue Authentifizierungsclients und -projekte für die Organisation erstellen."
        },
        "canManageBilling": {
            "title": "Abrechnung verwalten",
            "description": "Benutzer mit dieser Berechtigung können die Abrechnungseinstellungen für die Organisation verwalten.",
            "error": "Sie sind nicht berechtigt, die Abrechnung für diese Organisation zu verwalten."
        },
        "metrics": {
            "title": "Metriken",
            "description": "Metriken sind Datenpunkte, die Ihnen helfen zu verstehen, wie Ihre Organisation Cephable verwendet.",
            "view": "Metriken anzeigen",
            "lineChart": {
                "title": "Durchschnittliche Anzahl gleichzeitiger Verbindungen",
                "description": "Dieses Diagramm zeigt die durchschnittliche Anzahl gleichzeitiger Verbindungen für die Organisations- und Projektdaten im Zeitverlauf.",
                "max": "Max. Verbindungen: {{maxConnections}}",
                "project": "Projektgesamt",
                "org": "Organisation Gesamt"
            },
            "orgTitle": "Metriken für {{value}}",
            "manage": {
                "title": "Leistungsmetriken",
                "description": "Laden Sie die während der Modellinferenz erfassten Leistungsmetriken herunter oder löschen Sie sie."
            },
            "download": {
                "button": "Metriken herunterladen",
                "success": "Die Metrikdatei wurde in Ihrem Download-Ordner gespeichert.",
                "error": "Das Herunterladen der Metrikdatei ist fehlgeschlagen.",
                "noFile": "Keine Metrikdatei gefunden. Versuchen Sie zunächst, das Modell auszuführen."
            },
            "clear": {
                "button": "Klare Metriken",
                "success": "Die Metriken wurden gelöscht.",
                "error": "Das Löschen der Metrikdatei ist fehlgeschlagen.",
                "confirm": {
                    "title": "Klare Leistungsmetriken",
                    "description": "Möchten Sie wirklich alle aufgezeichneten Leistungsmesswerte löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
                    "cancel": "Stornieren",
                    "confirm": "Klare Metriken"
                }
            }
        },
        "projects": {
            "title": "Projekte",
            "description": "Verwenden Sie Projekte, um den sicheren Zugriff zu verwalten, Geräteinteraktionen zu konfigurieren und die Art und Weise zu optimieren, wie Ihre Apps plattformübergreifend Befehle senden und empfangen.",
            "name": "App-Name",
            "view": "Projekte anzeigen",
            "error": "Fehler beim Laden der Projekte.",
            "stats": {
                "title": "Projektstatistiken",
                "connections": "Verbindungen insgesamt",
                "all": {
                    "title": "Alle Projektmetriken",
                    "description": "Aggregierte Metriken für alle mit {{ orgName }} verknüpften Projekte"
                },
                "card": "Projekte von {{value}}",
                "users": "Gesamtnutzerzahl seit {{date}}",
                "avgUsers": "Durchschnittliche monatliche Benutzerzahl.",
                "concurrent": {
                    "title": "Durchschnittliche Anzahl gleichzeitiger Verbindungen in den letzten {{days}} Tagen",
                    "label": "Gleichzeitiger Durchschn",
                    "max": "Max. Verbindungen",
                    "overage": "Überschuss",
                    "description": "Gleichzeitige Verbindungen geben die Anzahl der Benutzer an, die gleichzeitig mit Ihrem Projekt verbunden sind. Diese Kennzahl hilft Ihnen zu verstehen, wie viele Benutzer Ihre App gleichzeitig verwenden."
                }
            },
            "projectType": {
                "title": "Projekttyp",
                "description": "Projekttypen werden verwendet, um Ihre Projekte zu kategorisieren und uns dabei zu helfen, die richtigen SDKs für Sie auszuwählen."
            },
            "accessDenied": {
                "generic": "Sie haben keinen Zugriff auf dieses Projekt.",
                "title": "Zugriff verweigert.",
                "description": "Sie haben keinen Zugriff zum Anzeigen, Erstellen, Bearbeiten oder Löschen von Projekten. Wenden Sie sich für den Zugriff bitte an Ihren Administrator."
            },
            "upgrade": {
                "title": "Upgrade auf Cephable SDK",
                "description": "Cephable kann mithilfe unserer SDKs direkt in Ihre App, Ihr Spiel oder Ihren Dienst integriert werden. Projekte sind derzeit mit Ihrem Konto nicht verfügbar. Wenn Sie glauben, dass ein Fehler vorliegt, wenden Sie sich bitte an support@cephable.com.",
                "shortDescription": "Projekte sind für Ihr Konto derzeit nicht verfügbar. Wenden Sie sich an uns, um ein Upgrade durchzuführen."
            },
            "limit": {
                "title": "Lust auf mehr Projekte?",
                "error": "Projektlimit erreicht.",
                "description": "Sie haben die maximale Anzahl an Projekten für Ihre Organisation erreicht. Wenden Sie sich bitte an Ihren Administrator, um Ihr Konto zu aktualisieren."
            },
            "create": {
                "title": "Projekt erstellen",
                "titleLong": "Lasst uns anfangen.",
                "first": {
                    "title": "Beginnen Sie mit Ihrem Projekt.",
                    "description": "Es sieht so aus, als hätten Sie noch kein Projekt erstellt. Client-Schlüssel und -Geräte sind für die sichere Kommunikation zwischen Ihren Anwendungen und unseren Diensten unerlässlich. Mit einem Client-Schlüssel können Sie Sprach- und Kopfbewegungssteuerungen schnell und sicher in Ihre Apps integrieren."
                },
                "details": {
                    "title": "Projektdetails",
                    "description": "Erstellen Sie ein neues Projekt, um die Autorisierung, Gerätefunktionen und SDK-Integrationen Ihrer Anwendung zu verwalten. Befolgen Sie die folgenden Schritte, um sichere, anpassbare Interaktionen für Ihre Benutzer einzurichten."
                }
            },
            "sdk": {
                "title": "Laden Sie das SDK herunter",
                "description": "Erhalten Sie Zugriff auf unser leistungsstarkes SDK, das entwickelt wurde, um adaptive Steuerungen zu vereinfachen.",
                "select": {
                    "title": "SDK auswählen",
                    "description": "Wählen Sie das SDK aus, das Sie für dieses Projekt verwenden möchten. Unsere SDKs ermöglichen die nahtlose Integration adaptiver Sprach- und Kopfbewegungssteuerungen über verschiedene Plattformen hinweg."
                }
            },
            "clients": {
                "title": "Autorisierungsclients",
                "configure": "Autorisierungsclient konfigurieren",
                "description": "Autorisierungsclients verwalten den sicheren Zugriff auf Ihre Anwendungen. Definieren Sie einen Autorisierungsclient, um Benutzer zu authentifizieren und Interaktionen mit Ihrer Anwendung zu steuern.",
                "settings": "Autorisierungseinstellungen",
                "create": "Autorisierungsclient erstellen",
                "max": "Max. Projekte: {{value}}"
            },
            "secret": {
                "title": "Client-Geheimnis",
                "created": "Ihr Client-Geheimnis wurde erstellt.",
                "description": "Ihr Client-Geheimnis wird nur einmal angezeigt. Kopieren Sie es jetzt und bewahren Sie es an einem sicheren Ort auf.<br><br> Verwenden Sie es nur für Ihre eigene Entwicklung. Geben Sie es nicht an Dienste oder Anwendungen von Drittanbietern weiter.",
                "copy": "Geheimen Schlüssel kopieren",
                "rotate": {
                    "title": "Rotieren des Client-Geheimnisses",
                    "description": "ACHTUNG: Diese Aktion widerruft Ihr bestehendes Client-Geheimnis und erstellt ein neues Client-Geheimnis. Dazu müssen Sie Ihre gesamte bestehende Nutzung in Ihren Apps aktualisieren. Diese Aktion kann nicht rückgängig gemacht werden.",
                    "error": "Fehler beim Rotieren des Geheimnisses. Bitte versuchen Sie es später noch einmal."
                }
            },
            "key": {
                "title": "Client-Schlüssel",
                "view": "Clientschlüssel anzeigen",
                "copy": "Schlüssel kopieren",
                "delete": {
                    "title": "Clientschlüssel löschen",
                    "description": "WARNUNG: Diese Aktion entfernt Ihren vorhandenen Clientschlüssel und alle zugehörigen Einstellungen. Diese Aktion kann nicht rückgängig gemacht werden.",
                    "error": "Fehler beim Löschen Ihres Client-Schlüssels.",
                    "success": "Ihr Projekt wurde gelöscht."
                }
            },
            "tokenRedirect": {
                "title": "Token-Umleitungs-URLs",
                "description": "Token-Umleitungs-URLs sind die Endpunkte, an die nach Abschluss der Authentifizierung Zugriffstoken gesendet werden. Mit diesen URLs kann Ihre Anwendung sicher Token empfangen, die für den Zugriff auf Benutzerdaten und -dienste erforderlich sind."
            },
            "authRedirect": {
                "title": "Autorisierungscode-Umleitungs-URLs",
                "description": "Die AuthCode-Umleitungs-URL ist der Endpunkt, an den Autorisierungscodes gesendet werden, nachdem ein Benutzer Ihrer Anwendung die Berechtigung erteilt hat. Diese URL ist in OAuth-Flows von entscheidender Bedeutung, da sie die sichere Übertragung des Autorisierungscodes vom Autorisierungsserver an Ihre App gewährleistet und es Ihnen ermöglicht, Zugriffstoken im Namen des Benutzers anzufordern."
            },
            "scopes": {
                "title": "Bereiche",
                "configure": "Bereiche definieren",
                "titleLong": "API-Berechtigungsbereiche",
                "description": "Bereiche definieren die Berechtigungen, die dieser Autorisierungsclient haben wird. Legen Sie Bereiche fest, um den Zugriff auf bestimmte Daten und Funktionen zu beschränken und sicherzustellen, dass Benutzer nur den Zugriff erhalten, den sie benötigen.",
                "manage": "Verwalten von Autorisierungsbereichen"
            },
            "type": {
                "title": "Implementierungstyp"
            },
            "deviceScopes": {
                "title": "Zugehörige Gerätetypen",
                "titleLong": "Erlaubte Gerätetypen",
                "configure": "Zulässige Gerätetypen konfigurieren",
                "action": "Neuen Gerätetyp hinzufügen",
                "descriptionShort": "Definieren Sie, welche Gerätetypen auf dieses Projekt zugreifen können.",
                "titles": "Zugehörige Gerätetypen",
                "description": "Der Gerätetyp definiert die Berechtigungen und Zugriffsebenen, die ein Gerät innerhalb Ihrer Anwendung hat. Durch die Zuweisung bestimmter Gerätetypen können Sie die Aktionen und Daten steuern, auf die jedes Gerät zugreifen kann. So stellen Sie sicher, dass Ihre Anwendung sicher bleibt und Ihren Datenschutzrichtlinien entspricht."
            },
            "deviceType": {
                "title": "Gerätetypen",
                "description": "Ein DeviceType definiert eine Gerätekategorie und beschreibt detailliert ihre Eingabe-/Ausgabefunktionen und unterstützten Funktionen (z. B. Sprache, Gesten, Controllertypen). Es stellt sicher, dass nur autorisierte Geräte mit einer Anwendung interagieren können.",
                "action": "Gerätetyp erstellen",
                "name": "Gerätetypname",
                "descriptionLong": "Gerätetyp Beschreibung",
                "features": {
                    "title": "Unterstützt Funktionen",
                    "description": "Definieren Sie die Ein- und Ausgaben, die Ihre App unterstützt. Dies hilft uns, das Benutzererlebnis auf Cephable zu optimieren.",
                    "supportsVoiceInput": "Spracheingabe",
                    "supportsPhysicalInput": "Physischer Eingang",
                    "supportsKeyboardOutput": "Tastaturausgabe",
                    "supportsPlayStationControllerOutput": "PlayStation-Controller",
                    "supportsFaceInput": "Gesichtseingabe",
                    "supportsGestureInput": "Gesteneingabe",
                    "supportsXboxControllerOutput": "Xbox-Controller",
                    "supportsDigitalExtensions": "Digitale Erweiterungen",
                    "supportsPhysicalExtensions": "Physische Erweiterungen",
                    "supportsNintendoControllerOutput": "Nintendo-Controller",
                    "supportsGenericControllerOutput": "Allgemeiner Controller-Ausgang"
                },
                "canAutoStart": {
                    "title": "Unterstützt automatische Steuerungsstarts",
                    "description": "[canAutoStart] Wenn aktiviert, überprüfen SDKs die Benutzereinstellungen und versuchen, die Kamera- oder Mikrofonsteuerung sofort nach der Benutzeranmeldung zu starten."
                },
                "isSupported": {
                    "title": "Aktiv",
                    "description": "[isSupported] Wenn deaktiviert, sendet, empfängt oder bestätigt Cephable keine damit verbundenen Benutzergeräte mehr. Entspricht veraltet."
                },
                "locale": {
                    "title": "Standardsprache",
                    "description": "[defaultLocale] Das Standardgebietsschema für diesen Gerätetyp. Dies wird als Standardsprache für das Gerät verwendet.",
                    "support": "Unterstützt Sprachen",
                    "warn": "** Es sieht so aus, als ob Sie benutzerdefinierte Steuerelemente eingerichtet haben. Bitte stellen Sie sicher, dass Sie die benutzerdefinierten Steuerelemente für die zugehörigen Sprachen aktualisiert haben.**",
                    "name": "{{lang}} – Gerätetypname",
                    "langDescription": "{{lang}} - Beschreibung"
                },
                "customControls": {
                    "title": "Benutzerdefinierte Steuerelemente",
                    "object": "{{lang}} – Benutzerdefiniertes Steuerelementobjekt",
                    "description": "Benutzerdefinierte Steuerelemente sind eine erweiterte Option, mit der Benutzer die mit diesem Gerät verknüpften App-Steuerelemente manuell einrichten und bearbeiten können. Wenn Sie möchten, dass Benutzer Ihr Gerät direkt von Cephable aus steuern, müssen Sie Ihre Gerätesteuerelemente hier registrieren. Ausführliche Informationen zu den Optionen finden Sie in der Cephable-API.",
                    "addControl": "Steuerelement hinzufügen",
                    "empty": "Noch keine benutzerdefinierten Steuerelemente vorhanden. Verwenden Sie „Steuerelement hinzufügen“, um Ihr erstes zu erstellen.",
                    "untitled": "Unbenanntes Steuerelement",
                    "controlId": "Kontroll-ID",
                    "controlIdHelp": "Dieses Steuerelement hat eine eindeutige Kennung. Diese muss vor dem Speichern festgelegt werden – sie kann später nicht mehr geändert werden.",
                    "fallback": "Zurückgreifen",
                    "controlName": "Steuerelementname",
                    "controlDescription": "Steuerungsbeschreibung",
                    "defaultCommandsLabel": "Standard-Sprachbefehle",
                    "defaultCommandsHelp": "Dies sind die standardmäßigen Sprachauslöser, die Benutzern für dieses Steuerelement in der aktuellen Sprache angezeigt werden.",
                    "sharedAcrossLanguages": "Wird in allen Sprachen geteilt",
                    "sharedAcrossLanguagesHelp": "Durch die Bearbeitung dieser Felder wird der Wert für alle Sprachen gleichzeitig aktualisiert.",
                    "iconUrl": "Symbol-URL",
                    "contextGroupName": "Kontextgruppe",
                    "isProfileControl": "Profilsteuerung",
                    "isPrefixVoiceCommand": "Präfix-Sprachbefehl",
                    "allowWhenDictating": "Beim Diktieren zulassen",
                    "allowsHold": "Ermöglicht Halten",
                    "isDeprecated": "Veraltet",
                    "requiresEmployeeAccess": "Erfordert Mitarbeiterzugriff",
                    "requiresStudentAccess": "Erfordert Zugang für Studierende",
                    "requiresGenericLicense": "Erfordert eine generische Lizenz",
                    "requiresPlusAccess": "Erfordert Plus-Zugang",
                    "allIncomplete": "Alle Gebietsschemas verfügen über unvollständige benutzerdefinierte Steuerelemente. Bitte vervollständigen Sie mindestens ein Gebietsschema, bevor Sie speichern.",
                    "savedWithIncomplete": "Gespeichert. Unvollständige benutzerdefinierte Steuerelement-Gebietsschemas wurden nicht gespeichert: {{incompleteLocales}}"
                },
                "success": {
                    "title": "Erfolg!",
                    "description": "Sie haben einen neuen Gerätetyp erstellt. {{name}} Sie können jetzt den Umfang Ihres Autorisierungsclientgeräts nach Bedarf aktualisieren."
                },
                "id": "Gerätetyp-ID",
                "throttleRules": {
                    "title": "Regeln für die Gassteuerung",
                    "description": "Konfigurieren Sie Drosselungsregeln, um den Befehlsfluss und die Eingabebeschränkungen für diesen Gerätetyp zu steuern.",
                    "disableVoiceInput": "Spracheingabe deaktivieren",
                    "disableHotkeyInput": "Hotkey-Eingabe deaktivieren",
                    "disableCameraInput": "Kameraeingang deaktivieren",
                    "disableMultiInputs": "Mehrere Eingänge deaktivieren",
                    "maximumCommandsPerSecond": "Maximale Befehle pro Sekunde",
                    "maximumCommandsPerMinute": "Maximale Befehle pro Minute",
                    "maximumMacroLength": "Maximale Makrolänge",
                    "jitter": {
                        "title": "Timing-Jitter",
                        "description": "Um natürlichere Eingabemuster zu erzeugen, sollten Halte- und Pausenzeiten durch zufällige Variationen ergänzt werden.",
                        "holdTimeJitterMin": "Haltezeitjitter Min (ms)",
                        "holdTimeJitterMax": "Maximaler Haltezeitjitter (ms)",
                        "pauseTimeJitterMin": "Pausenzeit-Jitter Min (ms)",
                        "pauseTimeJitterMax": "Maximaler Pausenzeit-Jitter (ms)"
                    },
                    "incompatibleActions": {
                        "title": "Inkompatible Aktionsgruppen",
                        "description": "Definiere Aktionsgruppen, die nicht im selben Makro gleichzeitig existieren können.",
                        "addGroup": "Gruppe hinzufügen",
                        "removeGroup": "Gruppe entfernen",
                        "addAction": "Aktion hinzufügen",
                        "removeAction": "Aktion entfernen",
                        "reason": "Grund",
                        "reasonPlaceholder": "Warum diese Aktionen unvereinbar sind",
                        "eventType": "Ereignistyp",
                        "key": "Schlüssel",
                        "customActionId": "Benutzerdefinierte Aktions-ID",
                        "emptyGroup": "In dieser Gruppe sind keine Aktionen vorhanden. Fügen Sie mindestens zwei Aktionen hinzu."
                    },
                    "requiredPause": {
                        "title": "Erforderliche Pause zwischen den Aktionen",
                        "description": "Definiere in demselben Makro Paare von Aktionen, zwischen denen eine minimale Pause erforderlich ist.",
                        "addRule": "Regel hinzufügen",
                        "removeRule": "Regel entfernen",
                        "actionA": "Aktion A",
                        "actionB": "Aktion B",
                        "minimumPause": "Minimale Pause (ms)",
                        "bidirectional": "Bidirektional",
                        "bidirectionalHelp": "Wenn diese Option aktiviert ist, ist die Pause in beide Richtungen (A→B und B→A) erforderlich."
                    },
                    "macroStepRules": {
                        "title": "Makro-Schrittregeln",
                        "holdTimeJitterMin": "Haltejitter Min (ms)",
                        "holdTimeJitterMax": "Maximaler Haltejitter (ms)"
                    }
                }
            },
            "originHost": {
                "title": "Ursprungshost",
                "description": "Die URL, die bei API-Interaktionen als primäre Quelle für Anfragen und Daten dient."
            },
            "orgTitle": "Projekte von {{value}}"
        },
        "viewOrganization": "Organisation Anzeigen",
        "update": "Ihre Organisation wurde aktualisiert! Die App wird aktualisiert.",
        "error": "Fehler beim Laden der Organisation. Bitte versuchen Sie es später erneut.",
        "new": {
            "name": {
                "label": "Name der Organisation",
                "placeholder": "Geben Sie den Namen Ihrer Organisation ein"
            },
            "description": {
                "label": "Beschreibung der Organisation",
                "placeholder": "Was sind Ihre Ziele mit der Verwendung von Cephable Professional?"
            },
            "details": "Details zur Organisation"
        },
        "expired": {
            "user": "Ihre Cephable-Lizenz ist anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version herabgestuft. Um Ihre Lizenz zu verlängern, wenden Sie sich bitte an Ihren Organisationsadministrator.",
            "admin": "Ihre Cephable-Lizenz ist anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zurückgestuft. Bitte verlängern Sie Ihre Lizenz, um weiterhin die erweiterten Funktionen nutzen zu können.",
            "multiple": "Ihre Cephable-Lizenzen sind anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zurückgestuft. Bitte verlängern Sie mindestens eine Ihrer Lizenzen, um weiterhin die erweiterten Funktionen über Cephable Basic hinaus nutzen zu können.",
            "dialog": {
                "title": "Wählen Sie eine Organisation aus",
                "description": "Ihrem Konto sind mehrere Organisationen zugeordnet. Wählen Sie bitte die Organisation aus, deren Abonnement Sie verlängern möchten."
            },
            "title": "Ihre Cephable-Lizenz ist abgelaufen",
            "titlePlural": "Ihre Cephable-Lizenzen sind abgelaufen",
            "banner": "Ihre Cephable-Lizenz ist abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zurückgestuft. Mit einer Verlängerung erhalten Sie Zugriff auf Funktionen wie erweiterte Sprachsteuerung, KI-gestützte Aufgaben und viele vordefinierte App-Steuerelemente."
        },
        "orgName": "Name der Organisation",
        "menu": {
            "title": "Organisationsmenü",
            "view": "Menü anzeigen",
            "expand": "Menü erweitern"
        },
        "settings": {
            "title": "Organisationseinstellungen",
            "description": "Verwalten Sie die Abrechnung, den Namen, die Beschreibung und die Ressourcen Ihrer Organisation.",
            "view": "Einstellungen anzeigen",
            "general": {
                "title": "Allgemein"
            },
            "resources": {
                "edit": "Ressourcen bearbeiten",
                "description": "Verwenden Sie den Markdown-Editor auf der linken Seite, um hilfreiche Ressourcen für alle Mitglieder der Organisation zu aktualisieren und zu formatieren. Während Sie tippen, zeigt die Vorschau auf der rechten Seite, wie Ihr Inhalt den Benutzern angezeigt wird. Sie können Überschriften, Listen, Links und andere Formatierungselemente mit Markdown-Syntax hinzufügen. Änderungen sind für Mitglieder sichtbar, sobald sie gespeichert wurden."
            },
            "other": {
                "title": "Andere Einstellungen",
                "description": "Verwalten Sie die Abrechnung, den Namen, die Beschreibung und die Ressourcen Ihrer Organisation."
            }
        },
        "managed": {
            "title": "Verwaltete Organisation",
            "titlePlural": "Verwaltete Organisationen",
            "description": "Verwaltete Organisationen sind Organisationen, die von einem Cephable-Wiederverkäufer verwaltet werden. Wiederverkäufer können hier Ihr Team, Teamprofile, Abrechnung und mehr verwalten.",
            "error": "Fehler beim Laden verwalteter Organisationen.",
            "empty": {
                "title": "Keine verwalteten Organisationen gefunden.",
                "description": "Es sieht nicht so aus, als ob es verwaltete Organisationen gibt, die diesen Kriterien entsprechen. Oder Ihre Lizenzschlüssel wurden noch nicht aktiviert."
            },
            "titleShort": "Verwaltet"
        },
        "canManageChildOrganizations": {
            "title": "Untergeordnete Organisationen verwalten",
            "description": "Benutzer mit dieser Berechtigung können als Administrator untergeordnete Organisationen erstellen und verwalten."
        },
        "canViewAnalytics": {
            "title": "Analytics anzeigen",
            "description": "Benutzer mit dieser Berechtigung können die Metriken und Analysen für die Organisation anzeigen."
        },
        "create": "Neue Organisation erstellen",
        "orgCustomBillingUrl": {
            "title": "Benutzerdefinierte Abrechnungs-URL",
            "description": "Dies ist eine benutzerdefinierte URL, die verwendet wird, um den Benutzer zu Ihrem (dem Abrechnungssystem des Wiederverkäufers) umzuleiten. Sollte mit „https://“ oder „mailTo:“ beginnen."
        },
        "upgrade": {
            "existing": {
                "title": "Sie sind Teil einer bestehenden Lizenz.",
                "description": "Bitte führen Sie ein Upgrade durch, indem Sie im Seitenmenü auf „{{action}}“ klicken."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "Generative KI deaktiviert",
                "description": "Ihre Organisation hat den Zugriff auf Generative AI-Funktionen deaktiviert. Weitere Informationen erhalten Sie von Ihrem Organisationsadministrator."
            },
            "isRemoteControlDisabled": {
                "title": "Geräteübergreifende Synchronisierung deaktiviert",
                "description": "Ihre Organisation hat den Zugriff auf die Synchronisierung deaktiviert. Sie können unsere Begleit-App nicht verwenden und keine externen Geräte steuern. Weitere Informationen erhalten Sie von Ihrem Organisationsadministrator."
            }
        },
        "troubleshooting": {
            "title": "Fehlerbehebung",
            "editorDescription": "[Optional] Dieser Abschnitt ist für alle Benutzer über die Seite mit den Verbindungsdetails sowohl in der mobilen als auch in der Desktop-App von Cephable sichtbar.",
            "description": "Falls Sie Probleme mit Cephable haben, versuchen Sie die folgenden Schritte, um häufig auftretende Probleme zu beheben."
        },
        "onboarding": {
            "title": "Onboarding",
            "editorDescription": "[Optional] Nutzern wird ein Onboarding-Fenster angezeigt, wenn dieser Gerätetyp ihrem Konto hinzugefügt wird. Hier können Sie Anweisungen zur Einrichtung und Verwendung des Gerätetyps mit Ihrer Anwendung bereitstellen."
        },
        "documents": "Unterlagen",
        "completionStatus": {
            "title": "Abschlussstatus",
            "error": "",
            "complete": "Vollständig.",
            "incomplete": "Unvollständig."
        },
        "metadata": {
            "title": "Metadaten",
            "urlError": "Die URL muss mit http:// oder https:// beginnen.",
            "metatitle": {
                "label": "Meta-Titel",
                "placeholder": "Geben Sie einen Kurztitel ein"
            },
            "shortDescription": {
                "label": "Kurzbeschreibung",
                "placeholder": "Geben Sie eine kurze Vorschaubeschreibung ein (maximal 150 Zeichen)."
            },
            "externalLink": {
                "label": "Externer Link",
                "placeholder": "https://example.com/device-info",
                "description": "Ein direkter Link zu einer externen Website oder Ressource mit weiteren Informationen zur Ersteinrichtung dieses Geräts. Wenn Sie diesen Link verwenden, verzichten wir auf die Verwendung des Markdown-Formats für die Kundenliste."
            },
            "iconUrl": {
                "label": "URL des Gerätesymbols",
                "placeholder": "https://example.com/device-icon.png",
                "description": "Ein direkter Link zu einem Bild, das diesen Gerätetyp darstellt. Dieses Symbol wird in der Cephable-App und in Gerätelisten angezeigt."
            },
            "darkModeIconUrl": {
                "label": "URL des Symbols für Geräte im Dunkelmodus",
                "placeholder": "https://example.com/device-icon-dark.png",
                "description": "Ein direkter Link zu einem Bild, das diesen Gerätetyp im Dunkelmodus darstellt. Dieses Symbol wird in der Cephable-App und in Gerätelisten angezeigt, wenn der Nutzer den Dunkelmodus aktiviert hat."
            },
            "editorDescription": "Wenn Ihr Gerät in der Cephable-App als Erweiterung oder Verbindung ausgewählt wird, verwenden wir diese Informationen, um sie Benutzern anzuzeigen, die neue Verbindungen einrichten."
        },
        "client-listing": {
            "title": "Kundenliste",
            "editorDescription": "Detaillierte Anweisungen für neue Benutzer zum Einrichten von Verbindungen mit diesem Gerätetyp. Dieser Markdown-Inhalt wird in der Cephable-App angezeigt, wenn Benutzer eine neue Verbindung hinzufügen."
        },
        "canAccessOrganizationProfiles": {
            "title": "Steuerelemente der Organisations-App anzeigen",
            "description": "Benutzer mit dieser Berechtigung können die mit dieser Organisation verknüpften Organisations-App-Steuerelemente anzeigen."
        },
        "canEditOrganizationProfiles": {
            "title": "Verwaltung der App-Steuerelemente der Organisation",
            "description": "Benutzer mit dieser Berechtigung können Organisations-App-Steuerelemente erstellen, bearbeiten und löschen, die dieser Organisation zugeordnet sind."
        },
        "profiles": {
            "title": "Steuerelemente der Organisations-App",
            "description": "Organisations-App-Steuerelemente sind gemeinsam genutzte Profile, mit denen Sie App-Steuerelemente innerhalb Ihrer Organisation verteilen oder mit Ihren Integrationsbenutzern teilen können.",
            "view": "Steuerelemente der Organisations-App anzeigen",
            "editDescription": "Bearbeiten Sie die Steuerelemente der Organisations-App, um die Einstellungen anzupassen.",
            "empty": "Es wurden keine Steuerelemente für Organisations-Apps gefunden. Erstellen Sie eine, um loszulegen.",
            "error": "Fehler beim Laden der Steuerelemente der Organisations-App.",
            "titleShort": "App-Steuerelemente"
        },
        "canViewAuthClients": {
            "title": "Projekte ansehen",
            "description": "Benutzer mit dieser Berechtigung können Authentifizierungsclients und Projekte für die Organisation anzeigen."
        },
        "governance": {
            "title": "Governance",
            "orgTitle": "{{value}} Governance",
            "description": "Legen Sie die Leitplanken fest, die Ihr Team bei der Nutzung des Cephable-Assistenten unterstützen.",
            "automation": {
                "title": "Automatisierungsregeln",
                "description": "Legen Sie fest, wo Cephable Prozesse automatisieren kann und geben Sie Anweisungen, die sein Verhalten für Ihre Organisation prägen.",
                "rulesTitle": "Regeln",
                "create": "Automatisierungsregel erstellen",
                "edit": "Automatisierungsregel bearbeiten",
                "created": "Automatisierungsregel erstellt.",
                "updated": "Automatisierungsregel aktualisiert.",
                "deleted": "Automatisierungsregel gelöscht.",
                "loadError": "Automatisierungsregeln konnten nicht geladen werden.",
                "saveError": "Die Automatisierungsregel konnte nicht gespeichert werden.",
                "deleteError": "Die Automatisierungsregel konnte nicht gelöscht werden.",
                "searchPlaceholder": "Suchregeln nach App, Website, Eingabeaufforderung oder Geltungsbereich",
                "promptOnly": "Assistentenunterricht",
                "editorDescription": "Wählen Sie den Regeltyp aus, geben Sie optional eine App oder Website als Ziel an und fügen Sie klare Anweisungen für Cephable hinzu.",
                "validation": "Fügen Sie eine App oder Website, Anweisungen für den Assistenten oder beides hinzu.",
                "appOrDomain": {
                    "label": "App oder Website",
                    "helper": "Verwenden Sie einen wiedererkennbaren App-Namen oder eine Domain, wie zum Beispiel Slack, gmail.com oder github.com."
                },
                "prompt": {
                    "label": "Anweisungen für den Assistenten",
                    "helper": "Beschreiben Sie, was Cephable tun sollte oder nicht. Die Anweisungen sollten präzise und umsetzbar sein."
                },
                "type": {
                    "label": "Regeltyp",
                    "block": "Block",
                    "allow": "Erlauben"
                },
                "scope": {
                    "organization": "Organisationsweit",
                    "organizationDescription": "Diese Regel gilt für alle aktuellen und zukünftigen Mitglieder.",
                    "members": "Bestimmte Mitglieder",
                    "membersDescription": "Speichern Sie die Regel und weisen Sie sie dann nur den Mitgliedern zu, die sie benötigen."
                },
                "assign": "Mitglieder zuweisen",
                "delete": {
                    "title": "Automatisierungsregel löschen?",
                    "description": "Damit wird die Regel und alle darauf basierenden Mitgliederzuweisungen endgültig entfernt."
                },
                "empty": {
                    "title": "Noch keine Automatisierungsregeln",
                    "description": "Erstellen Sie eine Regel, um die erste Leitlinie für Assistenzkräfte in Ihrer Organisation festzulegen."
                },
                "guidance": {
                    "block": {
                        "title": "Beschränken Sie Apps und Websites",
                        "description": "Verwenden Sie eine Blockregel mit einem App-Namen oder einer Domain, um zu verhindern, dass Cephable mit der App interagiert."
                    },
                    "prompt": {
                        "title": "Assistentenkontext hinzufügen",
                        "description": "Nutzen Sie die Anweisungen Ihrer Assistenten, um Richtlinien, erforderliche Kontrollen oder sichere Arbeitsweisen zu kommunizieren."
                    },
                    "scope": {
                        "title": "Wählen Sie das richtige Zielfernrohr",
                        "description": "Entweder sollten unternehmensweit gemeinsame Leitplanken gelten oder Ausnahmen auf ausgewählte Mitglieder beschränkt bleiben."
                    }
                },
                "assignment": {
                    "title": "Eine Regel einem Mitglied zuweisen",
                    "description": "Verwalten Sie die mitgliederspezifische Zuordnung für {{value}}.",
                    "memberLabel": "Mitglied",
                    "apply": "Regel anwenden",
                    "remove": "Regel entfernen",
                    "assigned": "Diese Regel wird dem ausgewählten Mitglied zugewiesen.",
                    "notAssigned": "Diese Regel ist dem ausgewählten Mitglied nicht zugewiesen.",
                    "applied": "Die Regel gilt für das Mitglied.",
                    "removed": "Regel für Mitglied entfernt.",
                    "loadError": "Organisationsmitglieder konnten nicht geladen werden.",
                    "statusError": "Die Automatisierungsregeln dieses Mitglieds konnten nicht geladen werden.",
                    "saveError": "Die Mitgliederzuordnung konnte nicht aktualisiert werden."
                }
            },
            "moreControls": {
                "title": "Weitere Kontrollmechanismen sind im Anmarsch.",
                "description": "Diese zentrale Plattform wird um Steuerelemente für die Funktionen erweitert, die Ihr Team nutzen kann, und die Anbieter, mit denen es sich verbinden kann.",
                "skills": "Fähigkeiten",
                "mcp": "MCP-Tools",
                "ai": "Bringen Sie Ihre eigene KI mit."
            }
        },
        "canManageGlobalAutomationRules": {
            "title": "Governance managen",
            "description": "Benutzer mit dieser Berechtigung können Organisationsautomatisierungsregeln und Mitgliederzuweisungen verwalten."
        }
    },
    "developer": {
        "title": "Entwickler",
        "titleLong": "Entwicklerressourcen",
        "description": "Cephable kann mit unseren SDKs direkt in Ihre App, Ihr Spiel oder Ihren Dienst integriert werden.",
        "sdk": {
            "title": "Entdecken Sie unsere SDKs",
            "description": "Wir bieten erstklassige SDKs, die Spracherkennung und adaptive Steuerungen nahtlos in Ihre Anwendungen integrieren. Unsere Tools sind darauf ausgelegt, die Benutzerinteraktion durch intuitive Steuerungen zu verbessern und die Zugänglichkeit zu fördern, sodass Ihre Software von allen Benutzern effektiver bedient werden kann.",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "Netz",
                "description": "Integrieren Sie Sprach- und adaptive Steuerelemente direkt in Ihre Webanwendungen.",
                "action": "NPM-Paket abrufen"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Windows-Anwendungen",
                "description": "Nutzen Sie die Leistungsfähigkeit von .NET, um mit unseren WPF- und WinUI3-SDKs Anwendungen zu erstellen.",
                "actionCore": "Holen Sie sich das Core-Paket",
                "actionWpf": "WPF-Paket Abrufen"
            },
            "android": {
                "title": "Android",
                "subtitle": "Mobile Geräte",
                "description": "Android-Anwendungen zur Unterstützung von Sprach- und Kopfbewegungsfunktionen.",
                "action": "Android SDK holen"
            },
            "more": {
                "title": "Mehr",
                "description": "Sie finden nicht, was Sie brauchen? Kontaktieren Sie uns und wir helfen Ihnen.",
                "action": "Fordern Sie ein SDK an"
            },
            "docs": {
                "title": "Dokumentation",
                "description": "Entdecken Sie die detaillierte Dokumentation, Beispielprojekte und Anleitungen, um mit Cephable loszulegen.",
                "action": "Dokumente ansehen"
            }
        },
        "demo": {
            "title": "Demos",
            "titleLong": "Erleben Sie unsere SDKs in Aktion",
            "description": "Entdecken Sie die Leistungsfähigkeit unserer Technologien zur Sprach- und Kopfbewegungssteuerung anhand unserer Beispielanwendungen. Von interaktiven Spielen bis hin zu dynamischen Web- und Mobil-Apps demonstriert jedes Beispiel die Vielseitigkeit und Effektivität unserer SDKs. Sehen Sie sich diese Beispiele an, um Erkenntnisse und Inspirationen für die Integration verbesserter Zugänglichkeit und immersiver Erlebnisse in Ihre eigenen Projekte zu gewinnen.",
            "game": {
                "title": "2048 Spiel",
                "subtitle": "Netz",
                "description": "Verbessern Sie das traditionelle Gameplay mit adaptiver Sprach- und Kopfbewegungssteuerung.",
                "action": "Spielen Sie das Spiel"
            },
            "unity": {
                "title": "Einheit",
                "subtitle": "Spieleentwicklung",
                "description": "Erfahren Sie, wie adaptive Steuerelemente beim Spielen genutzt werden können, um eine ansprechendere UX bereitzustellen.",
                "action": "Beispiel abrufen"
            },
            "samples": "Dokumente und Beispiele",
            "other": {
                "title": "Andere Demos",
                "description": "Erleben Sie aus erster Hand, wie Cephable Ihre Anwendung, Ihr Spiel oder Ihr Gerät verbessern kann.",
                "action": "Weitere Demos anzeigen"
            },
            "web": {
                "title": "Web-SDK-Beispiele",
                "subtitle": "Netz",
                "description": "Unkomplizierte Integration aller unserer Kernfunktionen in Webanwendungen.",
                "action": "Erleben Sie das SDK"
            },
            "docs": {
                "title": "Entwicklerdokumentation und Beispiele",
                "description": "Entdecken Sie die detaillierte Dokumentation, Beispielprojekte und Anleitungen, um mit Cephable loszulegen.",
                "action": "Dokumente ansehen"
            }
        },
        "other": {
            "title": "Andere Ressourcen",
            "description": "Wenn Sie in unseren SDKs nicht finden, was Sie brauchen, versuchen Sie, direkt mit unseren APIs zu arbeiten, oder wenden Sie sich für Hilfe, Inspiration und Unterstützung an die Community.",
            "api": {
                "title": "API",
                "description": "Unsere APIs ermöglichen Ihnen die direkte Interaktion mit Cephable. Sie können unsere APIs verwenden, um benutzerdefinierte Integrationen zu erstellen."
            },
            "support": {
                "title": "Unterstützung",
                "description": "Sie finden nicht, was Sie brauchen? Kontaktieren Sie unsere Community über Discord.",
                "action": "Treten Sie Discord bei"
            }
        }
    },
    "customControls": {
        "title": "Globale und Gerätesteuerung",
        "prefixDisclaimer": "Dies ist eine Präfixsteuerung. Sie überwacht die Wörter nach dem Befehl und sucht dann in der folgenden Phrase nach Übereinstimmungen.",
        "allowPausedDisclaimer": "Diese Steuerung funktioniert auch, wenn das Mikrofon angehalten ist.",
        "resetControls": {
            "title": "Steuerelemente zurücksetzen",
            "description": "Ihre Sprachsprache hat sich seit der letzten Aktualisierung Ihrer Steuerung geändert. Hinweis: Dadurch werden Ihre Steuerelemente auf {{language}} zurückgesetzt und Sie verlieren möglicherweise alle benutzerdefinierten Befehle. Möchten Sie wirklich zurücksetzen?",
            "confirm": "Ja, Bedienelemente zurücksetzen",
            "error": "Beim Zurücksetzen Ihrer Steuerung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
        },
        "conflictIndicators": {
            "warn": "Achtung:",
            "title": "Eingabekonfigurationskonflikte erkannt",
            "globalControls": "Konflikte bei der globalen Steuerungskonfiguration",
            "deviceControls": "Konfigurationskonflikte bei der Gerätesteuerung",
            "usedInput": "dient als Input für",
            "description": "Einige der Eingaben für Ihre globalen und Gerätesteuerungen werden auch in einer oder mehreren Ihrer App-Steuerungen verwendet. Dies kann bei der Verwendung von Cephable zu Konflikten führen. In diesem Fall geben wir der App-Steuerung stets den Vorzug vor der globalen oder Gerätesteuerung.",
            "item": "Die Eingabe <strong>{{value}}</strong> wird in Ihren App-Steuerelementen verwendet: ",
            "globalDescription": "Die folgenden globalen Steuerelemente weisen Eingabekonflikte mit den Steuerelementen Ihrer App auf.",
            "deviceDescription": "Bei den folgenden Gerätesteuerungen treten Eingabekonflikte mit Ihren App-Steuerelementen auf."
        },
        "globalControls": {
            "title": "Globale Steuerelemente",
            "empty": "Sie haben noch keine globalen Steuerelemente. Klicken Sie unten, um eines zu erstellen.",
            "edit": "Globale Steuerelemente bearbeiten",
            "description": "Globale Steuerelemente sind immer verfügbar, unabhängig von der verwendeten App oder dem verwendeten Gerät. Einige funktionieren sogar, wenn die Mikrofon- oder Kamerasteuerung pausiert ist."
        },
        "deviceControls": {
            "title": "Gerätesteuerung",
            "empty": "Sie haben noch keine Gerätesteuerung. Klicken Sie unten, um eine zu erstellen.",
            "edit": "Gerätesteuerung bearbeiten",
            "controls": {
                "cephable-open-app": {
                    "success": "App öffnen: {{value}}",
                    "error": "App nicht gefunden: {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["schließen"],
                    "name": "App nach Namen schließen",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um eine App auf Ihrem Computer über ihren Namen zu schließen.",
                    "success": "App schließen: {{value}}",
                    "error": "App nicht gefunden: {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimieren"],
                    "name": "Minimieren Sie die aktuell fokussierte App.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu minimieren.",
                    "success": "Minimieren Sie den Erfolg fokussierter Apps!",
                    "error": "Fehler beim Minimieren der fokussierten App."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["maximieren"],
                    "name": "Maximieren Sie die aktuell fokussierte App.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu maximieren.",
                    "success": "Maximieren Sie den gezielten App-Erfolg!",
                    "error": "Fehler beim Minimieren der fokussierten App."
                },
                "cephable-generate-text": {
                    "commands": ["erzeugen"],
                    "name": "Generieren Sie Text, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um entsprechenden Text zu generieren."
                },
                "cephable-stop-generate-text": {
                    "commands": [
                        "Stoppen Sie die Generierung",
                        "Generierung stoppen",
                        "Abbrechen Generieren",
                        "Generierung abbrechen"
                    ],
                    "name": "Stoppen Sie die Textgenerierung.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um die Textgenerierung zu stoppen"
                },
                "cephable-open-panel": {
                    "commands": ["Panel anzeigen"],
                    "name": "Öffnen Sie das Cephable-Bedienfeld",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um das Cephable-Bedienfeld zu öffnen."
                },
                "cephable-close-panel": {
                    "commands": ["Bedienfeld ausblenden"],
                    "name": "Verstecken Sie das Cephable-Panel",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um das Cephable-Bedienfeld auszublenden oder zu minimieren."
                },
                "cephable-close-focused-app": {
                    "commands": ["Strom schließen"],
                    "name": "Schließen Sie die aktuell fokussierte App.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu schließen.",
                    "success": "Aktuelle App erfolgreich geschlossen!",
                    "error": "Fehler beim Schließen der aktuellen App."
                },
                "cephable-rewrite-text": {
                    "commands": ["umschreiben"],
                    "name": "Schreiben Sie den Text neu, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell markierten Text neu zu schreiben."
                },
                "cephable-summarize-text": {
                    "commands": ["zusammenfassen"],
                    "name": "Fassen Sie den Text zusammen, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell hervorgehobenen Text zusammenzufassen."
                },
                "cephable-translate-text": {
                    "commands": ["übersetzen"],
                    "name": "Übersetzen Sie Text, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell markierten Text zu übersetzen."
                },
                "cephable-click-by-name": {
                    "commands": ["klopfen", "Schlag", "Navigieren Sie zu", "gehe zu"],
                    "name": "Tippen Sie auf Element nach Name",
                    "description": "Tippen Sie auf ein Element auf der Seite anhand seines Namens, z. B. „Speichern“, um auf die Schaltfläche „Speichern“ zu klicken. Dies entspricht der Sprachsteuerung mit der Maus; Sie klicken also mit Sprachbefehlen anstatt mit der Maus."
                },
                "cephable-automate": {
                    "commands": [
                        "automatisieren",
                        "versuchen",
                        "haben cephable",
                        "einen Workflow durchführen",
                        "Arbeit an"
                    ],
                    "name": "Führen Sie einen KI-Workflow aus, indem Sie nach diesem Befehl eine Aufgabe beschreiben.",
                    "description": "Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von einer Aufgabe, wie z. B. „Automatisches Senden einer E-Mail an mein Team“, und Cephable führt diese als KI-Workflow aus."
                }
            },
            "description": "Gerätesteuerungen sind an das jeweilige Gerät oder die Verbindung gebunden, die Sie verwenden. Sie sind verfügbar, ohne dass Sie sie zu Ihren App-Steuerelementen hinzufügen müssen, und sind besonders nützlich für Funktionen oder Ereignisse, die nur auf bestimmten Geräten unterstützt werden."
        },
        "warn": "Das Mikrofon wurde nicht gestartet. Sie müssen Ihr Mikrofon starten, um globale Steuerelemente und Gerätesteuerungen verwenden zu können.",
        "changeProfile": {
            "success": "App-Steuerung ändern: {{value}}",
            "error": "App-Steuerelemente konnten nicht gefunden werden: „{{value}}“"
        },
        "descriptionShort": "Globale und Gerätesteuerungen sind stets verfügbare Aktionen, die für die Nutzung mit jeder Software konzipiert sind. Globale Steuerungen – wie „Kamera stoppen“ – sind systemweit und App-unabhängig, während Gerätesteuerungen auf die jeweilige Geräteverbindung zugeschnitten sind und erweiterte Funktionen als Standard-App-Steuerungen freischalten.",
        "description": "Globale und Gerätesteuerungen sind jederzeit verfügbare Aktionen, die für die Verwendung mit jeder Software konzipiert sind. Globale Steuerungen – wie „Kamera stoppen“ – gelten systemweit und App-unabhängig, während Gerätesteuerungen auf die jeweilige Geräteverbindung zugeschnitten sind und erweiterte Funktionen als Standard-App-Steuerungen freischalten. Diese Steuerungen werden derzeit per Sprachsteuerung aufgerufen, zukünftig werden wir jedoch auch andere Eingaben unterstützen.",
        "noDevice": "Dieser Schritt verwendet eine benutzerdefinierte Erweiterung, die Sie noch nicht für Ihr Konto konfiguriert haben. Fügen Sie die Erweiterung hinzu, um diesen Schritt freizuschalten."
    },
    "notifications": {
        "title": "Benachrichtigungen",
        "center": "Benachrichtigungscenter",
        "empty": "Sie haben derzeit keine Benachrichtigungen. Versuchen Sie es ein anderes Mal noch einmal.",
        "seen": "Gesehen",
        "markAsRead": "Als gelesen markieren",
        "view": "Alle {{value}}-Benachrichtigungen anzeigen"
    },
    "unsaved": {
        "title": "Sie haben nicht gespeicherte Änderungen.",
        "description": "Sie haben nicht gespeicherte Änderungen. Möchten Sie diese Seite wirklich verlassen?",
        "cancel": "Beenden ohne Speichern",
        "confirm": "Speichern und beenden"
    },
    "login": {
        "welcome": "Willkommen bei Cephable!",
        "subtitle": "Kontrollieren Sie Ihre Technologie nach <strong>Ihren</strong> Bedingungen.",
        "create": "Benutzerkonto erstellen",
        "signIn": "Anmelden",
        "loading": "Weiterleitung zur Anmeldung ...",
        "error": "Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Bitte melden Sie sich erneut an.",
        "existingAccount": "Hast du schon ein Konto?",
        "description": "Steuern. Erstellen. Automatisieren. Cephable – Ihre persönliche KI für schnelle Befehle, kontextbezogenes Erstellen von Entwürfen und vollautomatische Arbeitsabläufe. Keine Cloud-Verarbeitung. Nahtlose Unterstützung, die Sie überallhin begleitet."
    },
    "home": {
        "title": "Heim",
        "startControls": "Schalten Sie es ein!",
        "manage": "Konfigurieren",
        "profileGenerate": {
            "title": "Ups. Sieht so aus, als ob Sie noch keine App-Steuerelemente haben.",
            "description": "Damit Cephable Ihren Computer steuern kann, benötigen wir Informationen zu Ihren Steuerungswünschen. Sie können App-Steuerelemente von Grund auf neu erstellen oder sich von uns mit unserem Steuerelementgenerator bei der Erstellung unterstützen lassen."
        }
    },
    "wizard": {
        "description": "Cephable verwendet diese Informationen dann, um Steuerelemente zu generieren, die Sie überprüfen und ausprobieren können!",
        "includeDefaultKeysQuestion": "Standard-Sprachbefehle für Tasten und Mausklicks einschließen?",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Code usw.",
        "noOptionsText": "Beginnen Sie mit der Eingabe, um eine App zu finden, die Sie steuern möchten",
        "generate": "Steuerelemente generieren",
        "complete": {
            "title": "Okay, wir sind fertig!",
            "description": "Klicken Sie auf die Schaltfläche unten, um die von uns generierten Steuerelemente anzuzeigen. Sie können alle Aspekte manuell bearbeiten, hinzufügen oder entfernen, um sie für sich zu perfektionieren.",
            "viewControls": "Meine Bedienelemente anzeigen"
        },
        "error": {
            "emptyInput": "Bitte wählen Sie mindestens eine Eingabemethode aus",
            "emptyApp": "Bitte geben Sie mindestens einen App-Namen ein",
            "generatingProfile": "Fehler beim Generieren der App-Steuerelemente"
        },
        "loading": {
            "title": "Wir fügen alle Teile zusammen",
            "description": "Dies kann bis zu einer Minute dauern. Verlassen Sie diese Seite nicht und gehen Sie nicht zurück, sonst wird die Generierung gestoppt."
        },
        "selectedTips": {
            "title": "Tipp Nr. {{count}}",
            "previous": "Vorheriger Tipp",
            "next": "Nächster Tipp",
            "two": "Sie können die Empfindlichkeit Ihrer Eingaben im Abschnitt „Einstellungen für Ausdruckssteuerung“ des Hauptfensters steuern. Auf diese Weise können Sie die Art und Weise, wie Cephable Ihre Eingaben interpretiert, weiter verfeinern. Und Cephable wird mit der Zeit immer besser, da es mit Ihnen zusammenarbeitet!",
            "three": "Nachdem wir dies eingerichtet haben, haben Sie immer noch die vollständige Kontrolle über die Konfiguration. Wir geben Ihnen eine Basislinie, aber Sie können jederzeit die Zuordnung zwischen dem, was Sie tun, und dem, was auf dem Computer geschieht, ändern.",
            "four": "Sie können Ihre Steuerelemente ausdrucken, um eine physische Kopie zu haben, während Sie Cephable verwenden. Wir wissen, dass das alles neu ist und etwas Eingewöhnungszeit erfordert. Übung macht den Meister!",
            "one": "Wussten Sie, dass Sie Cephable auf einem Gerät verwenden können, um ein anderes zu steuern? Laden Sie Cephable auf Ihr Handy, Tablet oder sogar einen anderen Computer herunter und wählen Sie die Verbindung aus, die Sie steuern möchten (vielleicht diese hier). Ihre persönlichen Profile und Eingabeprofile sind auf allen Geräten konsistent! Stellen Sie einfach sicher, dass Cephable auf Ihrem Gerät und Ihren Verbindungen läuft."
        },
        "steps": {
            "one": "Schritt 1. Geben Sie den Namen der App ein, die Sie steuern möchten.",
            "two": "Schritt 2. Bestätigen Sie die Eingabesteuerung, die Sie verwenden möchten:",
            "three": "Schritt 3. (optional)",
            "threeContinued": "Beschreiben Sie alle spezifischen Aktionen, die Sie für Befehle einrichten möchten, die Sie häufig verwenden oder für die Sie eine starke Vorliebe haben. Bitte verwenden Sie einfaches Englisch wie die folgenden"
        },
        "title": "App-Steuerelemente generieren",
        "titleLong": "Generieren einer App-Steuerung",
        "try": "Probieren Sie den Control Generator aus",
        "placeholder": "Achten Sie darauf, dass die Sprachbefehle kurz sind.\n\nIch möchte „Vorwärts“ sagen können, um zur nächsten Folie in der Präsentation zu gelangen.\n\nIch möchte Kopfbewegungen zum Bewegen des Cursors und Sprachsteuerung für Bearbeitungstasten verwenden.\n\nSchnellaktionsschaltflächen für alle Bewegungen und Fähigkeiten meiner Figur hinzufügen."
    },
    "macros": {
        "title": "Kontrolle",
        "titlePlural": "Bedienelemente",
        "description": "Steuerelemente enthalten eine Eingabe (eine Aktion, die Sie ausführen, z. B. Ihren Kopf neigen) und Schritte, die Cephable ausführt, nachdem diese Eingabeaktion aufgezeichnet wurde. Sie können Steuerelemente verwenden, um eine Kombination von Schritten zu erstellen, die durch eine einzelne Eingabe ausgelöst werden.",
        "new": "Erstellen eines neuen Steuerelements",
        "newDescription": "Erstellen Sie ein neues Steuerelement, um mehrere Schritte und Eingaben zu kombinieren.",
        "add": "Steuerelement hinzufügen",
        "create": "Erstellen eines Steuerelements",
        "name": {
            "title": "Steuerelementname",
            "question": "Wie möchten Sie diese Steuerung nennen?",
            "description": "Geben Sie Ihrem Steuerelement einen Namen, damit Sie es später leicht finden können.",
            "placeholder": "Aktion, die dieses Steuerelement ausführt, z. B. „Springen“ oder „Vergrößern“"
        },
        "empty": "Sie haben noch keine Steuerelemente. Klicken Sie unten, um eines zu erstellen.",
        "copySuffix": "{{name}}_kopieren"
    },
    "event": {
        "title": "Schritt",
        "titlePlural": "Vorgehensweise",
        "previewSummaryPlural": "{{first}} und {{total}} weitere Ereignisse",
        "add": "Schritt hinzufügen",
        "stepType": "Schritttyp",
        "select": "Wählen Sie den Schritttyp aus, den Sie hinzufügen möchten.",
        "question": "Welche Art von Aktionen soll Cephable ausführen?",
        "setup": "Konfigurieren Sie Ihren Step",
        "description": "Schritte sind die Aktionen, die Cephable ausführt, nachdem die Eingabe ausgelöst wurde. Sie können einem Steuerelement mehrere Schritte hinzufügen, um eine Kombination von Aktionen zu erstellen.",
        "expand": "Erweitern Sie, um die restlichen Schritte anzuzeigen",
        "stepUp": "Schritt nach oben verschieben",
        "stepDown": "Schritt nach unten verschieben",
        "stepCopy": "Schritt kopieren",
        "stepRemove": "Schritt entfernen",
        "insertStep": "Schritt unten einfügen",
        "showOptions": "Optionen anzeigen",
        "hideOptions": "Optionen ausblenden",
        "hold": "Haltezeit (in Millisekunden)",
        "error": "Sie müssen Ihren Schritt konfigurieren.",
        "multiple": "Mehrere Schritte",
        "deviceTypeCustomAction": {
            "title": "Benutzerdefinierte Geräteaktion"
        },
        "keyPress": {
            "title": "Drücken Sie die Taste oder den Knopf",
            "short": "Drücken",
            "fieldSet": "Zu drückende Tasten oder Knöpfe",
            "label": "Taste oder Knopf",
            "holdTime": "Tastendruckdauer (in Millisekunden)",
            "description": "Drücken Sie eine Taste auf der Tastatur, ohne die Tastatur zu verwenden.",
            "longDescription": "Diese Funktion simuliert das Drücken einer Taste auf Ihrer Tastatur. Wenn Sie beispielsweise Schwierigkeiten beim Drücken physischer Tasten haben, können Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um eine Taste virtuell zu „drücken“.",
            "example": "Sagen Sie „Enter“, um eine E-Mail zu senden, ohne die Eingabetaste physisch zu drücken.",
            "timing": "Tastendruck-Timing",
            "tap": "Klopfen",
            "tapLong": "Tippen Sie auf die Schaltfläche",
            "latch": "Verriegeln",
            "latchLong": "Halten bis zur Freigabe",
            "hold": "Halten",
            "holdLong": "Halten Sie für eine gewisse Zeit",
            "toggle": "Umschalten",
            "toggleLong": "Aktion umschalten",
            "release": "Freigeben",
            "releaseLong": "Aktion freigeben",
            "latchLabel": "<strong>{{value}}</strong> halten, bis es freigegeben wird",
            "tapLabel": "Tippen Sie auf <strong>{{value}}</strong>",
            "pressLabel": "Drücken Sie <strong>{{value}}</strong> für <strong>{{time}}</strong> Millisekunden",
            "remove": "Tastendruck entfernen",
            "add": "Zum Drücken eine Taste/einen Knopf hinzufügen"
        },
        "keyRelease": {
            "title": "Taste oder Knopf zum Loslassen",
            "short": "Freigeben",
            "selected": "Ausgewählte Schlüssel zum Loslassen",
            "description": "Lassen Sie eine Taste auf der Tastatur los, die Sie gedrückt und gehalten haben.",
            "longDescription": "Diese Funktion simuliert das Loslassen einer Taste auf Ihrer Tastatur. Sie sollte in Verbindung mit einem Tastendruck verwendet werden, der auf unbestimmte Zeit gedrückt gehalten wird. Wenn Sie beispielsweise Schwierigkeiten beim Drücken physischer Tasten haben, können Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um eine Taste virtuell „loszulassen“.",
            "example": "Sagen Sie „Stopp“, nachdem Sie „Ausführen umschalten“ gesagt haben, um mit dem Laufen aufzuhören.",
            "label": "Geben Sie <strong>{{value}}</strong> frei",
            "add": "Schlüssel/Knopf zum Entsperren hinzufügen",
            "remove": "Schlüsselfreigabe entfernen"
        },
        "keyToggle": {
            "title": "Umschalttaste oder -knopf",
            "short": "Umschalten",
            "selected": "Ausgewählte Tasten zum Umschalten",
            "description": "Schalten Sie eine Taste auf der Tastatur wie einen Lichtschalter mit einem einzigen Steuerelement ein oder aus.",
            "longDescription": "Dadurch wird die Funktion einer Taste wie bei einem Schalter ein- oder ausgeschaltet. Dies ist nützlich für Tasten, die Sie für eine unbestimmte Zeit gedrückt halten möchten. Sie können dies verwenden, um die gleiche Aktion sowohl für das Drücken als auch für das Loslassen oder Anhalten einer Taste beizubehalten.",
            "example": "Sagen Sie „Toggle Run“, um mit dem Laufen zu beginnen. Sagen Sie „Toggle Run“, um mit dem Laufen aufzuhören.",
            "label": "<strong>{{value}}</strong> umschalten",
            "add": "Taste/Knopf zum Umschalten hinzufügen",
            "remove": "Schlüssel entfernen - Umschalter"
        },
        "pause": {
            "title": "Pause",
            "description": "Fügen Sie eine kurze Verzögerung zwischen den Aktionen hinzu.",
            "longDescription": "Mit dieser Funktion können Sie eine kurze Verzögerung zwischen Aktionen einfügen. Dies ist wichtig, wenn eine Aktion vollständig abgeschlossen sein muss, bevor die nächste beginnt. Wenn Sie beispielsweise einen Befehl verwenden, um Text in einem Dokument fett zu formatieren, müssen Sie möglicherweise zuerst ein Kontextmenü öffnen. Die Pausenfunktion gibt genügend Zeit, damit das Kontextmenü geöffnet und aktiviert werden kann, bevor mit dem nächsten Schritt fortgefahren wird. So wird ein reibungsloser und fehlerfreier Betrieb gewährleistet.",
            "example": "Stellen Sie sich vor, Sie bearbeiten ein Dokument mit Sprachbefehlen. Sie sagen „Text formatieren“, woraufhin ein Kontextmenü geöffnet wird. Dann sagen Sie nach einer kurzen Pause, damit das Menü vollständig angezeigt werden kann, „Fett“, um den ausgewählten Text fett zu formatieren. Die Pausenfunktion stellt sicher, dass das Kontextmenü bereit ist, Ihren nächsten Befehl zu empfangen.",
            "label": "Pause für <strong>{{value}}</strong> Millisekunden"
        },
        "type": {
            "title": "Typ",
            "field": "Zu tippende Phrase",
            "placeholder": "getippte Phrase",
            "question": "Welchen Text möchten Sie eingeben?",
            "description": "Schreiben Sie Text wie mit einer Tastatur.",
            "longDescription": "Dies imitiert das Eintippen einer Textzeichenfolge, ähnlich dem Tippen auf einer Tastatur. Es ist ideal, um längere Texte einzugeben, ohne jede Taste drücken zu müssen. Wenn Sie Text dynamisch eingeben möchten, können Sie stattdessen die Diktierfunktion verwenden.",
            "example": "Sagen Sie „Name“, um „Hallo, mein Name ist Ellen Ripley.“ in ein Chatfenster einzugeben.",
            "label": "Geben Sie <strong>{{value}} ein</strong>"
        },
        "mouseMove": {
            "title": "Bewegen Sie die Maus",
            "description": "Bewegen Sie den Zeiger auf dem Bildschirm.",
            "longDescription": "Bewegen Sie den Cursor oder Zeiger Ihres Bildschirms ohne physische Maus. Dies ist besonders hilfreich für Benutzer mit eingeschränkter Handbeweglichkeit. Dies ist nützlich für die Feinsteuerung der Mausbewegung, die in einigen Spielen erforderlich ist. Wenn Sie alle Mausbewegungen mithilfe Ihrer Kopfbewegung simulieren möchten, können Sie in den Kameraeinstellungen die Option „Kopfbewegung zur Maussteuerung“ ausprobieren.",
            "example": "Sagen Sie „Maus nach rechts bewegen“, um den Cursor 100 Pixel nach rechts zu bewegen.",
            "moveX": "Maus bewegt sich nach links/rechts um Pixel",
            "numberMoveX": "Anzahl der nach links/rechts zu verschiebenden Pixel",
            "moveY": "Mausbewegung nach oben/unten in Pixeln",
            "numberMoveY": "Anzahl der nach oben/unten zu verschiebenden Pixel",
            "label": "Bewegen Sie die Maus <strong>{{value}}</strong>",
            "command": "Mausbewegung: {{command}}",
            "commandLabel": "Mausbewegung",
            "startCommand": "Mausbewegung starten",
            "stopCommand": "Mausbewegung stoppen"
        },
        "joystickMove": {
            "title": "Joysticks bewegen",
            "description": "Verwenden Sie einen Joystick, um Dinge auf dem Bildschirm zu bewegen.",
            "longDescription": "Diese Funktion simuliert die Bewegung eines Joysticks. Wenn Sie beispielsweise Schwierigkeiten mit der Verwendung eines physischen Joysticks haben, können Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um einen Joystick virtuell zu bewegen.",
            "example": "Sagen Sie „Joystick nach links bewegen“, um den Joystick 100 Pixel nach links zu bewegen.",
            "prefix": "Bewegen Sie den linken Joystick",
            "left": "Linker Joystick",
            "leftX": "Linke X",
            "leftY": "Linke Y",
            "right": "Rechter Joystick",
            "rightX": "Rechte X",
            "rightY": "Rechte Y",
            "x": "Stärke der X-Achse",
            "y": "Stärke der Y-Achse",
            "moveXLabel": "Zug X: {{value}}",
            "moveYLabel": "Y bewegen: {{value}}",
            "labelLeft": "Bewegen Sie den linken Joystick",
            "labelRight": "Bewegen Sie den rechten Joystick",
            "latch": "Latch hält die Position, bis Sie sie mit dem Befehl „Alles stoppen“ loslassen."
        },
        "playAudio": {
            "title": "Audio abspielen",
            "placeholder": "Aussagesatz, den Cephable sagen wird",
            "description": "Spielen Sie einen Ton, ein Wort oder eine Phrase ab.",
            "longDescription": "Mit dieser Funktion können Benutzer eingegebene Sätze in gesprochene Wörter umwandeln. Dies ist besonders nützlich für Personen, die möglicherweise Schwierigkeiten beim Sprechen haben. Wenn Sie einen Satz eingeben, wird der Text mit der PlayAudio-Funktion mithilfe synthetischer Sprache laut ausgesprochen. Dies kann bei der Kommunikation oder in Situationen hilfreich sein, in denen ein Benutzer Informationen mündlich weitergeben muss, aber eine Alternative zur Verwendung seiner eigenen Stimme bevorzugt oder benötigt.",
            "example": "Lächeln Sie, um das Wort „Hallo“ abzuspielen.",
            "label": "Sprechen Sie <strong>\"{{value}}\"</strong>"
        },
        "stopOutputs": {
            "title": "Alle Ausgaben stoppen",
            "titleLong": "Alle Ausgaben stoppen (alle Tasten und Knöpfe loslassen, alle Mausbewegungen stoppen, alle Eingaben stoppen)",
            "description": "Stoppen Sie alle laufenden Aktionen wie etwa Tastendrücke.",
            "longDescription": "Stoppen Sie sofort alle laufenden Ausgaben oder Aktionen. Dies ist eine Sicherheits- oder Komfortfunktion, um jeden Prozess anzuhalten. Wir erledigen dies automatisch für Sie, wenn Sie die Kamera- oder Mikrofonsteuerung schließen oder anhalten.",
            "example": "Sagen Sie „Stopp“, um alle Ausgaben zu stoppen.",
            "label": "Alle Ausgänge stoppen und Tasten loslassen"
        },
        "custom": {
            "title": "Brauch"
        },
        "options": {
            "moveUp": "Nach oben",
            "moveDown": "Nach unten",
            "moveLeft": "Nach links bewegen",
            "moveRight": "Nach rechts bewegen",
            "copyStep": "Schritt kopieren",
            "removeStep": "Schritt entfernen"
        },
        "directions": {
            "up": "Hoch",
            "down": "Runter",
            "left": "Links",
            "right": "Rechts"
        }
    },
    "expression": {
        "title": "Gesichtsausdruck",
        "titlePlural": "Gesichtsausdrücke",
        "label": "Ausdruck / Gestik",
        "start": "Starten Sie die Ausdruckssteuerung",
        "startSmiling": {
            "title": "Fangen Sie an zu lächeln",
            "description": "Wenn Sie zunächst nicht lächeln und dann anfangen zu lächeln, wird diese Steuerung ausgelöst. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Steuerung zum Öffnen/Schließen des Mundes kann zu Konflikten führen."
        },
        "stopSmiling": {
            "title": "Hör auf zu lächeln",
            "description": "Wenn Sie lächeln und dann aufhören zu lächeln, wird diese Steuerung ausgelöst. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Steuerung zum Öffnen/Schließen des Mundes kann zu Konflikten führen."
        },
        "eyebrows": {
            "title": "Augenbrauen hochziehen",
            "description": "Wenn Sie beide Augenbrauen aus Ihrer Ruheposition heben, wird diese Steuerung ausgelöst."
        },
        "openMouth": {
            "title": "Offener Mund",
            "description": "Wenn Ihr Mund geschlossen ist (oder Ihre Grundlinie leicht geöffnet ist) und Sie ihn weiter öffnen, wird diese Steuerung ausgelöst. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Lächelsteuerung kann zu Konflikten führen."
        },
        "closeMouth": {
            "title": "Mund schließen",
            "description": "Wenn Sie Ihren Mund geöffnet haben und ihn vollständig schließen, wird diese Steuerung ausgelöst. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerungen wie die Lächelsteuerung kann zu Konflikten führen."
        },
        "description": "Verbessern Sie Ihr digitales Erlebnis mit Gesichtsausdrücken. Verwenden Sie Gesten wie Augenbrauenheben, Lächeln und andere Bewegungen, um Ihren Mauszeiger nahtlos zu steuern, Aktionen auszuführen oder Ihre Interaktionen anzupassen."
    },
    "head": {
        "title": "Kopfbewegung",
        "titlePlural": "Kopfbewegungen",
        "label": "Kopf-/Körperbewegung",
        "question": "Welche Art von Bewegung möchten Sie verwenden?",
        "tilt": {
            "title": "Kopfneigung",
            "left": {
                "title": "Kopf nach links neigen",
                "description": "Wenn Sie in die Kamera schauen und Ihren Kopf nach links neigen, wird diese Steuerung ausgelöst."
            },
            "right": {
                "title": "Kopf nach rechts neigen",
                "description": "Wenn Sie in die Kamera schauen und Ihren Kopf nach rechts neigen, wird diese Steuerung ausgelöst."
            },
            "back": {
                "title": "Kopf nach hinten neigen",
                "description": "Wenn Sie in die Kamera schauen, den Kopf in den Nacken legen und nach oben schauen, wird diese Steuerung ausgelöst."
            },
            "forward": {
                "title": "Kopf nach vorne neigen",
                "description": "Wenn Sie in die Kamera schauen, den Kopf nach vorne neigen und nach unten schauen, wird diese Steuerung ausgelöst."
            },
            "description": "Neigen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."
        },
        "turn": {
            "title": "Kopf drehen",
            "left": {
                "title": "Kopf nach links drehen",
                "description": "Wenn Sie in die Kamera schauen und Ihren Kopf drehen und nach links schauen, wird diese Steuerung ausgelöst."
            },
            "right": {
                "title": "Kopf rechts abbiegen",
                "description": "Wenn Sie in die Kamera schauen und Ihren Kopf drehen und nach rechts schauen, wird diese Steuerung ausgelöst."
            },
            "description": "Drehen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."
        },
        "lean": {
            "title": "Kopf schlank",
            "left": {
                "title": "Kopf nach links neigen",
                "description": "Wenn Sie in die Kamera schauen und sich nach links neigen, sodass Ihr Gesicht weiter links im Kamerarahmen ist, wird diese Steuerung ausgelöst."
            },
            "right": {
                "title": "Kopf nach rechts neigen",
                "description": "Wenn Sie in die Kamera schauen und sich nach rechts neigen, sodass Ihr Gesicht weiter rechts im Kamerarahmen ist, wird diese Steuerung ausgelöst."
            },
            "back": {
                "title": "Kopf nach hinten neigen",
                "description": "Wenn Sie in die Kamera schauen und sich nach hinten lehnen, sodass Ihr Gesicht weiter von der Kamera entfernt ist, wird diese Steuerung ausgelöst."
            },
            "forward": {
                "title": "Kopf nach vorne lehnen",
                "description": "Wenn Sie in die Kamera schauen und sich nach vorne beugen, sodass Ihr Gesicht näher an der Kamera ist, wird diese Steuerung ausgelöst."
            },
            "up": {
                "title": "Körper nach oben bewegen",
                "description": "Wenn Sie in die Kamera schauen und Ihren Kopf nach oben bewegen, indem Sie Ihren Hals strecken oder Ihren ganzen Körper nach oben bewegen, wird diese Steuerung ausgelöst."
            },
            "down": {
                "title": "Körper nach unten bewegen",
                "description": "Diese Steuerung wird ausgelöst, wenn Sie in die Kamera schauen und Ihren Kopf nach unten bewegen, indem Sie den Hals krümmen, sich ducken oder Ihren ganzen Körper senken."
            },
            "center": {
                "title": "Zentrieren Sie Ihren Kopf",
                "description": "Wenn Sie in die Kamera schauen und Ihren Kopf zurück in die der Grundlinie entsprechende Mittelposition bewegen, wird diese Steuerung ausgelöst."
            },
            "description": "Neigen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."
        },
        "description": "Steuern Sie Ihr Gerät oder Ihre Verbindung mit Kopfbewegungen wie Neigen, Nicken oder Drehen. Mithilfe der Kamera Ihres Geräts sorgt Cephable für ein privates und intuitives Erlebnis mit verbesserter Steuerung oder Mausnavigation."
    },
    "voice": {
        "title": "Sprachsteuerung",
        "titlePlural": "Sprachsteuerung",
        "placeholder": "Stimme oder Satz, auf den Cephable achtet",
        "question": "Welche Aussage oder Phrase möchten Sie zu diesem Steuerelement sagen?",
        "when": "Wenn ich sage ...",
        "say": "Sagen Sie '{{value}}'",
        "load": {
            "fail": {
                "title": "{{language}} Sprachsteuerung nicht verfügbar",
                "description": "Oh nein! {{language}} konnte für die Sprachsteuerung nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wir verwenden Englisch (USA), bis die Verbindung wiederhergestellt ist."
            }
        },
        "description": "Durch das Einschalten des Mikrofons werden intelligente und natürliche Sprachbefehle freigeschaltet, die eine nahtlose Interaktion mit dem Computer über Anwendungen und Software hinweg ermöglichen. Sprechen Sie natürlich, um Befehle auszuführen oder Text zu diktieren – für ein müheloses und intuitives Erlebnis."
    },
    "motion": {
        "title": "Bewegungssteuerung",
        "titlePlural": "Bewegungssteuerung",
        "question": "Welche Art der Bewegung mit einem Telefon oder Tablet möchten Sie verwenden?",
        "start": "Bewegungssteuerung starten",
        "settings": "Bewegungseinstellungen",
        "descriptionShort": "Neigen, drehen oder schütteln Sie Ihr Gerät, um Cephable zu steuern.",
        "description": "Mit Bewegungssteuerungen können Sie die Bewegungen Ihres Telefons oder Tablets in der Companion App in Steuerelemente für Ihr Gerät umwandeln. Neigen oder schütteln Sie Ihr Telefon in verschiedene Richtungen, um neue Ergebnisse zu erzielen.",
        "up": {
            "title": "Neigen Sie Ihr Gerät nach oben",
            "description": "Wenn Ihr Gerät flach auf einer Oberfläche liegt und Sie es nach oben neigen, sodass Sie es sehen, wird diese Steuerung ausgelöst."
        },
        "down": {
            "title": "Neigen Sie Ihr Gerät nach unten",
            "description": "Wenn Ihr Gerät flach auf einer Oberfläche liegt und Sie es nach unten neigen, sodass es von Ihnen weg zeigt, wird diese Steuerung ausgelöst."
        },
        "left": {
            "title": "Neigen Sie Ihr Gerät nach links",
            "description": "Wenn Ihr Gerät flach auf einer Oberfläche liegt und Sie es nach links neigen, sodass es nach links zeigt, wird diese Steuerung ausgelöst."
        },
        "right": {
            "title": "Neigen Sie Ihr Gerät nach rechts",
            "description": "Wenn Ihr Gerät flach auf einer Oberfläche liegt und Sie es nach rechts neigen, wird diese Steuerung ausgelöst."
        },
        "shake": {
            "title": "Schütteln Sie Ihr Gerät",
            "description": "Wenn Sie Ihr Gerät schütteln, wird diese Steuerung ausgelöst."
        },
        "edit": {
            "title": "Bewegungseinstellungen bearbeiten",
            "description": "Ändern Sie Ihre Bewegungssteuerungseinstellungen, um anzupassen, wie weit Sie Ihr Telefon beim Laufen zur Companion App bewegen müssen",
            "sensitivity": {
                "title": "Empfindlichkeitseinstellungen für die Bewegungssteuerung",
                "description": "Die Empfindlichkeit gibt Cephable an, wie weit Sie Ihr Gerät neigen müssen, um eine Steuerung auszulösen. Je größer der Wert (ganz rechts auf dem Schieberegler), desto höher ist die Empfindlichkeit und desto weniger müssen Sie neigen, um die Steuerung auszulösen."
            },
            "tilt": {
                "title": "Neigungsempfindlichkeit",
                "description": "Diese Werte bestimmen, wie weit Sie Ihr Gerät nach oben, unten, links und rechts neigen müssen, damit eine Eingabe erkannt wird."
            },
            "mouse": {
                "title": "Bewegungssteuerung für Mausbewegungen",
                "description": "Legen Sie fest, ob und wie Sie Bewegungssteuerungen zum Bewegen der Maus anstelle von Auslösesteuerungen verwenden möchten",
                "enable": {
                    "title": "Bewegungssteuerung für Mausbewegungen aktivieren",
                    "description": "Wenn dies aktiviert ist, werden zum Bewegen der Maus einige Ihrer Bewegungssteuerelemente anstelle der Trigger-Steuerelemente verwendet.",
                    "option": "Bewegungssteuerung für Mausbewegungen verwenden?"
                },
                "invert": {
                    "title": "Mausbewegung umkehren",
                    "description": "Für die X-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach links die Maus nach rechts und eine Bewegung nach rechts nach links. Für die Y-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach unten die Maus nach oben und eine Bewegung nach oben nach unten.",
                    "x": "Mausbewegung auf der X-Achse umkehren?",
                    "y": "Mausbewegung auf der Y-Achse umkehren?"
                }
            }
        }
    },
    "keys": {
        "title": "Taste oder Knopf",
        "titlePlural": "Tasten oder Knöpfe",
        "label": "Externe Taste / Knopf",
        "question": "Welche Taste oder Schaltfläche möchten Sie drücken?",
        "edit": "Tasten und Schaltflächen bearbeiten",
        "defaultOption": "Standard-Sprachbefehle für Tasten und Mausklicks einschließen?",
        "description": "Mithilfe von Tasten und Schaltflächen können Sie Ihre verschiedenen Eingabesteuerungen den Tastendrücken auf der Tastatur und dem Controller zuordnen.",
        "then": "Cephable wird drücken...",
        "empty": "Es sind keine Tastensteuerungen vorhanden, die diesen Kriterien entsprechen.",
        "backspace": "Rücktaste",
        "delete": "Löschen",
        "enter": "Eingeben",
        "space": "Leertaste",
        "tab": "Tab",
        "shift": "Schicht",
        "ctrl": "Strg",
        "leftCtrl": "Linke Strg-Taste",
        "rightCtrl": "Rechte Strg-Taste",
        "leftShift": "Linksverschiebung",
        "rightShift": "Rechtsverschiebung",
        "alt": "Alle",
        "leftAlt": "Linke Alt-Taste",
        "escape": "Flucht",
        "up": "Pfeil nach oben",
        "down": "Pfeil nach unten",
        "left": "Pfeil nach links",
        "right": "Pfeil nach rechts",
        "command": "Befehl",
        "caps": "Feststelltaste",
        "reset": {
            "title": "Tastenbelegung zurücksetzen",
            "confirm": "Alle Tastenbelegungen zurücksetzen?",
            "confirmDescription": "Wählen Sie aus, wie Sie die Tastenbelegung zurücksetzen möchten. Diese Aktion kann erst nach dem Speichern rückgängig gemacht werden.",
            "confirmButton": "Tastenbelegung zurücksetzen",
            "defaultOption": "Auf Standardwerte für die aktuelle Sprache zurücksetzen",
            "emptyOption": "Auf leeren Zustand zurücksetzen (alle Befehle löschen)"
        }
    },
    "talkback": {
        "title": "Talkback",
        "question": "Was möchten Sie, dass Cephable sagt?",
        "description": "Richten Sie Steuerelemente ein, mit denen Cephable für Sie spricht. Sie können Steuerelemente verschiedenen Sätzen zuweisen, die vorgelesen werden sollen.",
        "thenMacro": "dann wird Cephable sagen ...",
        "empty": "Es gibt keine Talkback-Bedienelemente, die diesem Kriterium entsprechen.",
        "add": "Hinzufügen einer neuen Talkback-Steuerung",
        "remove": "Talkback-Steuerung entfernen",
        "edit": "Talkback-Steuerelemente bearbeiten",
        "deprecatedNotice": "Talkback ist jetzt direkt in die primären App-Steuerelemente integriert. Ihre App-Steuerelemente enthalten einige ältere Talkback-Ereignisse, die aktualisiert werden müssen."
    },
    "dictation": {
        "title": "Diktat",
        "question": "Welcher Satz soll den Diktiermodus auslösen?",
        "thenMacro": "Cephable wird …",
        "empty": "Es gibt keine Diktiersteuerungen, die diesen Kriterien entsprechen.",
        "type": "Typ",
        "edit": "Diktatphrasen bearbeiten",
        "remove": "Diktatphrase entfernen",
        "add": "Neue Diktierphrase hinzufügen",
        "on": "Diktat",
        "off": "Befehle",
        "onboarding": {
            "tourLabel": "Diktat",
            "learn": "Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freihändig in Text umwandeln.",
            "welcome": {
                "title": "Diktat",
                "description": "Mit der Diktierfunktion können Sie natürlich sprechen und Ihre Worte direkt während des Sprechens abtippen lassen. Es ist, als hätten Sie einen persönlichen Assistenten, der alles tippt, was Sie sagen."
            },
            "microphone": {
                "title": "Schalten Sie Ihr Mikrofon ein",
                "description": "Schalten Sie zunächst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."
            },
            "activate": {
                "title": "Diktiermodus starten",
                "description": "Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie „Diktat starten“ oder klicken Sie auf die Schaltfläche „Diktieren“. Schalten wir jetzt den Diktiermodus ein."
            },
            "speaking": {
                "title": "Klicken Sie auf ein Dokument oder Feld und beginnen Sie zu sprechen",
                "description": "Die Diktierfunktion gibt Ihre Eindrücke in Echtzeit wieder. Klicken Sie auf ein Textfeld oder Dokument und beginnen Sie zu sprechen. Sagen Sie beispielsweise: „So verwenden Sie den Diktiermodus.“"
            },
            "pauseResume": {
                "title": "Diktat pausieren",
                "description": "Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach „Diktat pausieren“. Sie können jederzeit mit „Diktat starten“ fortfahren. Sie können die Funktion mit Ihren globalen Always-On- und Gerätesteuerungen weiter anpassen."
            },
            "stop": {
                "title": "Diktat stoppen",
                "description": "Möchten Sie zurück zur App-Steuerung wechseln? Sagen Sie einfach „Diktat beenden“. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zurück. Sie können jederzeit mit „Diktat starten“ fortfahren."
            },
            "complete": {
                "title": "Glückwunsch!",
                "description": "Das war's! Sie können jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool für freihändiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen müssen."
            }
        },
        "description": "Mit der Diktierfunktion können Sie natürlich sprechen und Ihre Worte während des Sprechens eintippen lassen. Es ist, als hätten Sie einen persönlichen Assistenten, der alles tippt, was Sie sagen."
    },
    "face": {
        "title": "Gesichtsausdruck",
        "titlePlural": "Gesichtsausdrücke",
        "try": "Probieren Sie die Gesichtsausdrucksteuerung aus",
        "question": "Welche Art von Gesichtsausdruck möchten Sie verwenden?",
        "descriptionShort": "Verwenden Sie verschiedene Gesichtsbewegungen für eine verbesserte Steuerung.",
        "description": "Gesichtsausdrücke sind Teil der Ausdruckssteuerung. Sie ermöglicht Ihnen die Verwendung verschiedener Gesichtsbewegungen für erweiterte Steuerungen. Sie können Augenbrauenbewegungen, Mundbewegungen und mehr verwenden, um unterschiedliche Ergebnisse zu erzielen."
    },
    "other": {
        "title": "Andere",
        "titlePlural": "Andere Bedienelemente",
        "label": "Andere Steuerung",
        "placeholder": "anderer experimenteller Befehl",
        "question": "Welchen zusätzlichen Befehl möchten Sie verwenden? Diese sind typischerweise für nicht-Cephable-Verbindungen gedacht, die nicht in andere Kategorien passen. Sie können auch als Sprachbefehle fungieren, wenn Sie das angegebene Wort oder die angegebene Phrase aussprechen. Hinweis: Diese Steuerelemente sind experimentell und werden möglicherweise nicht vollständig unterstützt.",
        "description": "Andere Steuerelemente sind experimentell und werden möglicherweise nicht vollständig unterstützt. Sie können für nicht-Cephable-Verbindungen oder als Sprachbefehle verwendet werden, wenn Sie das angegebene Wort oder den angegebenen Satz aussprechen."
    },
    "support": {
        "title": "Unterstützung",
        "profiles": "Einführung in App-Steuerelemente",
        "question": "Finden Sie immer noch nicht, was Sie brauchen?",
        "more": "Erfahren Sie mehr auf Cephable.com mit Schritt-für-Schritt-Anleitungen, Tutorials, Videos und mehr."
    },
    "community": {
        "title": "Treten Sie der Community bei",
        "description": "Holen Sie sich Unterstützung, tauschen Sie Ideen aus oder werden Sie Mitglied der Cephable-Communitys.",
        "discord": "Discord-Community",
        "facebook": "Facebook-Gruppe"
    },
    "resources": {
        "title": "Hilfreiche Ressourcen",
        "description": "Finden Sie Antworten auf Ihre Fragen zu den Merkmalen und Funktionen von Cephable.",
        "guides": "Schritt-für-Schritt-Anleitungen"
    },
    "feedback": {
        "title": "Rückmeldung",
        "description": "Erzählen Sie uns von Ihren Erfahrungen mit Cephable.",
        "contact": "Kontaktieren Sie uns",
        "feature": "Funktion vorschlagen",
        "bug": "Ein Problem melden"
    },
    "settings": {
        "title": "Einstellungen",
        "general": "Allgemeine App-Einstellungen",
        "description": "Dies ist Ihre Leinwand, auf der Sie durch die Feinabstimmung Ihrer Steuerungen Ihr Erlebnis individuell gestalten können.",
        "orgTitle": "{{ value }}-Einstellungen",
        "advanced": {
            "title": "Erweiterte Einstellungen",
            "description": "Klicken Sie hier, um erweiterte Einstellungen für Ihre KI-Einstellungen, App-Steuerung, Verbindungen, Erweiterungen und mehr zu erhalten."
        },
        "quick": "Hier finden Sie die Kontexteinstellungen für das Bedienfeld. Nutzen Sie diese, um Ihre aktuelle Benutzererfahrung zu optimieren."
    },
    "account": {
        "title": "Konto",
        "menu": "Nutzermenü",
        "settings": "Kontoeinstellungen",
        "description": "Aktualisieren Sie wichtige Informationen, um mit Cephable in Verbindung zu bleiben.",
        "usernameLabel": "Benutzername:",
        "emailLabel": "E-Mail:",
        "password": {
            "change": "Kennwort ändern",
            "description": "Aktualisieren Sie Ihr Passwort, um Ihr Konto zu schützen.",
            "old": "Altes Passwort",
            "current": "Ihr aktuelles Passwort",
            "new": "Neues Passwort",
            "desired": "Ihr gewünschtes neues Passwort",
            "confirm": "Neues Passwort bestätigen",
            "update": "Kennwort aktualisieren"
        },
        "isEmailVerified": {
            "title": "E-Mail ist nicht verifiziert.",
            "description": "Ihre E-Mail wurde nicht bestätigt. Bitte suchen Sie in Ihrem Posteingang nach einem Bestätigungslink.",
            "resend": "E-Mail erneut senden",
            "success": "Wir haben Ihnen eine neue Bestätigungs-E-Mail gesendet.",
            "error": "Beim Senden der Bestätigungs-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
            "org": "Ihre E-Mail-Adresse wurde nicht bestätigt. Sie ist für den Zugriff auf die Lizenzdaten erforderlich. Bitte überprüfen Sie Ihre E-Mail-Adresse auf einen Bestätigungslink.",
            "titleAlt": "Bestätigen Sie Ihre E-Mail-Adresse",
            "descriptionLong": "Willkommen bei Cephable! Eine Bestätigungs-E-Mail wurde an {{email}} gesendet. Bitte überprüfen Sie Ihren Posteingang oder Spam-Ordner und klicken Sie auf den Link. Falls Sie ihn nicht sehen, können Sie die Bestätigungs-E-Mail erneut senden.",
            "appBlock": "Du hast es fast geschafft! Eine Bestätigungs-E-Mail wurde an {{email}} gesendet. Bitte überprüfe deinen Posteingang und klicke auf den Link, um deine E-Mail-Adresse zu bestätigen. Solltest du den Link nicht finden, überprüfe bitte deinen Spam-Ordner."
        },
        "signout": {
            "title": "Abmelden",
            "question": "Möchten Sie sich wirklich abmelden?",
            "confirm": "Ja, abmelden",
            "warn": {
                "title": "Sie werden gleich abgemeldet.",
                "description": "Es sieht so aus, als wären Sie eine Weile inaktiv gewesen. Aus Sicherheitsgründen melden wir Sie in XX Sekunden ab. Wenn Sie angemeldet bleiben möchten, klicken Sie unten auf „Angemeldet bleiben“.",
                "confirm": "Angemeldet bleiben",
                "cancel": "Jetzt abmelden"
            },
            "description": "Sobald Sie sich abmelden, wird diese Verbindung aus Ihrem Konto entfernt und ist in der Companion App oder anderen Verbindungen nicht mehr sichtbar.",
            "confirmDescription": "Sie werden abgemeldet und diese Verbindung wird entfernt"
        },
        "marketing": {
            "title": "E-Mail-Einstellungen",
            "description": "Aktualisieren Sie Ihre E-Mail-Einstellungen, um Updates und Neuigkeiten von Cephable zu erhalten.",
            "marketing": "Marketing-E-Mails",
            "optIn": "Ich möchte Tutorials, Tipps, Updates und Newsletter erhalten, um mein Cephable-Erlebnis zu verbessern"
        },
        "error": {
            "save": "Fehler beim Speichern der Kontoeinstellungen.",
            "password": "Fehler beim Aktualisieren des Passworts.",
            "signout": "Fehler beim Abmelden.",
            "old": "Altes Passwort ist erforderlich.",
            "new": "Ein neues Passwort ist erforderlich.",
            "match": "Die Passwörter stimmen nicht überein.",
            "marketing": "Fehler beim Aktualisieren der E-Mail-Einstellungen.",
            "userPreferences": "Fehler beim Speichern der Benutzereinstellungen."
        },
        "success": {
            "save": "Kontoeinstellungen gespeichert.",
            "password": "Passwort aktualisiert.",
            "marketing": "E-Mail-Einstellungen aktualisiert.",
            "userPreferences": "Benutzereinstellungen aktualisiert."
        },
        "userPreferences": {
            "title": "Benutzereinstellungen",
            "description": "Aktualisieren Sie Ihre Einstellungen, um das für Sie passende Cephable-Erlebnis zu schaffen.",
            "warningOptOut": "Warnungen ausblenden, wenn ich App-Steuerelemente speichere oder aktualisiere",
            "enableTranscribeTask": "Aktivieren Sie die experimentelle Dateitranskriptionsaufgabe im Cephable-Panel",
            "enableGamepadSupport": "Aktivieren Sie die Gamepad-Unterstützung für lokale Treiber und Xbox-Controller-Emulation",
            "enableMetrics": "Aktivieren Sie die Ausgabe von Nutzungsmetriken für Leistungstests. Sie können die Protokolle herunterladen.",
            "enableCameraControls": "Aktivieren Sie die Kamerasteuerung im Cephable-Panel."
        },
        "delete": {
            "title": "Konto löschen",
            "description": "Sie können Ihr Konto endgültig löschen und alle Bezüge zu Ihren persönlichen Daten entfernen. Mit der Löschung Ihres Kontos werden Ihre Verbindungen getrennt und funktionieren nicht mehr, sind nicht mehr mit Ihrem Konto verknüpft und Ihre App-Einstellungen sowie alle weiteren Einstellungen gehen verloren. Dieser Vorgang kann nicht rückgängig gemacht werden.",
            "button": "Konto endgültig löschen",
            "confirmation": "Sind Sie sicher, dass Sie Ihr Konto löschen möchten?",
            "note": "Diese Handlung ist unumkehrbar.",
            "confirm": "Ja, mein Konto löschen"
        },
        "communication": {
            "title": "Kommunikationseinstellungen"
        },
        "name": {
            "title": "Anzeigename"
        },
        "email": {
            "title": "E-Mail-Adresse",
            "description": "Ihre registrierte E-Mail-Adresse"
        }
    },
    "appSettings": {
        "description": "Diese Einstellungen gelten nur für diese App. Wenn Sie die Einstellungen der Cephable-App auf einem anderen Computer oder Mobilgerät ändern möchten, bearbeiten Sie die Einstellungen in dieser App.",
        "autostart": {
            "title": "Cephable automatisch starten",
            "description": "Wenn diese Einstellung aktiviert ist, wird die Cephable-App automatisch gestartet, wenn Sie sich bei Ihrem Gerät anmelden. Wenn Sie auch über automatische Sprach- und Ausdruckssteuerungen verfügen, werden diese ebenfalls sofort gestartet.",
            "question": "Cephable-App automatisch starten?"
        },
        "position": {
            "topLeft": "Oben links",
            "top": "Oben Mitte",
            "topRight": "Oben rechts",
            "bottom": "Unten Mitte",
            "bottomLeft": "Unten links",
            "bottomRight": "Unten rechts",
            "label": "Befehlsvorschubposition auswählen",
            "description": "Wählen Sie aus, wo der Befehls-Feed auf Ihrem Bildschirm angezeigt werden soll."
        },
        "micPosition": {
            "title": "Position des Mikrofon-Eingangsfensters",
            "description": "Wählen Sie aus, wo auf Ihrem Bildschirm die Mikrofonsteuerung für Sprache und Diktieren platziert werden soll.",
            "label": "Fensterposition für Mikrofoneingang auswählen"
        },
        "cameraPosition": {
            "title": "Position des Kamera-Eingabefensters",
            "description": "Wählen Sie aus, wo auf Ihrem Bildschirm die Kamerasteuerung für Gesichts- und Kopfbewegungen positioniert werden soll.",
            "label": "Wählen Sie die Position des Kamera-Eingabefensters"
        },
        "theme": {
            "title": "Thema",
            "description": "Wählen Sie ein Thema, das zu Ihrem Stil passt.",
            "label": "Wählen Sie ein Thema",
            "light": "Licht",
            "dark": "Dunkel",
            "system": "Verwenden Sie die Betriebssystem-Systemeinstellungen"
        },
        "overlay": {
            "title": "Befehlsfeed",
            "description": "Der Befehlsfeed zeigt die verschiedenen von Ihnen verwendeten Steuerelemente und die an Ihren Computer gesendeten Steuerelemente an. Er ist per Klick erreichbar, wird aber immer über anderen Fenstern angezeigt. Wenn diese Einstellung aktiviert ist, wird die Cephable-App angezeigt und befindet sich immer über anderen Fenstern und Anwendungen.",
            "question": "Befehls-Feed anzeigen?"
        },
        "transparent": {
            "title": "Transparenz des Befehlsfeeds",
            "description": "Der Wert bestimmt die Opazität des Textes. Je niedriger der Wert, desto durchsichtiger ist der Feed."
        },
        "panelAutoHide": {
            "title": "Cephable-Panel automatisch ausblenden",
            "delay": "Verzögerung vor dem Verstecken",
            "denominator": "Sekunden",
            "time": "{{value}} Sekunden"
        },
        "title": "Allgemeine App-Einstellungen",
        "scale": {
            "description": "Passen Sie die Textgröße in der gesamten App an.",
            "label": "Textgröße",
            "small": "Klein",
            "large": "Groß"
        },
        "panelScale": {
            "description": "Passen Sie die Größe der Schaltfläche für das ausgeblendete Bedienfeld an.",
            "label": "Größe der Bedienfeld-Schaltfläche"
        },
        "aiNewFiles": {
            "title": "Ordner für neue KI-Dateien",
            "description": "Wählen Sie aus, wo der KI-Agent neue Dateien standardmäßig speichert, sofern Sie keinen bestimmten Speicherort angeben. Wenn die Standardeinstellung beibehalten wird, werden neue Dateien in einem Ordner „Cephable-Work“ in Ihrem Benutzerordner gespeichert, der bei der ersten Verwendung automatisch erstellt wird.",
            "selectButton": "Ordner auswählen",
            "clearButton": "Standardordner verwenden",
            "current": "Neue Dateien werden gespeichert unter: {{folder}}",
            "default": "Neue Dateien werden im Standardordner „Cephable-Work“ in Ihrem Benutzerordner gespeichert.",
            "openButton": "Ordner öffnen",
            "openError": "Der Ordner konnte nicht geöffnet werden. Er wurde möglicherweise verschoben oder gelöscht."
        },
        "aiWorkspace": {
            "title": "AI Workspace-Ordner",
            "description": "Wählen Sie einen Ordner aus, den der KI-Agent auf dem Gerät zum Suchen, Lesen und Bearbeiten von Dateien sowie zum Ausführen von Befehlen verwendet. Standardmäßig hat der Agent Zugriff auf Ihren gesamten Computer.",
            "selectButton": "Ordner auswählen",
            "clearButton": "Den gesamten Computer nutzen",
            "current": "Aktueller Arbeitsbereichsordner:",
            "none": "Es wurde kein Arbeitsbereichsordner ausgewählt. Der KI-Agent kann auf Ihren gesamten Computer zugreifen.",
            "restrictQuestion": "Beschränken Sie den KI-Agenten auf diesen Ordner.",
            "restrictDescription": "Wenn diese Option aktiviert ist, können die Datei- und Befehlswerkzeuge des KI-Agenten nichts außerhalb des ausgewählten Ordners lesen oder ändern."
        },
        "documentTemplates": {
            "title": "Dokumentvorlagen",
            "description": "Wählen Sie eine Vorlagendatei aus, die der KI-Agent beim Erstellen neuer Dokumente verwendet. Belassen Sie den Typ auf der Cephable-Standardeinstellung, um das integrierte Cephable-Design anzuwenden. Word, PowerPoint und Excel verfügen jeweils über eine eigene Vorlage.",
            "word": "Word-Vorlage",
            "wordDescription": "Vorlage, die der KI-Agent für neue Word-Dokumente (.docx) verwendet.",
            "powerpoint": "PowerPoint-Vorlage",
            "powerpointDescription": "Vorlage, von der der KI-Agent für neue PowerPoint-Präsentationen (.pptx) ausgeht.",
            "excel": "Excel-Vorlage",
            "excelDescription": "Vorlage, die der KI-Agent für neue Excel-Arbeitsmappen (.xlsx) verwendet.",
            "selectButton": "Datei auswählen",
            "clearButton": "Cephable-Standard verwenden",
            "current": "Vorlage: ",
            "default": "Verwendung der integrierten Cephable-Standardvorlage mit Markenstyling."
        },
        "automationBrowser": {
            "title": "Sichtbarkeit des Automatisierungsbrowsers",
            "description": "Wenn der KI-Agent den Cephable-Browser nutzt (Webrecherche, Google Docs/Sheets/Slides, Gmail, Drive), läuft er normalerweise unbemerkt im Hintergrund, um Sie nicht zu stören. Aktivieren Sie diese Option, um die Funktionsweise zu sehen.",
            "question": "Den Automatisierungsbrowser während der KI-Arbeit anzeigen?"
        }
    },
    "input": {
        "title": "Eingang",
        "titlePlural": "Eingabesteuerung",
        "explore": "Eingabesteuerung erkunden",
        "descriptionShort": "Entdecken Sie die verschiedenen Eingabesteuerelemente, die Cephable nutzt, um Ihnen ein besseres digitales Erlebnis zu bieten.",
        "typeLabel": "Eingabesteuerungstyp",
        "toolTip": "Dies verwendet {{alt}}",
        "remove": "Eingabesteuerung entfernen",
        "filter": "Filtern nach Eingabetyp",
        "select": "Wählen Sie einen Eingang",
        "question": "Welchen Eingabetyp möchten Sie verwenden?",
        "add": "Eingabe hinzufügen",
        "addMore": "Einen weiteren Eingang hinzufügen",
        "removeItem": "Element entfernen {{index}}",
        "item": "Artikel {{index}}: {{label}}",
        "duplicate": "Doppelte Elemente sind nicht zulässig.",
        "maximum": "Maximal {{maxItems}} Elemente zulässig.",
        "description": "Eingabesteuerungen sind die verschiedenen Methoden zur Steuerung Ihres Geräts. Dazu gehören beispielsweise Ihre Stimme, Kopfbewegungen, Gesichtsausdrücke und zusätzliche Verbindungen. Entdecken Sie unten die verschiedenen Eingabesteuerungen, um mehr zu erfahren."
    },
    "time": {
        "soon": "Demnächst verfügbar",
        "now": "Jetzt",
        "today": "Heute",
        "yesterday": "Gestern",
        "minutesAgo": "vor {{count}} Minute",
        "minutesAgo_plural": "vor {{count}} Minuten",
        "daysAgo": "vor {{count}} Tagen",
        "daysAgo_plural": "vor {{count}} Tagen",
        "monthsAgo": "vor {{count}} Monaten",
        "monthsAgo_plural": "vor {{count}} Monaten",
        "yearsAgo": "vor {{count}} Jahr",
        "yearsAgo_plural": "vor {{count}} Jahren",
        "minutesAhead": "in {{count}} Minuten",
        "todayAhead": "später heute",
        "tomorrow": "morgen",
        "daysAhead": "in {{count}} Tagen",
        "monthsAhead": "in {{count}} Monaten",
        "yearsAhead": "in {{count}} Jahren"
    },
    "peripherals": {
        "empty": "Keine Peripheriegeräte erkannt",
        "switch": "Schalten",
        "keyboard": "Tastatur",
        "gamepad": "Gamepad",
        "companionApp": "Begleit-App",
        "available": "Verfügbar zur Nutzung",
        "error": "Überprüfen Sie Ihre Einstellungen."
    },
    "camera": {
        "windowTitle": "Cephable-Kamerasteuerung",
        "title": "Kamera",
        "titlePlural": "Kameras",
        "settings": "Kameraeinstellungen",
        "start": "Kamera starten",
        "restart": "Kamera neu starten",
        "descriptionShort": "Ermöglicht Gesichtsausdruck und Kopfbewegungen.",
        "description": "Verwenden Sie Ihre Kamera, um Gesichtsausdrücke und Körpergesten als verschiedene Steuerelemente zu erkennen.",
        "empty": "Keine Kameras gefunden.",
        "search": "Suche nach Kameranamen",
        "loading": "Kamerasteuerung wird geladen …",
        "error": "Unerwarteter Fehler beim Laden der Kamerasteuerung. Bitte überprüfen Sie Ihre Kamera und versuchen Sie es erneut.",
        "manage": {
            "title": "Klicken Sie hier, um Details zu Ihren Kameras anzuzeigen und zu verwalten.",
            "description": ""
        },
        "detected": {
            "face": "Gesicht erkannt.",
            "noFace": "Kein Gesicht erkannt. Bitte passen Sie Ihre Kamera oder Position an und versuchen Sie es erneut.",
            "command": "Erkannt: {{command}}"
        },
        "permission": {
            "title": "Kameraberechtigungen erforderlich",
            "description": "Sie müssen Cephable die Berechtigung erteilen, Ihre Kamera zu verwenden, um Gesichts- und Körpersteuerungen zu nutzen.",
            "button": "Berechtigungseinstellungen öffnen",
            "no": "Kein Kamerazugriff",
            "help": "Cephable benötigt Zugriff auf Ihre Kamera, um Ausdrucks- und Kopfsteuerungen verwenden zu können. Navigieren Sie zu <strong>Systemeinstellungen</strong> > <strong>Datenschutz</strong> > <strong>Kamera</strong> und ermöglichen Sie Cephable den Zugriff auf Ihre Kamera."
        },
        "controls": {
            "startData": "Aufzeichnung der Gesichtsdaten gestartet. Drücken Sie im Kamerafenster die Tastenkombination erneut, um die Aufzeichnung und den Download zu stoppen.",
            "downloadData": "Aufzeichnung gestoppt, Daten werden heruntergeladen",
            "paused": "Kamerasteuerung angehalten.",
            "pause": "Kamerasteuerung anhalten",
            "resume": "Kamerasteuerung fortsetzen",
            "resumed": "Kamerasteuerung wieder aufgenommen.",
            "linesOn": "Gesichtslinien einschalten",
            "linesOff": "Gesichtslinien ausschalten",
            "linesToggle": "Zeichnen von Gesichtslinien ein-/ausschalten",
            "noDeviceTitle": "Es wurde keine Kamera erkannt, die mit Cephable verwendet werden kann.",
            "noDeviceDescription": "Sie müssen eine Kamera anschließen, die mit mobilen Apps kompatibel ist.",
            "noDeviceConnectedDescription": "Die Kamerasteuerung dient als Vorschau der Oberfläche. Es werden keine Schritte erfolgreich ausgeführt. Verbinden Sie dieses Begleitgerät mit einem anderen, um Befehle auszulösen.",
            "lines": "Gesichtsfalten"
        },
        "switch": {
            "title": "Kamera wechseln",
            "description": "Wählen Sie eine andere Kamera zur Gesichts- und Körperkontrolle aus.",
            "select": "Kamera auswählen",
            "next": "Nächste Kamera",
            "nextLong": "Zur nächsten Kamera wechseln",
            "empty": "Keine weiteren Kameras gefunden.",
            "search": "Suche nach Kameranamen"
        },
        "baseline": {
            "title": "Ausgangslage",
            "description": "Die Basislinie ist die Standardposition Ihres Gesichts und Körpers, die Cephable zur Bestimmung Ihrer Bewegungen verwendet. Sie können die Basislinie hier aktualisieren und zurücksetzen.",
            "update": "Baseline aktualisieren",
            "reset": "Basislinie zurücksetzen",
            "updated": "Baseline aktualisiert",
            "tooltip": "Klicken Sie, um Ihre Basislinie auf Ihre aktuelle Ruheposition zu aktualisieren."
        },
        "edit": {
            "title": "Kameraeinstellungen bearbeiten",
            "description": "Sie können die Einstellungen für Ihre Eingänge, die eine Kamera erfordern, verfeinern, um sie besser an Ihre Anforderungen anzupassen.",
            "autoStart": {
                "title": "Kamera automatisch starten",
                "option": "Kamera- und Kopf-/Ausdruckssteuerung automatisch starten?",
                "description": "Ist diese Einstellung aktiviert, startet Ihr Controller die Kamera, sodass Sie Gesichtsausdrücke und Kopfbewegungen direkt beim Start der App steuern können. Ist diese Einstellung deaktiviert, tippen Sie auf der Verbindungsseite auf die Schaltfläche „Kamera starten“."
            },
            "head": {
                "title": "Kopfbewegungsempfindlichkeit",
                "description": "Die Empfindlichkeit gibt Cephable an, wie weit Sie sich bewegen müssen, um eine Steuerung auszulösen. Je größer der Wert (ganz rechts auf dem Schieberegler), desto höher ist die Empfindlichkeit und desto weniger müssen Sie sich bewegen, um die Steuerung auszulösen.",
                "tilt": {
                    "title": "Kopfneigungsempfindlichkeit",
                    "description": "Diese Werte bestimmen, wie weit Sie Ihren Kopf nach oben, unten, links und rechts neigen müssen, um Bedienelemente auszulösen",
                    "up": "Neigungsempfindlichkeit",
                    "down": "Neigungsempfindlichkeit",
                    "left": "Neigungsempfindlichkeit nach links",
                    "right": "Neigungsempfindlichkeit nach rechts",
                    "scaleHigh": "Leichte Neigung",
                    "scaleLow": "Große Neigung"
                },
                "turn": {
                    "title": "Kopfdrehempfindlichkeit",
                    "description": "Diese Werte bestimmen, wie weit Sie Ihren Kopf nach links und rechts drehen müssen, um Bedienelemente auszulösen",
                    "left": "Empfindlichkeit für Linksabbiegen",
                    "right": "Empfindlichkeit für Rechtsabbiegen",
                    "scaleHigh": "Leichte Wendung",
                    "scaleLow": "Große Wende"
                },
                "lean": {
                    "title": "Kopfneigungsempfindlichkeit",
                    "description": "Diese Werte bestimmen, wie weit Sie Ihren Kopf nach vorne und hinten neigen müssen, um Bedienelemente auszulösen",
                    "forward": "Empfindlichkeit beim Vorwärtslehnen",
                    "back": "Zurücklehnen-Empfindlichkeit",
                    "right": "Empfindlichkeit der Neigung nach rechts",
                    "left": "Empfindlichkeit für Neigung nach links",
                    "scaleHigh": "Leichte Neigung",
                    "scaleLow": "Großes Lean"
                },
                "duck": {
                    "title": "Kopfentspannung/Kopfanstiegsempfindlichkeit",
                    "description": "Diese Werte bestimmen, wie weit Sie Ihren Kopf beugen oder heben müssen, um die Steuerung auszulösen",
                    "down": "Empfindlichkeit von Entendaunen",
                    "up": "Sensibilität steigern",
                    "scaleHigh": "Leichte Verschiebung",
                    "scaleLow": "Große Verschiebung"
                }
            },
            "face": {
                "title": "Gesichtsausdrucksempfindlichkeit",
                "description": "Die Empfindlichkeit gibt Cephable an, wie übertrieben ein Ausdruck sein muss, damit ein Steuerelement ausgelöst wird. Je größer der Wert (ganz rechts auf dem Schieberegler), desto höher ist die Empfindlichkeit und desto weniger müssen Sie sich bewegen, um das Steuerelement auszulösen.",
                "eyebrow": {
                    "title": "Empfindlichkeit der Augenbrauen",
                    "description": "Diese Werte bestimmen, wie weit Sie Ihre Augenbrauen heben oder senken müssen, um die Steuerung auszulösen",
                    "up": "Erhöhen Sie die Empfindlichkeit der Augenbrauen",
                    "scaleHigh": "Leichte Erhöhung",
                    "scaleLow": "Große Erhöhung"
                },
                "mouth": {
                    "title": "Mundempfindlichkeit",
                    "description": "Diese Werte bestimmen, wie weit Sie Ihren Mund öffnen oder schließen müssen, um Bedienelemente auszulösen",
                    "open": "Empfindlichkeit beim Öffnen des Mundes",
                    "close": "Empfindlichkeit bei geschlossenem Mund",
                    "smile": "Lächelempfindlichkeit",
                    "scaleHigh": "Leicht geöffnet",
                    "scaleLow": "Großes offenes",
                    "closeScaleHigh": "Leicht geschlossen",
                    "closeScaleLow": "Dicht verschlossen",
                    "smileScaleHigh": "Leichtes Lächeln",
                    "smileScaleLow": "Großes Lächeln"
                }
            },
            "mouse": {
                "title": "Kopfbewegung zur Maussteuerung",
                "description": "Legen Sie fest, ob und wie Sie zum Bewegen der Maus Kopfbewegungssteuerungen verwenden möchten, anstatt andere Ausgaben auszulösen.",
                "enable": {
                    "title": "Kopfbewegung für Maussteuerung aktivieren",
                    "description": "Wenn dies eingeschaltet ist, werden einige Ihrer Kopfbewegungssteuerelemente anstelle der Triggersteuerelemente zum Bewegen Ihrer Maus verwendet.",
                    "option": "Kopfsteuerung für Mausbewegungen verwenden?"
                },
                "input": {
                    "title": "Mauseingabetyp",
                    "description": "Wählen Sie aus, welche Art von Kopfgesten Sie der Maussteuerung zuweisen möchten. Beispielsweise bedeutet Kopfneigen, dass Sie Ihren Kopf nach links und rechts neigen können, um die Maus nach links und rechts zu bewegen, Kopfdrehen bedeutet, dass Sie Ihren Kopf nach links und rechts drehen können, um die Maus zu bewegen, und Kopfneigen bedeutet, dass Sie sich nach links und rechts neigen können, um die Maus zu bewegen.",
                    "option": "Eingabetyp auswählen",
                    "optionLong": "Wählen Sie die Art der Kopfbewegung aus, die Sie zur Steuerung Ihrer Maus verwenden möchten."
                },
                "invert": {
                    "title": "Mausbewegung umkehren",
                    "description": "Wenn diese Option aktiviert ist, wird die Richtung, in die Sie Ihren Kopf bewegen, umgekehrt zur Richtung, in die Sie Ihre Maus bewegen. Für die X-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach links Ihre Maus nach rechts und eine Bewegung nach rechts nach links. Für die Y-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach unten Ihre Maus nach oben und eine Bewegung nach oben nach unten.",
                    "x": "Mausbewegung auf der X-Achse umkehren?",
                    "y": "Mausbewegung auf der Y-Achse umkehren?"
                },
                "mode": {
                    "title": "Mausbewegungsmodus",
                    "description": "Wählen Sie aus, wie der Cursor auf Ihre Kopfbewegungen reagieren soll."
                },
                "speed": {
                    "title": "Mausgeschwindigkeit",
                    "description": "Bestimmen Sie die konstante Geschwindigkeit, mit der sich der Cursor bewegen soll.",
                    "fast": "Schnell",
                    "slow": "Langsam"
                },
                "linear": {
                    "title": "Lineare Mausbewegung",
                    "description": "Wenn diese Option aktiviert ist, bewegt sich der Cursor nur in geraden horizontalen oder vertikalen Linien. Dies erleichtert die Navigation in diese spezifischen Richtungen ohne diagonale Abweichungen.",
                    "option": "Lineare Mausbewegung verwenden?"
                },
                "accelerationRate": {
                    "title": "Reaktionsverzögerung bei Mausbeschleunigung",
                    "description": "Die Anzahl der Millisekunden, die zum Erhöhen der Mausgeschwindigkeit benötigt wird."
                },
                "accelerationCurve": {
                    "title": "Mausbeschleunigungskurve",
                    "description": "Passen Sie die Rate an, mit der die Cursorgeschwindigkeit im Verhältnis zur Kopfbewegung zunimmt.",
                    "linear": "Linear",
                    "exponential": "Exponentiell",
                    "sublinear": "Unterlinear"
                },
                "maximumSpeed": {
                    "title": "Maximale Mausgeschwindigkeit",
                    "description": "Bestimmen Sie die maximale Anzahl an Pixeln, die sich der Cursor pro Sekunde bewegen kann."
                },
                "off": {
                    "title": "Aus",
                    "description": "Die Mausbewegung ist deaktiviert."
                },
                "steadyGlide": {
                    "title": "Gleichmäßiges Gleiten",
                    "description": "Wenn Sie Ihren Kopf über einen bestimmten Punkt hinaus bewegen, gleitet der Cursor kontinuierlich mit gleichmäßiger Geschwindigkeit in diese Richtung."
                },
                "speedBoost": {
                    "title": "Geschwindigkeitsschub",
                    "description": "Der Cursor bewegt sich schneller, je länger Sie Ihren Kopf in einer Position halten. Je länger Sie Ihren Kopf still halten, desto schneller beschleunigt der Cursor."
                },
                "dynamicGlide": {
                    "title": "Dynamisches Gleiten",
                    "description": "Die Geschwindigkeit des Cursors erhöht sich, je weiter Sie Ihren Kopf bewegen. Je weiter Sie Ihren Kopf bewegen, desto schneller gleitet der Cursor."
                },
                "proportionalSpeed": {
                    "title": "Proportionale Geschwindigkeit",
                    "description": "Der Cursor folgt Ihrer Nasenspitze proportional zu Ihren Bildschirmabmessungen."
                },
                "disabled": "Diese Funktion ist für Remote-Verbindungen und Nebenstellen deaktiviert."
            }
        },
        "stop": "Kamera stoppen",
        "show": "Kamera anzeigen",
        "hide": "Kamera ausblenden",
        "warn": "Die Kamerasteuerung wurde nicht gestartet. Starten Sie Ihre Kamera, um die Gesichts- und Körpersteuerung zu ermöglichen.",
        "draw": {
            "error": "Fehler beim Laden des Kamera-Feeds. Bitte überprüfen Sie Ihre Kamera und versuchen Sie es erneut."
        },
        "select": "Wählen Sie eine Kamera aus, mit der Sie eine Verbindung herstellen möchten, um erweiterte Steuerfunktionen über Ihr Gesicht, Ihren Körper und die Schnellaktionstasten zu erhalten.",
        "extension": {
            "title": "Erweiterung: Kamera",
            "enabledTitle": "Kamerasteuerung aktivieren",
            "enabledDescription": "Wenn diese Einstellung aktiviert ist, verwendet Cephable Ihre Kamera, um Ihre Gesichts- und Kopfbewegungen zu erkennen, damit Sie Ihr Gerät mit Mimik und Gestik steuern können, einschließlich der Verwendung Ihrer Kopfbewegungen als Maus."
        },
        "live": "LIVE",
        "paused": "Kamera angehalten"
    },
    "microphone": {
        "windowTitle": "Cephable-Sprachsteuerung",
        "title": "Mikrofon",
        "titlePlural": "Mikrofone",
        "settings": "Mikrofoneinstellungen",
        "start": "Mikrofon starten",
        "stop": "Mikrofon stoppen",
        "descriptionShort": "Ermöglicht Sprachbefehle und Diktate.",
        "description": "Verwenden Sie Ihr eingebautes Mikrofon, um Sprachsteuerung und Diktieren zu aktivieren.",
        "select": "Wählen Sie ein Mikrofon aus, das Sie für eine erweiterte Steuerung per Sprache koppeln möchten.",
        "empty": "Keine Mikrofone gefunden.",
        "search": "Suche nach Mikrofonnamen",
        "manage": {
            "title": "Klicken Sie hier, um Details zu Ihren Mikrofonen anzuzeigen und zu verwalten.",
            "description": ""
        },
        "permission": {
            "title": "Mikrofonberechtigungen erforderlich",
            "description": "Um die Sprachsteuerung nutzen zu können, müssen Sie Cephable die Berechtigung erteilen, Ihr Mikrofon zu verwenden.",
            "button": "Berechtigungseinstellungen öffnen",
            "no": "Kein Mikrofonzugriff",
            "help": "Cephable benötigt Zugriff auf Ihr Mikrofon, um Sprachsteuerungen verwenden zu können. Navigieren Sie zu <strong>Systemeinstellungen</strong> > <strong>Datenschutz</strong> > <strong>Mikrofon</strong> und ermöglichen Sie Cephable den Zugriff auf Ihr Mikrofon."
        },
        "controls": {
            "loadingDetail": "Dies kann einige Minuten dauern.",
            "pause": "Sprachsteuerung pausieren",
            "paused": "Steuerung angehalten.",
            "resume": "Sprachsteuerung fortsetzen",
            "dictationPlay": "Diktiermodus starten",
            "dictationPause": "Diktiermodus beenden",
            "prompt": "Beginnen Sie zu sprechen, um hier Ihre Sprachsteuerung anzuzeigen …",
            "dictationPrompt": "Beginnen Sie zu sprechen, um einzutippen, was Sie sagen möchten …",
            "latency": "Hohe Latenz erkannt. Schließen Sie ggf. einige Anwendungen, die möglicherweise zu viele Ressourcen verbrauchen.",
            "noDeviceConnectedDescription": "Die Mikrofonsteuerung dient als Vorschau der Oberfläche. Es werden keine Schritte erfolgreich ausgeführt. Verbinden Sie dieses Begleitgerät mit einem anderen, um Befehle auszulösen.",
            "status": {
                "loadingModel": "Sprachmodell wird geladen …",
                "paused": "Angehalten.",
                "dictating": "Diktieren.",
                "optimistic": "Optimistisch:",
                "listening": "Hören:",
                "thinking": "Denken...",
                "loadingPhiModel": "Textgenerierungsmodell wird geladen …",
                "generatingText": "Generieren...",
                "preparingPhiModel": "Textgenerierungsmodell wird vorbereitet ...",
                "permission": "Mikrofonberechtigungen werden überprüft …",
                "typing": "Tippen..."
            },
            "generatingTextDetail": "Stoppen Sie die Generierung, indem Sie Apps ändern oder „Stoppen Sie die Generierung“ sagen.",
            "command": "Befehl",
            "contextual": "Kontextuell",
            "send": "Schicken",
            "typedInputLabel": "Geben Sie einen Befehl oder Text zum Senden ein",
            "listeningPlaceholder": "Hören...",
            "dictationListeningPlaceholder": "Hören...",
            "pausedPlaceholder": "Die Stimme verstummte..."
        },
        "edit": {
            "title": "Mikrofoneinstellungen bearbeiten",
            "autoStart": {
                "title": "Automatisches Startmikrofon",
                "option": "Automatisches Startmikrofon",
                "description": "Die Sprachsteuerung wird beim Einschalten des Geräts automatisch erkannt. Falls deaktiviert, tippen Sie auf „Zuhören starten“, um die Funktion zu aktivieren."
            },
            "optimistic": {
                "title": "Optimistische, schnellere Sprachsteuerung",
                "option": "Optimistische, schnellere Sprachsteuerung",
                "description": "Macht die Sprachsteuerung schneller und reaktionsfreudiger, aber weniger fehlertolerant. Verwenden Sie den Standardmodus, wenn Sie Diktierfunktion oder mehr Flexibilität wünschen. Hinweis: Der optimistische Modus kann versehentlich aktiviert werden, wenn Sie Befehle nicht exakt aussprechen."
            },
            "confirm": {
                "title": "Sie haben nicht gespeicherte Änderungen.",
                "description": "Es wurden nicht gespeicherte Änderungen erkannt. Möchten Sie vor dem Beenden speichern?"
            },
            "aiCommands": {
                "title": "Intelligente Sprachbefehle",
                "description": "Sagen Sie Befehle ganz natürlich – Cephable AI erkennt, was Sie meinen, ohne dass eine exakte Übereinstimmung erforderlich ist.",
                "option": "Intelligente Sprachbefehle"
            },
            "aiDictation": {
                "title": "Intelligentes Diktieren und Schnelltippen",
                "description": "Verbesserte Spracherkennung mit automatischer Zeichensetzung, Eigennamen und Satzstruktur. Sagen Sie „[beliebigen Text] eingeben“, um Quick Type für eine intelligentere und natürlichere Diktierfunktion zu nutzen.",
                "option": "Intelligente Diktierfunktion und Schnelleingabe"
            },
            "description": "Verwalten Sie Ihre Sprachbefehle und Diktiereinstellungen für diese Verbindung."
        },
        "warn": "Ihr Mikrofon wurde nicht gestartet. Starten Sie das Mikrofon, um Sprachbefehle und Diktate zu ermöglichen.",
        "devices": {
            "error": "Mikrofon-Eingabegerät nicht gefunden."
        },
        "startDescription": "Schalten Sie das Mikrofon ein, um mit dem Anhören von Befehlen zu beginnen.",
        "modes": {
            "title": "Modus",
            "generate": {
                "label": "Erzeugen",
                "placeholder": "Beschreiben Sie, was Sie generieren möchten."
            },
            "rewrite": {
                "label": "Umschreiben",
                "placeholder": "Wie soll ich den Text umschreiben?"
            },
            "translate": {
                "label": "Übersetzen",
                "placeholder": "In welche Sprache übersetzen?"
            },
            "automate": {
                "label": "Automatisieren",
                "placeholder": "Beschreiben Sie die Schritte, die Sie automatisieren möchten."
            },
            "auto": {
                "label": "Auto",
                "placeholder": "Geben Sie etwas ein – Cephable wählt den besten Modus.",
                "upgrade": "Cephable benötigt {{tier}}, um diese Aktion auszuführen."
            },
            "control": {
                "label": "Kontrolle",
                "placeholder": "Geben Sie einen Befehl oder Text zum Senden ein"
            }
        },
        "context": {
            "add": "Kontext hinzufügen",
            "title": "Kontext hinzufügen",
            "highlighted": "Hervorgehobener Text",
            "clipboard": "Klemmbrett",
            "other": "Andere…",
            "otherTitle": "Benutzerdefinierten Kontext hinzufügen",
            "otherPlaceholder": "Geben Sie den zu verwendenden Kontext ein oder fügen Sie ihn ein.",
            "otherConfirm": "Hinzufügen",
            "otherCancel": "Stornieren",
            "remove": "Kontext entfernen",
            "required": "Für {{mode}} ist ein Kontext erforderlich.",
            "files": "Dateien…",
            "folders": "Ordner…",
            "removeAttachment": "Anhang entfernen",
            "dropToAttach": "Ziehen Sie Dateien oder Ordner per Drag & Drop, um sie als Kontext anzuhängen."
        }
    },
    "localization": {
        "title": "Spracheinstellungen",
        "titleShort": "Sprache",
        "description": "Wählen Sie Ihre bevorzugte Sprache aus einer Liste unterstützter Sprachen aus.",
        "newUserDescription": "Bitte wählen Sie eine bevorzugte Sprache aus, bevor Sie fortfahren.",
        "edit": "Sprache aktualisieren",
        "display": {
            "title": "Anzeigesprache",
            "description": "Sprache, die bei der Verwendung von Cephable angezeigt wird. Dazu gehören Dinge wie Menüs, Benachrichtigungen und App-Steuerelemente, die in der Sprache Ihrer Wahl angezeigt werden."
        },
        "voice": {
            "title": "Sprache für die Sprachsteuerung",
            "description": "Dies ist die Sprache, die bei der Erkennung von Diktaten und Sprachbefehlen verwendet wird. Durch die Angabe der Sprache wird die Genauigkeit Ihrer Spracheingaben verbessert.",
            "settings": {
                "title": "Spracherkennung und Anzeigesprache",
                "description": "Passen Sie Ihre Spracheinstellungen für Anzeige und Sprachsteuerung an. Mit dieser Option können Sie Ihre bevorzugten Sprachen für Bildschirmtext und Mikrofoninteraktionen wie Sprachsteuerung und Diktierfunktion auswählen."
            }
        },
        "locales": {
            "en": "English - Englisch",
            "en-us": "English (US) - Englisch (US)",
            "es": "Español — Spanisch",
            "fr": "Français – Französisch",
            "it": "Italiano – Italienisch",
            "de": "Deutsch",
            "ja": "日本語 - Japanisch",
            "en-gb": "English (UK) - Englisch (UK)",
            "en-in": "English (India) - Englisch (Indien)"
        },
        "save": {
            "success": "Benutzer-Gebietsschemaeinstellungen gespeichert!",
            "error": "Fehler beim Speichern der Gebietsschemaeinstellungen des Benutzers"
        },
        "profile": {
            "view": "Varianten",
            "title": "App-Steuerungssprache",
            "question": "Welche App-Steuerungssprache möchten Sie bearbeiten?",
            "description": "Einige App-Steuerelemente bieten Varianten für verschiedene Sprachen. Wechseln Sie zu einer anderen Sprache, um die Einstellungen zu bearbeiten und anzupassen.",
            "change": "Sprache ändern"
        },
        "unsupported": {
            "title": "Nicht unterstützte Sprache {{locale}}",
            "description": "Die ausgewählte Sprache wird nicht unterstützt. Bitte wählen Sie eine andere Sprache."
        },
        "select": "Sprache auswählen",
        "localesShort": {
            "en": "Englisch",
            "en-us": "Englisch (USA)",
            "es": "Spanisch",
            "fr": "Französisch",
            "it": "Italienisch",
            "de": "Deutsch",
            "ja": "japanisch",
            "en-gb": "Englisch (UK)",
            "en-in": "Englisch (Indien)"
        }
    },
    "license": {
        "trial": {
            "subtitle": "Sie können {{count}} Kollegen einladen, Cephable mit Ihnen auszuprobieren.",
            "noUsersSubtitle": "Sie haben keine Testbenutzer mehr. Aktualisieren Sie auf eine kostenpflichtige Lizenz, um weitere Benutzer hinzuzufügen.",
            "expired": {
                "user": "Ihr kostenloses Upgrade auf {{productName}} läuft am {{date}} ab. Um ein Upgrade durchzuführen, wenden Sie sich bitte an Ihren Organisationsadministrator – {{admin}}.",
                "admin": "Ihr kostenloses Upgrade auf {{productName}} läuft am {{date}} ab.",
                "userLong": "Ihr kostenloses Upgrade auf {{productName}} ist abgelaufen. Um ein Upgrade durchzuführen, wenden Sie sich bitte an Ihren Organisationsadministrator – {{admin}}.",
                "adminLong": "Ihr kostenloses Upgrade auf {{productName}} ist abgelaufen. Sie können Ihre Lizenz upgraden, um weiterhin auf erweiterte Funktionen zuzugreifen, die in Cephable Basic nicht verfügbar sind."
            },
            "start": "Kostenlose Testversion starten",
            "title": {
                "single": "Sie wurden kostenlos auf {{productName}} mit {{days}} verbleibenden Tagen aktualisiert.",
                "multiple": "{{organization}} ist in einer kostenlosen Testversion mit {{days}} verbleibenden Tagen"
            },
            "upgrade": "Behalten Sie durch das Upgrade Ihren Zugriff auf Funktionen wie erweiterte Sprachsteuerung, intelligente KI-Aufgaben und viele vorgefertigte App-Steuerungen."
        },
        "required": {
            "title": "Eine Cephable Professional-Lizenz ist erforderlich",
            "description": "Sie verwenden offenbar Cephable Basic. Die kommerzielle Nutzung von Cephable wird jedoch nicht unterstützt. Bitte aktualisieren Sie auf eine professionelle Lizenz, um die App weiterhin nutzen zu können."
        },
        "upgrade": {
            "professional": "Upgrade auf die Cephable Professional-Lizenz",
            "generic": {
                "title": "Verbessern Sie Ihr Cephable-Erlebnis",
                "description": "Die Cephable-Plattform bietet verschiedene Produkte für den kommerziellen Einsatz am Arbeitsplatz, in der Schule oder integriert in native Lösungen."
            },
            "fallback": {
                "title": "Fehler beim Laden des Abrechnungsportals",
                "description": "Das Abrechnungsportal konnte nicht geladen werden. Klicken Sie bitte auf die Schaltfläche unten, um sales@cephable.com zu kontaktieren und mit dem Upgrade fortzufahren."
            }
        },
        "activate": {
            "question": "Sie haben bereits einen Lizenzschlüssel?",
            "button": "Aktivieren",
            "title": "Lizenzschlüssel Aktivieren",
            "description": "Geben Sie Ihren Lizenzschlüssel ein, um Cephable zu aktualisieren. Wenn Sie keinen haben, starten Sie eine kostenlose Testversion oder erwerben Sie eine Lizenz.",
            "fieldLabel": "Lizenzschlüssel",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "success": "Glückwunsch. Ihr Konto wurde auf {{license}} aktualisiert!",
            "invalid": {
                "key": "Ungültiger Schlüssel. Bitte stellen Sie sicher, dass Sie den richtigen Schlüssel eingegeben haben.",
                "empty": {
                    "key": "Ungültiger Schlüssel. Bitte stellen Sie sicher, dass Sie einen Wert eingegeben haben.",
                    "name": "Ungültiger Organisationsname. Bitte stellen Sie sicher, dass Sie einen Wert eingegeben haben."
                }
            },
            "descriptionLong": "Geben Sie Ihren Lizenzschlüssel ein, um Cephable zu aktualisieren. Wenn Sie keinen haben, starten Sie eine kostenlose Testversion oder erwerben Sie eine Lizenz."
        },
        "welcome": {
            "title": "Willkommen bei {{license}}.",
            "description": "Sie sind {{organization}} erfolgreich beigetreten. {{description}}"
        },
        "redirect": {
            "title": "Umleitung",
            "description": "Sie wurden zu einem externen Abrechnungsportal weitergeleitet. In Ihrem Browser wird ein neuer Tab geöffnet. Wenn Sie nicht innerhalb weniger Sekunden weitergeleitet werden, klicken Sie bitte auf die Schaltfläche unten.",
            "error": "Fehler bei der Rechnungsumleitung",
            "external": "Sie wurden weitergeleitet. Bitte überprüfen Sie Ihren Browser."
        },
        "key": {
            "title": "Lizenzschlüssel",
            "titlePlural": "Lizenzschlüssel",
            "description": "Ein Lizenzschlüssel ist eine eindeutige Kennung, die zum Gewähren des Zugriffs auf die Funktionen „Cephable Professional“, „Education“ oder „Developer“ verwendet wird.",
            "details": "Details zum Lizenzschlüssel",
            "assigned": "Verwendet am: {{date}}",
            "expires": "Läuft ab am: {{date}}",
            "assign": "Schlüssel einer neuen Organisation zuweisen",
            "error": "Fehler beim Laden des Lizenzschlüssels.",
            "empty": {
                "title": "Keine Lizenzschlüssel gefunden.",
                "description": "Es scheint, als gäbe es keine Lizenzschlüssel, die diesen Kriterien entsprechen. Oder Sie haben noch keinen Lizenzschlüssel erworben."
            },
            "product": {
                "title": "Kaufen",
                "titleLong": "Lizenzschlüssel kaufen",
                "description": "Erwerben Sie einen Lizenzschlüssel, um das volle Potenzial von Cephable auszuschöpfen. Sehen Sie sich die verschiedenen verfügbaren Pläne und Preisoptionen an.",
                "action": "Jetzt kaufen",
                "empty": {
                    "title": "Keine Produkte gefunden.",
                    "description": "Es sieht so aus, als hätten Sie keine Produkte. Bitte wenden Sie sich an unser Vertriebsteam oder Ihren Vertreter, um das Problem zu lösen."
                },
                "yearly": "Jährliche Abrechnung",
                "years": "Abrechnung alle {{value}} Jahre",
                "days": "Abrechnung alle {{value}} Tage",
                "Subscription": {
                    "title": "Abonnement"
                },
                "MeteredConsumption": {
                    "title": "Gemessener Verbrauch"
                },
                "PayDown": {
                    "title": "Rückzahlung"
                },
                "OneTime": {
                    "title": "Einmalig"
                }
            }
        },
        "pro": {
            "tag": "Pro",
            "detail": "Dies ist eine Funktion, die nur Cephable Professional bietet.",
            "requiredDetail": "Für diese Funktion ist eine Cephable Professional-Lizenz erforderlich. Sie können in Ihren Kontoeinstellungen ein Upgrade durchführen oder eine kostenlose Testversion starten."
        },
        "titlePlural": "Lizenzen"
    },
    "purchase": "Kaufen",
    "saveError": "Fehler beim Speichern der Änderungen.",
    "description": "Beschreibung",
    "expand": "Expandieren",
    "expandMenu": "Menü erweitern",
    "editor": {
        "title": "Markdown-Editor",
        "bold": "Deutlich",
        "italic": "Kursiv",
        "underline": "Unterstreichen",
        "hr": "Horizontale Regel",
        "link": "Link",
        "quote": "Zitat",
        "code": "Code",
        "codeBlock": "Codeblock",
        "comment": "Kommentar",
        "image": "Bild",
        "table": "Tisch",
        "unordered-list": "Ungeordnete Liste",
        "ordered-list": "Sortierte Liste",
        "checked-list": "Prüfliste",
        "help": "Helfen",
        "edit": "Bearbeiten",
        "live": "Live",
        "preview": "Vorschau",
        "fullscreen": "Vollbild",
        "placeholder": "Bitte geben Sie hier Markdown-Text ein ...",
        "strikethrough": "Durchgestrichen"
    },
    "created": "Erstellt: {{value}}",
    "updated": "Aktualisiert: {{value}}",
    "deleted": "Gelöscht: {{value}}",
    "expires": "Läuft ab: {{value}}",
    "expired": "Abgelaufen: {{value}}",
    "used": "Verwendet: {{value}}",
    "results": "Ergebnisse",
    "panel": {
        "title": "Cephable-Panel",
        "question": "Autostart-Panel?",
        "position": {
            "top": "Spitze",
            "right": "Rechts",
            "left": "Links",
            "bottom": "Unten ",
            "description": "Wählen Sie aus, wo das Cephable Panel auf Ihrem Bildschirm angezeigt werden soll.",
            "label": "Position"
        },
        "sections": {
            "description": "Wählen Sie aus, welche Abschnitte im Bedienfeld sichtbar sein sollen. Sie können Abschnitte nach Ihren Wünschen ausblenden, um den Platz im Bedienfeld optimal zu nutzen.",
            "microphone": "Mikrofon- und Sprachsteuerung",
            "camera": "Kamera- und Gesichts-/Kopfsteuerung",
            "profile": "App-Steuerung und Vorschau",
            "globalControls": "Globale und Gerätesteuerungen",
            "tasks": "Intelligente Aufgaben",
            "buttons": "Schnellaktionsschaltflächen"
        },
        "titleShort": "Panel",
        "description": "Dies ist das Bedienfeld, das als Hauptsteuerungszentrale dient. Es ist immer sichtbar und ermöglicht Ihnen unter anderem die Steuerung Ihrer Apps per Sprachbefehl.",
        "reconnecting": "Verbindung wird wiederhergestellt…",
        "reconnectRetry": "Wiederholen"
    },
    "resume": "Wieder aufnehmen",
    "textGeneration": {
        "settings": "Einstellungen zur Textgenerierung",
        "edit": {
            "title": "Einstellungen für die Textgenerierung bearbeiten",
            "description": "Sie können die Einstellungen für Ihre intelligente Textgenerierung verfeinern, um die für Sie besten Ergebnisse zu erzielen.",
            "autoStart": {
                "title": "Automatisches Aufwärmen der Textgenerierung",
                "description": "Ist diese Einstellung aktiviert, wärmt Cephable AI die für Erstellungs- oder Automatisierungsaufgaben verwendeten KI-Modelle automatisch auf. Dadurch werden die Modelle schneller ausgeführt, verbrauchen aber mehr Systemressourcen. Durch Deaktivieren dieser Einstellung werden Ressourcen gespart, die Aufgaben können jedoch langsamer ausgeführt werden.",
                "option": "Automatisches Aufwärmen von KI-Modellen zur Textgenerierung?"
            },
            "prompt": {
                "title": "Zusätzliche Informationen zur Textgenerierung",
                "description": "Geben Sie zusätzliche Details ein, die mit der KI von Cephable zur Textgenerierung verwendet werden sollen. Nutzen Sie dieses Feld, um Ihre Präferenzen für Ton, Schreibstil oder andere Details einzugeben.",
                "field": "Zusätzliche Eingabeaufforderung",
                "placeholder": "Verwenden Sie beispielsweise einen freundlichen Ton, schreiben Sie professionell, seien Sie prägnant und auf den Punkt. Hinterlassen Sie beim Schreiben von Code durchdachte, aber nicht zu viele Kommentare usw."
            },
            "enableTextGen": {
                "title": "Intelligente Textgenerierung aktivieren",
                "description": "Wenn diese Einstellung aktiviert ist, kann Cephable AI Inhalte entwerfen, umschreiben, zusammenfassen und übersetzen oder Desktop-Aktionen in Ihren Apps automatisieren.",
                "option": "Intelligente Textgenerierung verwenden?"
            },
            "terminate": {
                "title": "Clear AI Resources",
                "description": "Klicken Sie hier, um die für Erstellungs- oder Automatisierungsaufgaben verwendeten Ressourcen freizugeben. Dadurch werden Ressourcen auf Ihrem Computer freigegeben, die Aufgaben können jedoch beim nächsten Aufruf langsamer ausgeführt werden.",
                "button": "Ressourcen löschen",
                "success": "Ressourcen zur Textgenerierung löschen.",
                "confirm": {
                    "title": "Clear AI Resources",
                    "description": "Möchten Sie wirklich die für Erstellungs- oder Automatisierungsaufgaben verwendeten Ressourcen freigeben? Dadurch werden zwar Ressourcen auf Ihrem Computer freigegeben, die Aufgaben können sich jedoch beim nächsten Mal verlangsamen.",
                    "confirm": "Ja, klare Ressourcen",
                    "cancel": "Stornieren"
                }
            },
            "clearModelCache": {
                "title": "KI-Modell-Cache löschen",
                "description": "Dadurch wird Speicherplatz auf Ihrem Computer freigegeben und das aktuell ausgewählte Modell erneut heruntergeladen.",
                "button": "Löschen und erneut herunterladen",
                "success": "Lokale Modelldateien gelöscht.",
                "confirm": {
                    "title": "KI-Modellcache löschen und neu herunterladen",
                    "description": "Möchten Sie den Cache des KI-Modells wirklich leeren und die Dateien von Ihrem System löschen? Das aktuell ausgewählte Modell wird automatisch erneut heruntergeladen.",
                    "confirm": "Ja, löschen und erneut herunterladen.",
                    "cancel": "Stornieren"
                },
                "error": "Fehler beim Löschen lokaler Modelldateien."
            },
            "enableHistory": {
                "title": "Textgenerierungsverlauf aktivieren",
                "description": "Wenn diese Einstellung aktiviert ist, verwendet Cephable AI Ihren Textgenerierungsverlauf, um Text im Kontext Ihrer vorherigen Aktion zu generieren.",
                "option": "Textgenerierungsverlauf verwenden?"
            },
            "modelSelection": {
                "title": "KI-Modell",
                "description": "Wählen Sie die KI-Modellfamilie und -größe, die auf diesem Gerät ausgeführt werden kann. Größere Modelle liefern bessere Ergebnisse, benötigen aber mehr Ressourcen. Laden Sie mehrere Modelle herunter, um schnell zwischen ihnen wechseln zu können.",
                "family": "Modellfamilie",
                "size": "Modellgröße",
                "downloaded": "Heruntergeladen",
                "downloading": "Wird heruntergeladen…",
                "download": "Herunterladen",
                "delete": "Download löschen",
                "unavailable": "Auf diesem Gerät nicht unterstützt.",
                "requiresBetterDevice": "Für dieses Modell wird ein leistungsfähigeres Gerät benötigt.",
                "selectPrompt": "Wählen Sie ein Modell aus",
                "noModels": "Für dieses Gerät sind noch keine kompatiblen Modelle verfügbar.",
                "deleteConfirm": {
                    "title": "Heruntergeladenes Modell löschen?",
                    "description": "Dadurch wird Speicherplatz freigegeben. Sie können es später erneut herunterladen."
                },
                "notDownloaded": "Dieses Modell ist ausgewählt, aber noch nicht heruntergeladen. Klicken Sie auf „Herunterladen“, um es zu verwenden.",
                "readyToUse": "Heruntergeladen – sofort einsatzbereit",
                "offlineNoModels": "Sie sind offline und es sind noch keine Modelle auf diesem Gerät gespeichert. Stellen Sie eine Internetverbindung her, um verfügbare Modelle anzuzeigen und herunterzuladen.",
                "offlineDownloadUnavailable": "Sie sind offline, daher kann dieses Modell nicht heruntergeladen werden. Stellen Sie eine Internetverbindung her, um es herunterzuladen, oder wechseln Sie zu einem bereits heruntergeladenen Modell.",
                "license": {
                    "upgrade": "Erfordert ein Lizenz-Upgrade",
                    "blockedNeedsDownload": "Für dieses Modell ist eine {{license}} erforderlich. Laden Sie ein älteres Modell herunter oder führen Sie ein Upgrade durch, um fortzufahren."
                },
                "notEnoughSpace": "Nicht genügend Speicherplatz auf dem Gerät",
                "notEnoughSpaceDetail": "Es wird {{required}} benötigt, aber auf diesem Gerät ist nur {{free}} frei. Geben Sie Speicherplatz frei und versuchen Sie es erneut.",
                "fallback": {
                    "alert": "Es wird {{fallback}} anstelle von {{preferred}} verwendet, wofür ein Upgrade erforderlich ist.",
                    "active": "{{preferred}} erfordert {{license}}. {{fallback}} wird stattdessen verwendet, bis Sie ein anderes Modell auswählen oder ein Upgrade durchführen."
                }
            }
        },
        "prompt": {
            "systemPrompt": "Generieren Sie AUSSCHLIESSLICH den angeforderten Text – keine Erklärungen, Kommentare oder sonstige Zusätze. Kein unaufgefordertes Markdown oder Erläuterungen. Geben Sie bei Code ausschließlich den Rohcode aus: keine Codeblöcke, keine Sprachkennzeichnungen, keine Erläuterungen. Erklären Sie nicht, was Sie getan haben.",
            "appName": "Sie generieren derzeit Text für {{appName}}.",
            "userPreferences": "Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}."
        },
        "translatePrompt": {
            "systemPrompt": "Übersetzen Sie den folgenden Text in {{language}}. Geben Sie NUR den übersetzten Text aus. Keine Erklärungen, keine Einleitung, keine Markdown-Formatierung, keine Codeblöcke, keine Anmerkungen, keine Kommentare zur Übersetzung in Klammern. Formatierung beibehalten. Für Code: Nur Kommentare und Zeichenketten übersetzen, Syntax exakt beibehalten.",
            "userPreferences": "Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}.",
            "genericUserPrompt": "Übersetzen: {{userRequestText}}"
        },
        "disabled": {
            "title": "Intelligente Aufgaben sind deaktiviert",
            "description": "Sie haben anscheinend intelligente Aufgaben deaktiviert. Aktualisieren Sie Ihre Einstellungen, um Textgenerierung, Textumschreibung und weitere Funktionen freizuschalten."
        },
        "skipTyping": {
            "complete": "Die Generierung ist abgeschlossen und das Paket kann in die Zwischenablage kopiert werden."
        },
        "summarizePrompt": {
            "systemPrompt": "Fassen Sie den bereitgestellten Text prägnant zusammen. Er kann Teil eines längeren Dokuments sein. Verwenden Sie keine Markdown-Formatierung oder Codeblöcke. Geben Sie NUR die Zusammenfassung aus – keine Einleitung, Beschriftungen, Erklärungen oder Kommentare. Erläutern Sie auch nicht, was Sie getan haben.",
            "userPreferences": "Beachten Sie diese Benutzereinstellungen für die Textgenerierung: {{userPreferences}}.",
            "summarizeInstructions": "Anleitung: {{summarizeInstructions}}.",
            "userPrompt": "Zusammenfassend: {{userRequestText}}"
        },
        "rewritePrompt": {
            "systemPrompt": "Schreiben oder formatieren Sie den bereitgestellten Text gemäß den Anweisungen um. Bei der Umformatierung (z. B. Listen, Tabellen, Strukturänderungen) behalten Sie den ursprünglichen Wortlaut exakt bei. Bei der Überarbeitung (z. B. Tonfall, Stil, Länge) behalten Sie die Bedeutung, aber nicht unbedingt den Wortlaut. Dies kann Teil eines größeren Dokuments sein. Passen Sie die Formatierung der Eingabe an: Wenn der Quelltext bereits Markdown oder Code ist, behalten Sie diese bei. Fügen Sie andernfalls keine Markdown-Formatierung (Überschriften, Fettdruck, Aufzählungszeichen, Codeblöcke) hinzu, es sei denn, die Anweisungen fordern ausdrücklich eine Liste, Tabelle oder eine ähnliche Struktur an. Geben Sie NUR das Ergebnis aus – keine Einleitung, Beschriftungen, Überschriften, Erklärungen oder Kommentare.",
            "userPreferences": "Beachten Sie diese Benutzereinstellungen für die Textgenerierung: {{userPreferences}}.",
            "rewriteInstructions": "Anweisungen: {{rewriteInstructions}}."
        }
    },
    "profile": {
        "title": "App-Steuerung",
        "titlePlural": "App-Steuerung",
        "titlePreview": "Vorschau der Steuerelemente",
        "previous": "Vorherige App-Steuerelemente",
        "manage": "App-Steuerelemente verwalten",
        "view": "Steuerelemente anzeigen",
        "edit": "App-Steuerelemente bearbeiten",
        "add": "App-Steuerelemente hinzufügen",
        "create": "App-Steuerelemente erstellen",
        "warn": "Um Ihre App-Steuerung verwenden zu können, müssen Kamera oder Mikrofon gestartet sein.",
        "descriptionShort": "Entdecken Sie die verschiedenen Möglichkeiten, wie Cephable Ihnen bei der Steuerung Ihrer Geräte und Software hilft.",
        "name": "App-Name",
        "nameQuestion": "Wie möchten Sie diese App-Steuerelemente nennen?",
        "newName": "Neue App-Steuerelemente",
        "search": "App-Steuerelemente nach Namen durchsuchen",
        "searchLong": "Suchen Sie nach App-Steuerelementen nach Name oder Beschreibung",
        "keyboardAndMouse": "Tastatur und Maus",
        "genericController": "Gamepad-Controller",
        "keyboardMouseAndController": "Tastatur, Maus und Controller",
        "permissionError": "Sie haben keine Berechtigung, diese App-Steuerelemente zu verwenden.",
        "set": {
            "title": "Es sieht nicht so aus, als hätten Sie die App-Steuerung bereits eingerichtet.",
            "cta": "App-Steuerelemente festlegen",
            "empty": {
                "auto": "Wechseln Sie zu einer anderen App, um die Steuerelemente anzuzeigen",
                "select": "Wählen Sie ein Steuerelement aus, um zu beginnen",
                "none": "Keine App-Steuerelemente gefunden"
            },
            "description": "Mithilfe der App-Steuerung weiß Cephable, worauf es achten muss und welche Aktionen ausgeführt werden sollen. Sie können die App-Steuerung jederzeit von der Startseite oder über Ihre Verbindungseinstellungen ändern."
        },
        "summary": {
            "title": "Zusammenfassung der App-Steuerelemente",
            "descriptionLong": "Hier sind die Details dieser App-Steuerelemente. Sie können nach Steuerelementen, Aktionen und mehr suchen, um zu sehen, was Sie mit diesen App-Steuerelementen tun können.",
            "description": "Erhalten Sie eine Zusammenfassung dieser App-Steuerelemente, einschließlich der verfügbaren Steuerelemente, Anpassungsmöglichkeiten, Details und mehr.",
            "view": "Zusammenfassung der App-Steuerelemente anzeigen",
            "filter": "Filtern nach Eingabetyp",
            "placeholder": "Steuerelementnamen suchen ..."
        },
        "copy": {
            "title": "App-Steuerelemente kopieren",
            "duplicate": "Doppelte App-Steuerelemente",
            "question": "Eine Kopie erstellen?",
            "description": "Möchten Sie eine neue Kopie dieser App-Steuerelemente erstellen? Dadurch wird ein neues Fenster mit den kopierten App-Steuerelementen geöffnet. Die Kopie wird Ihrem Konto jedoch erst nach dem Speichern hinzugefügt.",
            "confirm": "Ja, Kopie erstellen",
            "profileSuffix": "{{name}} (Kopie)"
        },
        "new": {
            "title": "Neue App-Steuerelemente erstellen",
            "description": "Entwickeln Sie Steuerelemente von Grund auf neu oder lassen Sie modernste KI personalisierte Steuerelemente erstellen, sodass Sie mithilfe Ihrer Stimme, Ihres Kopfes und Ihrer Gesichtsbewegungen mühelos durch Apps und Software navigieren können.",
            "note": "Empfohlen für fortgeschrittene Benutzer.",
            "scratch": "Von Grund auf neu erstellen"
        },
        "advancedOptions": "Erweiterte Steuerungsoptionen",
        "delete": {
            "title": "App-Steuerelemente löschen",
            "titleLong": "Löschen Sie diese App-Steuerelemente",
            "description": "Sie können diese App-Steuerelemente löschen, indem Sie auf „App-Steuerelemente löschen“ klicken.",
            "confirm": "Möchten Sie diese App-Steuerelemente wirklich löschen?",
            "confirmLong": "Sobald Sie diese App-Steuerelemente gelöscht haben, können Sie nicht mehr darauf zugreifen. Möchten Sie diese App-Steuerelemente wirklich löschen?",
            "confirmButton": "Ja, diese App-Steuerelemente löschen"
        },
        "current": "Aktuelle Kontrollen",
        "loading": "Steuerelemente werden geladen …",
        "null": "Sie haben noch keine App-Steuerelemente. Klicken Sie unten, um eines zu erstellen.",
        "nullButton": "Erstellen Sie Ihre ersten App-Steuerelemente",
        "preview": "Vorschau",
        "features": "Merkmale",
        "byline_public": "Von: Cephable Team",
        "byline_shared": "Geteilt von: Cephable Community",
        "share": {
            "title": "App-Steuerelemente teilen",
            "previewTitle": "Vorschau der freigegebenen App-Steuerelemente",
            "description": "Geben Sie diese App-Steuerelemente an andere weiter, damit diese eine Kopie erhalten und diese dann personalisieren können!",
            "descriptionLong": "Teilen Sie diese App-Steuerelemente mit anderen, damit diese eine Kopie erhalten und sie anschließend personalisieren können! Wählen Sie aus, wie Sie die App teilen möchten, und erstellen Sie anschließend einen Link zum Senden an andere.",
            "add": "Einen Freigabelink erstellen",
            "confirm": "Teilen Sie diese URL",
            "link": "Link teilen",
            "copy": "Link kopieren",
            "copied": "Kopiert!",
            "usage": "Nutzungsmenge",
            "created": "Erstellt {{value}}",
            "expiration": {
                "title": "Ablauf",
                "once": "Nur eine Verwendung zulassen",
                "unlimited": "Unbegrenzte Nutzung zulassen",
                "no": "Kein Ablaufdatum",
                "date": "Verfallsdatum",
                "dateDescription": "Läuft an einem bestimmten Datum ab"
            },
            "manage": "Vorherige Freigabelinks verwalten",
            "empty": "Für diese App-Steuerelemente wurden keine Freigaben erstellt."
        },
        "swap": {
            "title": "Steuerelemente austauschen",
            "titleLong": "Tauschen Sie Ihre App-Steuerelemente aus",
            "descriptionShort": "Verwenden Sie unterschiedliche App-Steuerelemente, die zu dem von Ihnen verwendeten Programm oder der Software passen.",
            "description": "Sie können zwischen verschiedenen App-Steuerelementen wechseln, um sie an das von Ihnen verwendete Programm oder die von Ihnen verwendete Software anzupassen."
        },
        "autoProfileSwitching": {
            "title": "Automatische Steuerungsumschaltung",
            "alerts": {
                "disabled": "Die automatische Steuerungsumschaltung ist deaktiviert.",
                "temporarilyDisabled": "Die automatische Steuerungsumschaltung ist vorübergehend deaktiviert.",
                "enabled": "Die automatische Steuerungsumschaltung ist eingeschaltet.",
                "error": "Fehler beim Speichern der Einstellungen für die automatische Steuerungsumschaltung"
            },
            "associatedPrograms": {
                "add": "Ein neues zugehöriges Programm hinzufügen",
                "description": {
                    "personal": "Wählen Sie die Software oder Programme aus, die Sie mit diesen Steuerelementen verbinden möchten. Dies unterstützt die automatische Steuerungsumschaltung, bei der Cephable diese App-Steuerelemente automatisch an das aktuell verwendete Programm anpasst.",
                    "short": "Wählen Sie die Software oder Programme aus, die Sie mit diesen Steuerelementen verbinden möchten."
                },
                "edit": "Zugehörige Programme bearbeiten",
                "noOptionsText": "Beginnen Sie mit der Eingabe, um zugehörige Programme zu finden",
                "profileLabel": "App-Steuerung:",
                "remove": "Zugehöriges Programm entfernen",
                "title": "Zugehörige Programme",
                "when": "Cephable schaltet meine App-Steuerung automatisch auf {{profileName}} um, wenn ich … verwende.",
                "emptySearch": "Mit diesen Steuerelementen sind keine Programme verknüpft.",
                "error": "Fehler beim Speichern der zugehörigen Programme. Bitte versuchen Sie es später erneut.",
                "emptyError": "Leeres zugehöriges Programm erkannt. Bitte entfernen Sie es, bevor Sie fortfahren."
            },
            "commandOverlay": {
                "command": "App-Steuerung wechseln: {{value}}"
            },
            "description": "Durch die automatische Steuerungsumschaltung passt sich Cephable nahtlos an Ihren Arbeitsablauf an. Ist die Funktion aktiviert, passt Cephable Ihre App-Steuerung kontextbezogen an das verwendete Programm oder die verwendete Software an. Ist sie deaktiviert, können Sie die App-Steuerung manuell über die Schaltfläche „Steuerung tauschen“ oder über globale Befehle umschalten."
        },
        "error": {
            "noMatch": "Keine App-Steuerung entspricht Ihrer Suche.",
            "load": "Fehler beim Laden der App-Steuerelemente.",
            "add": "Fehler beim Hinzufügen der App-Steuerelemente.",
            "delete": "Fehler beim Löschen der App-Steuerelemente.",
            "audioEventsWithEmptyCommands": "In Ihrem Talkback fehlen Steuerelemente. Überprüfen Sie Ihre Talkback-Steuerelemente, um sicherzustellen, dass sie vollständig sind.",
            "conflicts": "Fehler beim Speichern der App-Steuerelemente aufgrund von Konflikten.",
            "save": "Fehler beim Speichern der App-Steuerung. Bitte versuchen Sie es erneut.",
            "device": "Ungültige App-Steuerung für diese Verbindung. Bitte versuchen Sie es mit einer anderen."
        },
        "conflictIndicators": {
            "errorTitle": "Fehler beim Speichern der App-Steuerelemente aufgrund von Konflikten",
            "warningTitle": "App-Steuerung mit Warnungen gespeichert",
            "subtitle": "Die von Ihnen erstellten App-Steuerelemente weisen einige Konfigurationen auf, die zu Konflikten führen können.",
            "profileNameErrors": "Namenskonflikt bei App-Steuerelementen",
            "emptyControlsMapped": "Leere Eingabenamen",
            "emptyControlsMappedDescription": "Bitte fügen Sie Ihrer Eingabe einen Sprachbefehl, einen Gesichtsausdruck, eine Kopfneigung oder einen anderen Befehl hinzu.",
            "emptyKeybindingControlsMapped": "Leere Eingabenamen für Tastenkombinationen",
            "emptyKeybindingControlsMappedDescription": "Bitte fügen Sie Ihrer Eingabe für Tastenkombinationen einen Sprachbefehl, einen Gesichtsausdruck, eine Kopfneigung oder einen anderen Befehl hinzu.",
            "duplicateNameTitle": "Doppelter Name der App-Steuerung",
            "duplicateNameDescription": "Sie verfügen über bereits vorhandene App-Steuerelemente mit demselben Namen. Bitte ändern Sie den Namen, bevor Sie fortfahren.",
            "emptyNameTitle": "Leerer Name der App-Steuerelemente",
            "emptyNameDescription": "Die App-Steuerelemente müssen einen Namen haben, z. B. Spiel 1, Spotify, Word usw.",
            "macrosReleaseKeysMissingTitle": "Ausgaben mit unveröffentlichten Schlüsseln",
            "macrosReleaseKeysMissingDescription": "Bitte fügen Sie einen Freigabeschlüssel hinzu oder stoppen Sie alle Schritte, um zu verhindern, dass Schlüssel hängen bleiben.",
            "duplicateInputCommandMacroTitle": "Identische Steuereingänge",
            "duplicateCommandsDescription": "Bitte entfernen oder ändern Sie die doppelten Eingabebefehle.",
            "duplicateInputCommandBindingsTitle": "Identische Steuereingaben für Tastenkombinationen",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} mit {{commandOrEventType}}",
            "duplicateMacroNames": "Doppelte Steuerelementnamen",
            "duplicateMacroNamesDescription": "Bitte entfernen oder ändern Sie einen Ihrer identischen Steuerelementnamen.",
            "warningIgnore": "Ignorieren",
            "warningDoNotShowAgain": "Warnungen nicht mehr anzeigen",
            "macrosVoiceCommandConflictWithDictationTitle": "Sprachbefehle genauso steuern wie Diktierschlüsselwörter",
            "keybindingsVoiceCommandConflictWithDictationTitle": "Tastenkombinationen Sprachbefehle gleich wie Diktierschlüsselwörter",
            "macrosVoiceCommandConflictWithDictationDescription": "Ihre Spracheingaben lösen Diktate und Sprachbefehle aus.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "Ihre Spracheingaben lösen Diktate und Tastendrücke aus.",
            "macrosVoiceCommandConflictWithGenerationTitle": "Sprachbefehle steuern wie Schlüsselwörter generieren",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "Tastenkombinationen für Sprachbefehle sind dieselben wie bei der Generierung von Schlüsselwörtern",
            "macrosVoiceCommandConflictWithGenerationDescription": "Ihre Spracheingaben lösen die Generierung und Sprachbefehle aus.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "Ihre Spracheingaben lösen die Generierung und Tastendrücke aus.",
            "duplicateAssociatedProgramNames": "Doppelte zugehörige Programmnamen",
            "duplicateAssociatedProgramNamesDescription": "Bitte entfernen oder ändern Sie eines Ihrer identischen verknüpften Programme.",
            "emptyEvent": {
                "title": "Fehlende Schritte",
                "description": "In Ihrer Steuerung fehlen Schritte. Dies kann dazu führen, dass Cephable beim Eingeben eines Befehls keine Aktion ausführt."
            },
            "warningDetails": "Alle Konflikte anzeigen"
        },
        "success": {
            "save": "App-Steuerung gespeichert.",
            "add": "App-Steuerung hinzugefügt.",
            "delete": "App-Steuerung gelöscht.",
            "share": "Freigabelink erstellt und in die Zwischenablage kopiert",
            "shareDelete": "Freigabelink gelöscht.",
            "generate": "App-Steuerelemente generiert."
        },
        "warning": "App-Steuerung mit Warnungen gespeichert",
        "customize": "App-Steuerelemente anpassen",
        "custom": "{{name}} (Benutzerdefiniert)",
        "description": "App-Steuerelemente sind eine Reihe von Steuerelementen, mit denen Sie Ihr Gerät oder Ihre Verbindung steuern können. Sie können mehrere App-Steuerelemente erstellen und jederzeit zwischen ihnen wechseln."
    },
    "publicProfiles": {
        "toolbar": "App-Steuerelemente erkunden",
        "title": "App-Steuerelemente erkunden",
        "offline": {
            "title": "Öffentliche App-Steuerelemente können nicht geladen werden",
            "description": "Offenbar sind Sie offline. Sie können Ihre App-Steuerelemente weiterhin verwenden, aber keine neuen öffentlichen App-Steuerelemente laden.",
            "confirm": "Okay"
        },
        "announcement": "{{count}} Neue App-Steuerelemente wurden geladen",
        "description": {
            "personal": "Öffentliche App-Steuerelemente erleichtern Ihnen den schnellen Einstieg in Cephable mit Ihren Lieblings-Apps. Sie können die Standard-Steuerelemente verwenden, diese an Ihre Bedürfnisse anpassen oder völlig neue, benutzerdefinierte App-Steuerelemente erstellen.",
            "pro": "Öffentliche App-Steuerelemente erleichtern Ihnen den schnellen Einstieg in Cephable mit Ihren Lieblings-Apps. Sie können die Standard-Steuerelemente verwenden, diese an Ihre Bedürfnisse anpassen oder mit dem Steuerelementgenerator völlig neue, benutzerdefinierte App-Steuerelemente erstellen."
        },
        "team": "Cephable Team"
    },
    "publicTag": "Öffentlich",
    "tray": {
        "panel": "Bedienfeld umschalten",
        "dashboard": "Dashboard anzeigen",
        "quit": "Cephable beenden"
    },
    "generate": "Erzeugen",
    "stop": "Stoppen",
    "clear": "Klar",
    "rewrite": "Umschreiben",
    "translate": "Übersetzen",
    "smartTasks": {
        "title": "Intelligente Aufgaben",
        "show": "Intelligente Aufgaben anzeigen",
        "description": "Intelligente Aufgaben sind die verschiedenen Aufgaben, die die KI von Cephable für Sie erledigen kann. Diese Aufgaben werden durch die KI auf dem Gerät unterstützt und können zum Erstellen von Texten, Zusammenfassen, Umschreiben, Übersetzen, Notieren und Chatten mit Dokumenten verwendet werden.",
        "generateText": {
            "title": "Text generieren",
            "description": "Erstellen Sie Textinhalte basierend auf Ihren Eingaben oder Aufforderungen.",
            "label": "Beschreiben Sie, was Sie generieren möchten"
        },
        "summarizeText": {
            "title": "Text zusammenfassen",
            "description": "Sammeln Sie Erkenntnisse aus längeren Texten und erstellen Sie kurze Zusammenfassungen oder Kernaussagen.",
            "directions": "Geben Sie den zusammenzufassenden Text ein, andernfalls verwendet Cephable automatisch den von Ihnen markierten Text.",
            "titleShort": "Zusammenfassen",
            "write": "Zusammenfassung schreiben",
            "label": "Wie möchten Sie den Text zusammenfassen oder kürzen?",
            "outputLabel": "Ihre Zusammenfassung wird hier angezeigt.",
            "inputLabel": "Geben Sie den zu kürzenden Text ein"
        },
        "rewriteText": {
            "title": "Text neu schreiben",
            "description": "Markieren Sie den Text, in dem Sie schreiben, in einer anderen App, und kehren Sie dann hierher zurück und beschreiben Sie, wie er neu geschrieben werden soll.",
            "label": "Beschreiben Sie, wie Sie den Text umschreiben möchten",
            "inputLabel": "Geben Sie den umzuschreibenden Text ein"
        },
        "translateText": {
            "title": "Text übersetzen",
            "description": "Geben Sie den zu übersetzenden Text ein, oder Cephable verwendet automatisch den von Ihnen markierten Text.",
            "label": "Geben Sie den zu übersetzenden Text ein",
            "languageLabel": "Zu übersetzende Sprache"
        },
        "noteTaker": {
            "title": "Notizenmacher",
            "description": "Lassen Sie Cephable Ihre Meetings oder Gespräche lokal aufzeichnen und transkribieren"
        },
        "documentChat": {
            "title": "Dokumenten-Chat",
            "description": "Interagieren Sie mit Dokumenten und fragen Sie sie ab, um schnelle Erkenntnisse zu gewinnen."
        },
        "highlightText": {
            "title": "Hervorgehobenen Text verwenden",
            "description": "Cephable kann den in einer App markierten Text automatisch verwenden, um Aufgaben wie Zusammenfassen, Umschreiben oder Übersetzen auszuführen. Sie können Text auch manuell eingeben, wenn Sie möchten.",
            "label": "Geben Sie den zu verwendenden Text ein",
            "placeholder": "Sie können Text auch in einer anderen App markieren und hierher zurückkehren, um ihn zu verwenden.",
            "noTextFound": "Kein Text gefunden. Markieren Sie den Text in einer anderen App oder fügen Sie ihn in das Feld ein und versuchen Sie es erneut."
        },
        "pasteText": {
            "title": "Text einfügen",
            "description": "Cephable kann den in die Zwischenablage kopierten Text automatisch für Aufgaben wie Zusammenfassen, Umschreiben oder Übersetzen verwenden. Sie können den Text auch manuell eingeben.",
            "label": "Geben Sie den zu verwendenden Text ein",
            "placeholder": "Sie können Text auch in einer anderen App markieren und hierher zurückkehren, um ihn zu verwenden."
        },
        "clearCache": "Falls Probleme bei der Generierung auftreten, löschen Sie bitte Ihren Cache und Ihre Ressourcen in den Einstellungen für die Textgenerierung und versuchen Sie es erneut.",
        "transcribeAudio": {
            "title": "Audio transkribieren",
            "description": "Konvertieren Sie Audio- oder Videodateien mithilfe der KI-Transkription in Text.",
            "inputMethod": "Eingabemethode auswählen",
            "localFile": "Lokale Datei",
            "url": "URL",
            "selectFile": "Audio-/Videodatei auswählen",
            "urlLabel": "Audio-/Video-URL",
            "transcribe": "Transkribieren",
            "result": "Transkriptionsergebnis",
            "invalidFileType": "Bitte wählen Sie eine gültige Audio- oder Videodatei (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Transkriptionsfehler",
            "history": {
                "title": "Transkriptionsverlauf",
                "description": "Zeigen Sie Ihre gespeicherten Transkriptionen an und verwalten Sie sie.",
                "viewHistory": "Verlauf anzeigen",
                "empty": "Noch keine Transkriptionen. Beginnen Sie mit der Transkription, um Ihren Verlauf aufzubauen!",
                "titleLabel": "Titel (optional)",
                "titlePlaceholder": "Geben Sie einen Titel für diese Transkription ein",
                "textLabel": "Transkriptionstext",
                "confirmDelete": "Möchten Sie diese Transkription wirklich löschen?"
            }
        },
        "aiWorkflows": {
            "description": "Automatisieren Sie Ihre Desktop- und Browseraufgaben mit KI. Beschreiben Sie einfach, was Sie erreichen möchten, und Cephable führt die Aktionen für Sie aus.",
            "label": "Beschreiben Sie, was Sie erreichen möchten.",
            "status": {
                "idle": "Wir warten auf Ihre Anweisungen...",
                "initializing": "Die Vorbereitungen laufen...",
                "planning": [
                    "Einen Plan machen...",
                    "Aufschlüsselung Ihrer Anfrage...",
                    "Die einzelnen Schritte planen...",
                    "Organisation des Arbeitsablaufs...",
                    "Die Strategie wird vorbereitet...",
                    "Einen Aktionsplan erstellen...",
                    "Wir überlegen, wie wir Ihnen am besten helfen können...",
                    "Die richtige Vorgehensweise festlegen...",
                    "Ihre Anfrage wird analysiert...",
                    "Planung der Durchführung..."
                ],
                "thinking": [
                    "Denken...",
                    "Ihre Anfrage wird analysiert...",
                    "Wir überlegen, wie wir Ihnen am besten helfen können...",
                    "Die nächsten Schritte festlegen...",
                    "Die vorherigen Schritte werden verarbeitet...",
                    "Wir bearbeiten Ihre Anfrage...",
                    "Details werden abgerufen...",
                    "Überprüfung des Plans...",
                    "Die verschiedenen Optionen in Betracht ziehen...",
                    "Erstellen, Bewerten, Entscheiden..."
                ],
                "waitingForUser": "Ihre Eingabe ist erforderlich, um fortzufahren.",
                "completed": "Erfolg!",
                "failed": "Ihre Anfrage ist fehlgeschlagen: {{message}}",
                "canceled": "Ihre Anfrage wurde storniert.",
                "terminated": "Ihre Anfrage wurde bearbeitet.",
                "thinkingInteractive": [
                    "Überlegen Sie sich den nächsten Schritt...",
                    "Ein Rückblick auf das bisher Erreichte...",
                    "Die Entscheidung, was als Nächstes zu tun ist...",
                    "Analyse der Ergebnisse...",
                    "Planung der Fortsetzung...",
                    "Die Optionen auswerten...",
                    "Den besten nächsten Schritt herausfinden...",
                    "Ich arbeite am nächsten Teil Ihrer Anfrage...",
                    "Ich arbeite an den nächsten Schritten...",
                    "Die Ergebnisse des vorherigen Schritts werden verarbeitet..."
                ],
                "tools": {
                    "click_element_by_index": {
                        "executing-start": "Durch Klicken der entsprechenden Schaltfläche...",
                        "executing-complete": "Ich habe auf {{params.index}} geklickt."
                    },
                    "click_element": {
                        "executing-start": "Durch Anklicken der markierten Zahl...",
                        "executing-complete": "Ich habe auf {{params.elementName}} geklickt."
                    },
                    "copy_selection": {
                        "executing-start": "Kontextinformationen sammeln...",
                        "executing-complete": "Ich habe den Kontext und bin bereit für den nächsten Teil Ihrer Anfrage."
                    },
                    "draft_email": {
                        "executing-start": "Eine E-Mail verfassen...",
                        "executing-complete": "Ich habe eine E-Mail zum Thema {{params.subject}} entworfen."
                    },
                    "execute_app_action": {
                        "executing-start": "{{params.actionName}} wird ausgeführt...",
                        "executing-complete": "{{params.actionName}} abgeschlossen."
                    },
                    "find_all_text": {
                        "executing-start": "Suche nach allen relevanten Kontextinformationen zu {{params.searchText}}...",
                        "executing-complete": "Ich habe alle relevanten Kontextinformationen zu {{params.searchText}} gefunden."
                    },
                    "find_and_select_text": {
                        "executing-start": "Suche und Auswahl relevanter Kontextinformationen zu {{params.searchText}}...",
                        "executing-complete": "Ich habe relevanten Kontext zu {{params.searchText}} gefunden und ausgewählt."
                    },
                    "generate_text": {
                        "executing-start": "Inhalte erstellen...",
                        "executing-progress": "Inhalte werden erstellt...{{progress}}%",
                        "executing-complete": "Ich habe die angeforderten Inhalte erstellt."
                    },
                    "get_all_interactive_elements": {
                        "executing-start": "Scannen, um mehr Kontext zu erhalten...",
                        "executing-complete": "Ich verstehe, womit ich interagieren kann."
                    },
                    "get_all_text_elements_content": {
                        "executing-start": "Lesen, um mehr Kontext zu erhalten...",
                        "executing-complete": "Ich verstehe, welche Textinhalte verfügbar sind."
                    },
                    "get_all_text_elements_names": {
                        "executing-start": "Lesen, um mehr Kontext zu erhalten...",
                        "executing-complete": "Ich verstehe, welche Textinhalte verfügbar sind."
                    },
                    "get_available_profile_actions": {
                        "executing-start": "Ich prüfe, welche Steuerelemente in dieser App verfügbar sind...",
                        "executing-complete": "Ich verstehe, was ich mit dieser App machen kann."
                    },
                    "get_document_content": {
                        "executing-start": "Lesen, um mehr Kontext zu erhalten...",
                        "executing-complete": "Ich habe den Kontext und bin bereit für den nächsten Teil Ihrer Anfrage."
                    },
                    "get_installed_apps": {
                        "executing-start": "Die Entscheidung, welche App für Ihre Anfrage relevant ist...",
                        "executing-complete": "Ich weiß, welche Apps ich verwenden kann."
                    },
                    "get_running_app_names": {
                        "executing-start": "Die Entscheidung, welche App für Ihre Anfrage relevant ist...",
                        "executing-complete": "Ich weiß, welche Apps ich verwenden kann."
                    },
                    "get_selected_text": {
                        "executing-start": "Der ausgewählte Inhalt wird gelesen...",
                        "executing-complete": "Ich habe Kontextinformationen zum ausgewählten Inhalt."
                    },
                    "get_stored_content": {
                        "executing-start": "Kontext sammeln...",
                        "executing-complete": "Ich habe den Kontext und bin bereit für den nächsten Teil Ihrer Anfrage."
                    },
                    "keyboard_shortcut": {
                        "executing-start": "Kontext sammeln...",
                        "executing-complete": "Ich habe den Kontext und bin bereit für den nächsten Teil Ihrer Anfrage."
                    },
                    "open_app": {
                        "executing-start": "Öffne {{params.appName}}...",
                        "executing-complete": "Ich habe {{params.appName}} geöffnet."
                    },
                    "open_webpage": {
                        "executing-start": "Öffne {{params.url}}...",
                        "executing-complete": "Ich habe {{params.url}} geöffnet."
                    },
                    "paste_content": {
                        "executing-start": "Schreiben...",
                        "executing-complete": "Ich habe mit dem Schreiben fertig."
                    },
                    "respond_to_user": {
                        "executing-start": "Ihre Anfrage wird abgeschlossen...",
                        "executing-complete:": "Ich habe Ihre Anfrage bearbeitet."
                    },
                    "search_browser": {
                        "executing-start": "Suche im Web nach {{params.query}}...",
                        "executing-complete": "Ich habe im Internet nach {{params.query}} gesucht."
                    },
                    "select_all_text": {
                        "executing-start": "Der gesamte Text wird ausgewählt...",
                        "executing-complete": "Ich habe den gesamten Text ausgewählt."
                    },
                    "summarize_text": {
                        "executing-start": "Zusammenfassend lässt sich sagen:",
                        "executing-progress": "Zusammenfassend...{{progress}}%",
                        "executing-complete": "Ich habe den Text zusammengefasst."
                    },
                    "translate_text": {
                        "executing-start": "Der Text wird in {{params.targetLanguage}} übersetzt...",
                        "executing-progress": "Übersetzung läuft...{{progress}}%",
                        "executing-complete": "Ich habe den Text in {{params.targetLanguage}} übersetzt."
                    },
                    "type_stored_content": {
                        "executing-start": "Schreiben...",
                        "executing-complete": "Ich habe mit dem Schreiben fertig."
                    },
                    "type_text": {
                        "executing-start": "Schreiben...",
                        "executing-complete": "Ich habe mit dem Schreiben fertig."
                    },
                    "unknown": {
                        "executing-start": "Ich bin auf ein Problem gestoßen, als ich eine andere Strategie ausprobiert habe...",
                        "executing-complete": "Ich habe eine andere Strategie ausprobiert."
                    },
                    "append_to_file": {
                        "executing-start": "Der Datei wird etwas hinzugefügt...",
                        "executing-complete": "Ich habe der Datei Inhalte hinzugefügt."
                    },
                    "copy_path": {
                        "executing-start": "Kopieren...",
                        "executing-complete": "Ich habe es kopiert."
                    },
                    "create_directory": {
                        "executing-start": "Ordner wird erstellt...",
                        "executing-complete": "Ich habe den Ordner erstellt."
                    },
                    "delete_path": {
                        "executing-start": "Löschen...",
                        "executing-complete": "Ich habe es gelöscht."
                    },
                    "edit_user_file": {
                        "executing-start": "Die Datei wird bearbeitet...",
                        "executing-complete": "Ich habe die Datei bearbeitet."
                    },
                    "get_file_info": {
                        "executing-start": "Datei wird geprüft...",
                        "executing-complete": "Ich habe die Datei überprüft."
                    },
                    "list_directory": {
                        "executing-start": "Ordner auflisten...",
                        "executing-complete": "Ich habe den Ordner aufgelistet."
                    },
                    "move_path": {
                        "executing-start": "Umzug...",
                        "executing-complete": "Ich habe es verschoben."
                    },
                    "open_path": {
                        "executing-start": "Öffnung...",
                        "executing-complete": "Ich habe es geöffnet."
                    },
                    "read_user_file": {
                        "executing-start": "Die Datei wird gelesen...",
                        "executing-complete": "Ich habe die Datei gelesen."
                    },
                    "run_command": {
                        "executing-start": "Einen Befehl ausführen...",
                        "executing-complete": "Ich habe den Befehl ausgeführt."
                    },
                    "search_files": {
                        "executing-start": "Suche nach Dateien...",
                        "executing-complete": "Ich habe passende Dateien gefunden."
                    },
                    "search_in_files": {
                        "executing-start": "Suche in den Dateien...",
                        "executing-complete": "Ich habe in den Dateien gesucht."
                    },
                    "write_user_file": {
                        "executing-start": "Die Datei wird geschrieben...",
                        "executing-complete": "Ich habe die Datei geschrieben."
                    }
                },
                "networkError": "Die Verbindung wurde beim Herunterladen des Modells unterbrochen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut, indem Sie eine Anfrage senden oder die App neu starten.",
                "executing-org-block": "{{params.toolName}} kann nicht aufgerufen werden, da die Interaktion mit {{params.appOrDomain}} von der Organisation blockiert wird.",
                "executing-destructive-block": "Die Interaktion mit {{params.elementName}} ist blockiert. Bitte überprüfen Sie dies und führen Sie diese Aktion manuell aus.",
                "executing-type-focus-block": "Ich hatte ein Problem beim Schreiben des Inhalts. Er wurde in Ihre Zwischenablage kopiert, bitte fügen Sie ihn manuell ein.",
                "executing-permission-block": "Ich hatte Probleme beim Zugriff auf die Datei.",
                "stopped": "Angehalten.",
                "unsupportedOSVersion": "Ihr MacOS-System ist veraltet. Bitte aktualisieren Sie es und versuchen Sie es erneut."
            },
            "ready": {
                "waiting": "AI Workflows ist einsatzbereit. Wir warten auf Ihre Anweisungen.",
                "execute": "AI Workflows ist bereit. Wir starten auf Ihre Anfrage hin..."
            },
            "start": "Start",
            "progress": "Arbeiten...",
            "title": "Ihre KI-Workflows sind bereit",
            "steps": {
                "thinking": "Denken",
                "tool": "Werkzeug",
                "details": "Details",
                "chunkProgress": "Teil {{aktuell}} von {{gesamt}}",
                "output": "Ausgabe",
                "showMore": "Mehr anzeigen",
                "showLess": "Weniger anzeigen"
            },
            "prefix": "Arbeitsablauf:",
            "files": {
                "sectionTitle": "Dateien",
                "open": "Offen",
                "openFile": "Datei öffnen",
                "openFolder": "Ordner öffnen",
                "openError": "\"{{name}}\" konnte nicht geöffnet werden. Die Datei wurde möglicherweise verschoben oder gelöscht."
            },
            "input": {
                "other": "Andere…",
                "otherPlaceholder": "Geben Sie Ihre Antwort ein",
                "submit": "Schicken"
            },
            "continue": {
                "label": "Weitermachen",
                "placeholder": "Bitten Sie Cephable, mehr aus diesem Ergebnis zu machen…"
            },
            "retry": {
                "label": "Wiederholen"
            },
            "context": {
                "approaching": "Diese Konversation dauert bereits länger ({{percent}}% des KI-Speichers werden genutzt). Ältere Nachrichten werden möglicherweise bald gelöscht.",
                "trimmed": "Diese Konversation hat die Speichergrenze der KI erreicht, daher werden möglicherweise frühere Nachrichten vergessen. Starten Sie einen neuen Workflow, um die Speicherung zurückzusetzen."
            },
            "approval": {
                "title": "Aktion bestätigen",
                "approve": "Genehmigen",
                "reject": "Ablehnen",
                "edit": "Bearbeiten",
                "deletePath": "Diese Datei/diesen Ordner löschen? Dies ist endgültig.",
                "runCommand": "Diesen Shell-Befehl ausführen?",
                "movePath": "Diesen Pfad verschieben/umbenennen? Dadurch könnte der Zielpfad überschrieben werden.",
                "confirmDelete": "Löschen",
                "confirmRun": "Befehl ausführen",
                "confirmMove": "Bewegen",
                "badgeDestructive": "Zerstörerisch",
                "badgeCaution": "Vorsicht"
            },
            "browser": {
                "sectionTitle": "Browser",
                "view": "Browser anzeigen",
                "open": "Offen",
                "openError": "Der Browser konnte nicht geöffnet werden."
            }
        },
        "generatedByAI": "Die Daten werden durch geräteinterne KI bereitgestellt. Bitte überprüfen Sie die Angaben auf Richtigkeit.",
        "networkError": "Die Verbindung wurde beim Herunterladen des Modells unterbrochen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut, indem Sie eine Anfrage senden oder die App neu starten.",
        "genericError": "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "download": {
            "title": "Laden Sie KI-Modelle herunter, um weitere Funktionen freizuschalten",
            "description": "Um intelligente Aufgaben nutzen zu können, muss ein lokales Modell auf Ihr Gerät heruntergeladen werden. Dadurch wird sichergestellt, dass Ihre Daten privat bleiben und niemals in die Cloud übertragen werden.",
            "confirm": "Herunterladen",
            "cancel": "Nicht jetzt."
        },
        "runningInBackground": {
            "generate": "Wird im Hintergrund generiert...",
            "rewrite": "Überarbeitung im Hintergrund...",
            "translate": "Übersetzung im Hintergrund...",
            "summarize": "Zusammenfassend im Hintergrund...",
            "generic": "Läuft im Hintergrund..."
        }
    },
    "inputMethod": "Eingabemethode:",
    "hotkey": {
        "title": "Schnellaktionsschaltfläche",
        "titlePlural": "Schnellaktionsschaltflächen",
        "titlePanel": "Schnellaktionen",
        "label": "Anzeigename der Schnellaktionsschaltfläche",
        "placeholder": "Anzuzeigender Name",
        "question": "Wie möchten Sie diese Schaltfläche benennen?",
        "when": "Wenn ich tippe ...",
        "description": "Schnellaktionsschaltflächen sind anpassbare Schaltflächen, mit denen Sie durch Antippen relevante Aktionen in Ihrer App ausführen können. Ein einziges Antippen kann mehrere Schritte oder eine einzelne Aktion auslösen.",
        "usagePrompt": "Schnellaktionsschaltflächen sind anpassbare Schaltflächen, mit denen Sie durch Antippen entsprechende Aktionen in Ihrer App ausführen können. Sie können die Namen auf der Hauptseite der App-Steuerungseinstellungen hinzufügen, entfernen oder bearbeiten.",
        "reorder": "Sie können die Reihenfolge mit den Schaltflächen „Nach oben“ und „Nach unten“ neu anordnen.",
        "emptyTitle": "Keine Schnellaktionstasten",
        "edit": "Schnellaktionsschaltflächen bearbeiten",
        "tap": "Tippen Sie auf {{value}}",
        "copySuffix": "{{name}}_Kopie",
        "hotkeysOnly": "Benutzerdefinierte Schaltflächen",
        "allControls": "Alle App-Steuerelemente",
        "show": "Schnellaktionsschaltflächen anzeigen",
        "deprecatedDialog": {
            "title": "Ihre App-Steuerung erfordert ein Update.",
            "description2": "Ein schnelles Update genügt – buchstäblich eine Sekunde – und Sie können die nahtlose Anpassung der Schaltflächen genießen. Verabschieden Sie sich von zusätzlichen Schritten und freuen Sie sich auf eine benutzerfreundlichere Oberfläche. Sind Sie bereit für den Wechsel?",
            "confirm": "Lass es uns tun!",
            "description1": "Sie verwenden anscheinend ältere App-Steuerelemente mit Schnellaktionsschaltflächen. Wir haben spannende Updates für Sie! Wir haben das System überarbeitet, damit das Erstellen und Bearbeiten von Schnellaktionsschaltflächen kinderleicht ist – Sie müssen sich nicht mehr in die erweiterten Einstellungen vertiefen."
        },
        "demo": {
            "title": "Demo der Schnellaktionsschaltflächen",
            "step1": "Aktivieren Sie die Schnellaktionsschaltflächen",
            "step2": "Verwenden Sie die folgenden Beispielaufforderungen, um den Textblock zu steuern.",
            "command1": "Drücken Sie die Taste 1, um den Text zu vergrößern.",
            "command2": "Drücken Sie die Taste 2, um den Text fett darzustellen.",
            "command3": "",
            "continue": "Weiter mit Quick Action Buttons",
            "description": "Im Demobereich unten können Sie Schnellaktionsschaltflächen ausprobieren. Die Demo beschränkt sich auf die Steuerung dieses Textbereichs unten."
        },
        "example": {
            "title": "Beispiele für Schnellaktionsschaltflächen",
            "command1": "Tippen Sie auf „Pause“",
            "example1": "Beispiel „Video anhalten“",
            "command2": "Tippen Sie auf Weiter",
            "example2": "Beispiel „Herauszoomen“",
            "command3": "Tippen Sie auf „Stopp“",
            "example3": "Beispiel „Fenster schließen“",
            "description": "Diese Beispiele zeigen die Vielseitigkeit von Quick Action Buttons bei der Steuerung Ihres Geräts oder Ihrer Verbindung. Mit ihnen können Sie Befehle ausführen, durch Benutzeroberflächen navigieren oder Aktionen mit einem einfachen Fingertipp ausführen."
        },
        "emptySearch": "Es gibt keine Schnellaktionen, die diesen Kriterien entsprechen.",
        "empty": "Es sieht so aus, als ob Sie derzeit keine Schnellaktionen haben.",
        "emptyLong": "In diesen App-Steuerelementen sind keine Schnellaktionsschaltflächen konfiguriert. Sobald Sie Schnellaktionsschaltflächen hinzufügen oder App-Steuerelemente mit einer solchen Schaltfläche auswählen, werden diese hier angezeigt."
    },
    "reset": "Zurücksetzen",
    "info": "Weitere Informationen",
    "device": {
        "title": "Verbindung",
        "titlePlural": "Anschlüsse",
        "status": {
            "title": "Verbindungsstatus:",
            "connected": {
                "application": "Verbundene Anwendung",
                "connection": "Verbunden",
                "device": "Verbundenes Gerät",
                "game": "Verbundenes Spiel"
            },
            "disconnected": {
                "application": "Getrennte Anwendung",
                "connection": "Getrennt",
                "device": "Getrenntes Gerät",
                "game": "Getrenntes Spiel"
            }
        },
        "running": "Läuft",
        "offline": "Offline",
        "otherDevices": "Andere Ausgangsanschlüsse",
        "currentStatus": "Aktueller Status:",
        "connectionStatus": "Verbindungsstatus:",
        "profileStatus": "Aktuelle App-Steuerelemente:",
        "name": {
            "title": "Verbindungsname",
            "question": "Wie möchten Sie diese Verbindung nennen?",
            "description": "Geben Sie Ihrer Verbindung einen Namen, damit Sie sie später leicht wiederfinden können.",
            "placeholder": "Verbindungsname",
            "edit": "Verbindungsnamen bearbeiten"
        },
        "updates": {
            "title": "Verbindungsupdates",
            "settings": "Verbindungsaktualisierungseinstellungen",
            "description": "Suchen Sie nach Firmware-Updates für die Verbindung und ändern Sie die Einstellungen für die automatische Aktualisierung",
            "edit": "Update-Einstellungen bearbeiten",
            "check": {
                "title": "Nach Updates suchen",
                "processing": "Suche nach Updates! Dies kann einige Minuten dauern und Ihre Verbindung wird während der Updates möglicherweise neu gestartet.",
                "description": "Tippen Sie hier, um nach Updates für Ihre Verbindung zu suchen. Wenn ein Update verfügbar ist und Ihre Verbindung aktiv ist, wird die Aktualisierung gestartet. Die Aktualisierung kann einige Minuten dauern."
            },
            "auto": {
                "title": "Automatisch aktualisieren",
                "description": "Wenn diese Einstellung aktiviert ist, wird Ihre Verbindung automatisch aktualisiert, sobald sie angeschlossen ist, mit dem WLAN verbunden ist und ein Update verfügbar ist. Wenn diese Einstellung deaktiviert ist, müssen Sie auf die Schaltfläche „Aktualisieren“ tippen, um die neueste Version zu erhalten.",
                "option": "Automatische Aktualisierung verwenden?"
            }
        },
        "delete": {
            "title": "Link {{name}} entfernen",
            "titleLong": "Verknüpfung von Konto aufheben",
            "description": "Durch das Trennen der Verbindung wird Cephable von diesem Computer oder Spiel getrennt und aus Ihrem Konto entfernt. Sie können sich dann nicht mehr verbinden, Befehle senden oder Updates durchführen. Dieser Vorgang kann nicht rückgängig gemacht werden. Sie können jedoch eine neue Verbindung zum selben Computer oder Spiel herstellen, falls Sie Cephable später wieder verwenden möchten.",
            "confirm": "Möchten Sie diese Verbindung wirklich trennen?",
            "confirmLong": "Möchten Sie diese Verbindung wirklich abmelden und zurücksetzen? Sie können sich danach nicht mehr damit verbinden, Befehle senden oder sie aktualisieren. Nach dieser Abmeldung und Zurücksetzung kann jeder diese Verbindung von Grund auf neu einrichten.",
            "confirmButton": "Ja, diese Verbindung entfernen."
        },
        "manage": {
            "title": "Klicken Sie hier, um Details zu Ihren Verbindungen anzuzeigen und zu verwalten.",
            "description": "",
            "name": "Passen Sie Ihren Verbindungsnamen zur einfacheren Verwaltung an."
        },
        "error": {
            "save": "Fehler beim Speichern der Verbindung.",
            "load": "Fehler beim Laden der Verbindung.",
            "add": "Fehler beim Hinzufügen der Verbindung.",
            "delete": "Fehler beim Löschen der Verbindung.",
            "updates": "Fehler beim Suchen nach Updates.",
            "connection": "Die Verbindung konnte nicht hergestellt werden. Stellen Sie sicher, dass die Verbindung besteht, bevor Sie es erneut versuchen.",
            "deleteLong": "Wir konnten diese Verbindung nicht aus Ihrem Konto löschen. Wenn Sie sich erneut bei diesem Konto anmelden, müssen Sie diese Verbindung möglicherweise manuell in den Verbindungseinstellungen löschen."
        },
        "success": {
            "save": "Verbindung gespeichert.",
            "add": "Verbindung hinzugefügt.",
            "delete": "Verbindung gelöscht."
        },
        "description": "Cephable unterstützt mehrere Geräte und Verbindungen. Sie können hier Einstellungen verwalten oder alle auswählen. Dieser Computer ist immer Ihre Hauptverbindung. Sie können später weitere Verbindungen hinzufügen.",
        "swap": {
            "titlePlural": "Verbindungen austauschen",
            "description": "Cephable unterstützt mehrere Geräte und Verbindungen. Sie können hier eine beliebige auswählen. Dieser Computer dient immer als Ihre Hauptverbindung. Sie können später weitere Verbindungen hinzufügen."
        },
        "control": {
            "button": "Kontrolle {{name}}",
            "description": {
                "application": "Steuern Sie diese verbundene Anwendung per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise „Speichern“ sagen, wird die laufende Anwendung gespeichert.",
                "connection": "Steuern Sie diese Verbindung per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise „Speichern“ sagen, wird Ihre laufende Verbindung gespeichert.",
                "device": "Steuern Sie dieses verbundene Gerät per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise „Spotify öffnen“ sagen, wird Spotify auf dem laufenden Gerät geöffnet.",
                "game": "Steuern Sie dieses vernetzte Spiel mit Ihrer Stimme, schnellen Aktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise „Los“ sagen, bewegt sich der Spieler im Laufspiel."
            },
            "generic": "Steueranschluss"
        },
        "titleShort": "Verbinden",
        "titleLong": "Verbindungen & Erweiterungen",
        "viewAll": "Alle Verbindungen anzeigen",
        "add": {
            "short": "Verlängern",
            "title": "Neue Verbindung oder Erweiterung hinzufügen",
            "description": "Verbindungen und Erweiterungen bieten Ihnen zusätzliche Möglichkeiten, Ihr Cephable-Erlebnis zu optimieren. Sie können neue Verbindungen hinzufügen, um weitere Geräte, Anwendungen oder Spiele zu verbinden. Bringen Sie Ihr Cephable-Erlebnis auf die nächste Stufe, indem Sie Verbindungen und Erweiterungen hinzufügen.",
            "action": "Neue Verbindung hinzufügen",
            "notAvailable": "Diese Verbindung bzw. Erweiterung ist derzeit nicht öffentlich verfügbar. Dies tritt häufig bei der Verwendung von benutzergenerierten Erweiterungen auf. Bitte versuchen Sie es später erneut.",
            "isNotPublic": "VORSCHAU: Diese Erweiterung befindet sich in der Entwicklervorschau und ist möglicherweise unvollständig. Entwickler sollten alle Schritte vor der Veröffentlichung abschließen. Benutzer können später wieder vorbeischauen, um die Vollversion zu erhalten."
        },
        "new": "Sie haben eine neue Verbindung!",
        "newLong": "Sie haben eine neue Verbindung! Um sie zu nutzen, wählen Sie sie im Menü unten aus."
    },
    "explore": "Erkunden",
    "shortcuts": {
        "title": "Globale Verknüpfungen",
        "description": "Passen Sie Tastaturkürzel an, um von überall auf Ihrem System aus schnell auf die Cephable-Steuerelemente zugreifen zu können.",
        "info": "Diese Verknüpfungen funktionieren global und können auch verwendet werden, wenn Cephable nicht das aktive Fenster ist.",
        "shortcut": "Abkürzung",
        "toggleMicrophone": "Mikrofon umschalten",
        "toggleDictation": "Diktiermodus umschalten",
        "toggleVoiceControl": "Sprachsteuerungsmodus umschalten",
        "togglePanel": "Bedienfeld umschalten",
        "registrationFailed": "Einige globale Tastenkombinationen konnten nicht registriert werden. Sie werden möglicherweise von einer anderen Anwendung verwendet:",
        "record": {
            "title": "Verknüpfung aufzeichnen",
            "start": "Klicken zum Aufzeichnen",
            "listening": "Drücken Sie die gewünschte Tastenkombination...",
            "pressKeys": "Jetzt Tasten drücken"
        },
        "formatHint": "Wählen Sie mindestens eine Sondertaste ({{modifierKey}}, {{modifierKey2}}, Umschalttaste) und eine weitere Taste aus."
    },
    "gamepad": {
        "title": "Gamepad-Unterstützung",
        "description": "Konfigurieren Sie die Gamepad- und Joystick-Ausgabe für PC-Spiele",
        "driver": {
            "description": "Zur Unterstützung von Gamecontroller-Ausgaben muss Cephable einen externen Treiber namens ViGEm herunterladen und installieren. Dieser Treiber ermöglicht die Funktionalität eines virtuellen Xbox 360-Controllers, den Spiele nativ erkennen.",
            "installed": "Gamecontroller-Treiber installiert – Sie können die Gamepad-Ausgänge verwenden! Sollten weiterhin Probleme auftreten, können Sie versuchen, den Treiber neu zu installieren.",
            "notInstalled": "Gamecontroller-Treiber nicht installiert",
            "install": "Installieren Sie den Gamecontroller-Treiber",
            "reinstall": "Installieren Sie den Gamecontroller-Treiber neu",
            "installing": "ViGEm-Gamecontroller-Treiber wird installiert …",
            "installSuccess": "Der ViGEm-Gamecontroller-Treiber wurde erfolgreich installiert! Sie können jetzt Gamepad-Ausgänge in Ihren Steuerelementen verwenden.",
            "installFailed": "Der ViGEm-Treiber konnte nicht installiert werden. Bitte versuchen Sie es erneut oder installieren Sie den Treiber manuell von der ViGEm-Website.",
            "title": "Gamecontroller-Treiber",
            "disclosure": {
                "title": "Treiber eines Drittanbieters für Gamepads installieren?",
                "description": "Für die Gamepad-Unterstützung ist die Installation von ViGEm erforderlich, einem inoffiziellen Treiber eines Drittanbieters, der es Cephable ermöglicht, einen virtuellen Xbox-Controller zu emulieren. Fahren Sie nur fort, wenn Cephable diesen Treiber installieren soll.",
                "confirm": "Installieren Sie den ViGEm-Treiber"
            }
        },
        "platform": {
            "unsupported": "Plattform wird für Gamepad-Funktionen nicht unterstützt",
            "unsupportedDescription": "Die Gamepad-Ausgabe wird derzeit nur auf Windows x64-Systemen unterstützt. Unterstützung für Mac und Windows ARM64 ist noch nicht verfügbar."
        },
        "usage": "Sobald der Gamecontroller-Treiber installiert ist, können Sie Joystick-Bewegungen und Gamepad-Tastendrücke in Ihren Makros und Sprachbefehlen zur Steuerung von Spielen verwenden."
    },
    "youtube": {
        "unavailable": {
            "title": "Video nicht verfügbar",
            "description": "Dieses Video ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.",
            "retry": "Wiederholen"
        },
        "watch": {
            "title": "Hoppla.",
            "description": "Beim Laden des Videos ist anscheinend ein Problem aufgetreten. Sie können es direkt auf YouTube ansehen.",
            "button": "Auf YouTube ansehen"
        },
        "offline": {
            "title": "Video nicht verfügbar",
            "description": "Zum Laden dieses YouTube-Videos ist eine Internetverbindung erforderlich. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut."
        }
    },
    "metrics": {
        "download": {
            "success": "Auf die Metrikdatei wurde erfolgreich zugegriffen.",
            "manualPath": "Metrikdatei verfügbar unter: {{path}}",
            "error": "Fehler beim Herunterladen der Metrikdatei.",
            "noFile": "Keine Metrikdatei gefunden."
        },
        "clear": {
            "success": "Die Metrikdatei wurde erfolgreich gelöscht.",
            "error": "Fehler beim Löschen der Metrikdatei.",
            "noFile": "Keine zu löschende Metrikdatei gefunden.",
            "confirm": "Möchten Sie wirklich alle Messdaten löschen? Dies kann nicht rückgängig gemacht werden."
        }
    },
    "suggestedPrompts": {
        "title": "Vorgeschlagene Eingabeaufforderungen",
        "description": "Passen Sie die in KI-Aufgaben angezeigten Eingabeaufforderungen an, damit Sie schnell loslegen können.",
        "edit": "Vorgeschlagene Eingabeaufforderungen bearbeiten",
        "generate": "Text generieren",
        "rewrite": "Text neu schreiben",
        "addGenerate": "Hinzufügen einer Eingabeaufforderung zum Generieren",
        "addRewrite": "Fügen Sie eine Umschreibeaufforderung hinzu",
        "remove": "Eingabeaufforderung entfernen",
        "generatePlaceholder": "Geben Sie eine Eingabeaufforderung zur Textgenerierung ein ...",
        "rewritePlaceholder": "Geben Sie eine Eingabeaufforderung zum Umschreiben des Textes ein ...",
        "suggested": "Vorgeschlagene Eingabeaufforderungen",
        "suggestedFor": "Vorgeschlagen für {{profileName}}",
        "seeAll": "Alle Eingabeaufforderungen anzeigen",
        "showLess": "Weniger anzeigen",
        "allPrompts": "Alle Eingabeaufforderungen",
        "customFor": "Benutzerdefinierte Eingabeaufforderungen für {{profileName}}",
        "defaultPrompts": "Standardaufforderungen",
        "defaultGenerate": [
            "Eine professionelle E-Mail zur Vorstellung unseres neuen Produkts",
            "Eine Tagesordnung für die Teamdiskussion der nächsten Woche",
            "Ein Projektvorschlagsentwurf für eine neue Initiative",
            "Eine formelle Geschäftsbriefvorlage",
            "Ein Abschnitt zur technischen Dokumentation",
            "Eine Einführung in das Benutzerhandbuch",
            "Eine Übersicht über Schulungsunterlagen",
            "Entwurf eines Strategiedokuments",
            "Eine Folge-E-Mail nach einem Meeting",
            "Eine Dankesnachricht an einen Kunden",
            "Eine E-Mail mit einem Update zum Projektstatus",
            "Eine Einladung zu einer Firmenveranstaltung",
            "Eine Erinnerungs-E-Mail für bevorstehende Fristen",
            "Eine Willkommens-E-Mail für neue Teammitglieder",
            "Eine Entschuldigungs-E-Mail für die Dienstunterbrechung",
            "Eine Newsletter-Einführung",
            "Eine Brainstorming-Liste für Marketingkampagnen",
            "Kreative Lösungen zur Verbesserung der Teamproduktivität",
            "Ideen für Aktivitäten bei einer Firmenklausur",
            "Konzepte für eine neue Funktion der mobilen App",
            "Vorschläge zur Verbesserung des Kundenerlebnisses",
            "Innovationsideen für unsere Produktentwicklung",
            "Inhaltsideen für Social-Media-Beiträge",
            "Workshop-Themen zur beruflichen Weiterentwicklung",
            "Eine Funktion, die Benutzereingaben validiert",
            "Eine Datenbankabfrage zur Benutzerverwaltung",
            "Fehlerbehandlungscode für API-Anfragen",
            "Eine Konfigurationsdateivorlage",
            "Kommentare zur Erläuterung eines komplexen Algorithmus",
            "Unit-Testfälle für eine neue Funktion",
            "Dokumentation für API-Endpunkte",
            "Ein Skript für die automatisierte Bereitstellung"
        ],
        "defaultRewrite": [
            "Machen Sie diesen Text prägnanter und auf den Punkt",
            "Erweitern Sie diese Zusammenfassung um weitere Details",
            "Formatieren Sie dies als nummerierte Liste neu",
            "Wandeln Sie dies in Aufzählungspunkte um",
            "Strukturieren Sie dies in klare Absätze um",
            "Machen Sie diesen Text leichter überfliegbar",
            "Organisieren Sie diese Informationen hierarchisch",
            "Formatieren Sie dies als Schritt-für-Schritt-Anleitung",
            "Gestalten Sie diese Nachricht professioneller und formeller",
            "Schreiben Sie dies um, damit es lockerer und freundlicher klingt",
            "Passen Sie den Ton an, um ermutigender zu sein",
            "Machen Sie dies selbstbewusster und durchsetzungsfähiger",
            "Den Ton mildern, um diplomatischer zu sein",
            "Geben Sie diesem Text Begeisterung und Energie",
            "Machen Sie dies einfühlsamer und verständnisvoller",
            "Schreiben Sie in einem kooperativeren Ton neu",
            "Vereinfachen Sie dies für ein allgemeines Publikum",
            "Machen Sie diese Erklärung technischer und detaillierter",
            "Zerlegen Sie dieses komplexe Konzept in einfachere Begriffe",
            "Fügen Sie mehr Kontext und Hintergrundinformationen hinzu",
            "Fassen Sie dies in den wichtigsten Erkenntnissen zusammen",
            "Erläutern Sie die wichtigsten Punkte anhand von Beispielen",
            "Machen Sie dies für Anfänger zugänglicher",
            "Verdichten Sie dies, während Sie die wesentlichen Informationen behalten",
            "Verbessern Sie die Übersichtlichkeit und Lesbarkeit",
            "Machen Sie es ansprechender und interessanter",
            "Passen Sie es an, um die Grammatik und den Lesefluss zu verbessern",
            "Schreiben Sie es neu, um die Vorteile hervorzuheben"
        ],
        "defaultSummarize": [
            "Fassen Sie es in 3 Stichpunkten zusammen.",
            "Wichtige Entscheidungen herausarbeiten",
            "Führen Sie die wichtigsten Maßnahmen auf",
            "Fassen Sie es in einem Satz zusammen.",
            "Heben Sie die wichtigsten Fakten hervor",
            "Für ein nicht-technisches Publikum zusammenfassen",
            "Die wichtigsten Erkenntnisse herausarbeiten",
            "Fassen Sie es in 5 Stichpunkten zusammen.",
            "Identifizieren Sie das Kernproblem und den Lösungsvorschlag.",
            "Alle Schlussfolgerungen und Empfehlungen auflisten",
            "Geben Sie eine Managementzusammenfassung an.",
            "Fassen Sie den zeitlichen Ablauf der Ereignisse zusammen.",
            "Alle aufgeworfenen Fragen herausgreifen",
            "Listen Sie die genannten Vor- und Nachteile auf.",
            "Fassen Sie die wichtigsten Argumente zusammen."
        ]
    },
    "accessibilityService": {
        "error": {
            "generic": "Interner Fehler. Bitte versuchen Sie es später erneut.",
            "elementNotFound": "Es wurden keine Ergebnisse gefunden. Bitte überprüfen Sie, ob die Suchanfrage existiert, und versuchen Sie es erneut.",
            "highlightOnConflict": "Es wurden mehrere Elemente gefunden. Bitte präzisieren Sie Ihren Befehl, um anzugeben, welches Element Sie auswählen möchten.",
            "clickNotInitialized": "Die Namensauswahl ist momentan nicht verfügbar. Bitte kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
            "platformUnsupported": "Die Namensauswahl wird auf dieser Plattform nicht unterstützt."
        },
        "clickWait": "Initialisierung läuft. Bitte warten Sie einen Moment und versuchen Sie es erneut."
    },
    "deprecated": "Veraltet",
    "view": "Sicht",
    "aiWorkflows": {
        "settings": {
            "title": "Einstellungen automatisieren",
            "description": "Konfigurieren Sie die für KI-Workflows verwendeten KI-Modelle und -Geräte. KI-Workflows ermöglichen die Automatisierung von Desktop- und Browseraufgaben mithilfe von geräteinterner KI.",
            "configType": {
                "title": "Modellkonfigurationstyp",
                "description": "Wählen Sie den gewünschten Modellkonfigurationstyp für KI-Workflows aus. Verschiedene Konfigurationen sind für unterschiedliche Modelle optimiert.",
                "label": "Konfigurationstyp"
            },
            "reasoningModel": {
                "title": "Argumentationsmodell",
                "description": "Wählen Sie das KI-Modell für die Aufgaben im Bereich logisches Denken und Planen aus. Das Modell analysiert Ihre Anfragen und erstellt Aktionspläne.",
                "label": "Argumentationsmodell"
            },
            "reasoningDevice": {
                "label": "Logikgerät"
            },
            "generationModel": {
                "title": "Generationsmodell",
                "description": "Wählen Sie das KI-Modell für die Textgenerierung aus. Das Generierungsmodell erstellt bei Bedarf im Rahmen der Arbeitsabläufe Textinhalte.",
                "label": "Generationsmodell"
            },
            "generationDevice": {
                "label": "Erzeugungsgerät"
            },
            "noModelsFound": "Keine Modelle gefunden",
            "terminate": {
                "title": "Ressourcen für einen klaren Workflow",
                "description": "Klicken Sie hier, um den Workflow-Worker zu beenden und Ressourcen freizugeben. Dadurch werden alle laufenden Workflows gestoppt und der von den KI-Modellen belegte Speicher freigegeben.",
                "button": "Workflow-Mitarbeiter beenden",
                "success": "Workflow-Mitarbeiter beendet.",
                "confirm": {
                    "title": "Workflow-Mitarbeiter beenden",
                    "description": "Möchten Sie den Workflow-Worker wirklich beenden? Dadurch werden alle laufenden Workflows gestoppt und Ressourcen freigegeben.",
                    "confirm": "Ja, beenden"
                }
            },
            "autoWarm": {
                "title": "Automatischer Start von KI-Workflows",
                "description": "KI-Workflow-Modelle werden beim Start der App automatisch initialisiert. Die Modelle werden vorab geladen, sodass Workflows sofort starten können.",
                "option": "Automatischer Start von KI-Workflow-Modellen beim App-Start"
            },
            "prompt": {
                "title": "Zusätzliche Informationen zu KI-Workflows",
                "description": "Geben Sie hier zusätzliche Details ein, die von der KI von Cephable bei der Ausführung von Workflows verwendet werden sollen. In diesem Feld können Sie Ihre Präferenzen für Tonfall, Verhalten oder andere Details festlegen.",
                "field": "Zusätzliche Aufforderung",
                "placeholder": "Beispielsweise sollten Sie vor dem Absenden von E-Mails immer eine Bestätigung abgeben. Bevorzugen Sie kurze Antworten. Verwenden Sie in Dokumenten eine formelle Sprache."
            },
            "disableButtonNames": {
                "edit": "Block-Button-Interaktionen",
                "input": {
                    "label": "Schaltflächenname",
                    "question": "Welche Schaltflächen möchten Sie blockieren? Sie können vollständige oder teilweise Schaltflächennamen eingeben.",
                    "remove": "Name der Schaltfläche „Entfernen“"
                },
                "button": "Block-Schaltflächen",
                "description": "Legen Sie fest, mit welchen Schaltflächen KI-Workflows interagieren dürfen. Standardmäßig kann Cephable jede Schaltfläche auf Ihrem Bildschirm anklicken. Verwenden Sie diese Einstellung, um versehentliche Aktionen (z. B. „Kaufen“, „Löschen“) zu verhindern."
            },
            "remoteWorkflows": {
                "title": "Führen Sie KI-Workflows auf all Ihren Geräten aus",
                "option": "Meine anderen Geräte sollen die auf diesem Gerät ausgeführten Automatisierungen starten und befolgen.",
                "description": "Diese Funktion ist standardmäßig aktiviert. Ist sie aktiviert, können Sie die Automatisierungen dieses Geräts von Ihren anderen angemeldeten Geräten aus starten, überwachen und beantworten: Der Fortschritt der Automatisierung (Schritttitel und KI-Entscheidungen) sowie alle Fragen, die sie Ihnen stellt, werden in Echtzeit an diese Geräte gesendet, sodass Sie von überall aus antworten können. Diese Daten werden ausschließlich zwischen Ihren eigenen Geräten ausgetauscht und niemals auf den Servern von Cephable gespeichert. Deaktivieren Sie diese Funktion, um Automatisierungen ausschließlich auf diesem Gerät auszuführen – Automatisierungen werden weiterhin hier ausgeführt, jedoch werden keine Daten an Ihre anderen Geräte gesendet und diese können keine Automatisierungen auf diesem Gerät starten."
            },
            "thinkingLevel": {
                "field": "Argumentationsaufwand",
                "description": "Wie gründlich die KI jeden Schritt vor der Ausführung durchdenkt. Höhere Stufen helfen ihr, Aktionen bei komplexen Aufgaben zuverlässiger auszuwählen und zu ordnen, verlangsamen aber jeden einzelnen Schritt etwas. Die mittlere Stufe wird für die meisten Nutzer empfohlen.",
                "low": "Niedrig (schnellste)",
                "medium": "Mittel (empfohlen)",
                "high": "Hoch",
                "max": "Max (am gründlichsten)"
            }
        }
    },
    "control": "Kontrolle",
    "automate": "Automatisieren",
    "deviceCommandThrottled": {
        "macroLength": "Diese Verbindung unterstützt keine langen Makros. Ihr Makro wurde automatisch gekürzt.",
        "commandCount": "Diese Verbindung begrenzt die Geschwindigkeit, mit der Sie Befehle senden können. Bitte warten Sie und versuchen Sie es später erneut.",
        "incompatibleActions": "Dieses Steuerelement enthält Aktionen, die nicht miteinander kombiniert werden können und wurde daher nicht gesendet."
    },
    "tos": {
        "title": "Aktualisierung der Nutzungsbedingungen",
        "description": "Unsere Nutzungsbedingungen wurden aktualisiert. Bitte lesen und akzeptieren Sie die aktualisierten Bedingungen, um Cephable weiterhin zu nutzen.",
        "effectiveDate": "Gültigkeitsdatum: {{date}}",
        "accept": "Nutzungsbedingungen akzeptieren",
        "loadError": "Nutzungsbedingungen können nicht geladen werden. Bitte versuchen Sie es erneut.",
        "viewInBrowser": "Nutzungsbedingungen im Browser anzeigen",
        "acceptCheckbox": "Ich habe die Nutzungsbedingungen gelesen und akzeptiere sie"
    },
    "appearance": {
        "title": "Erscheinungsbild"
    },
    "troubleshooting": {
        "title": "Fehlerbehebung"
    },
    "extensions": {
        "title": "Erweiterungen",
        "titleShort": "Erweiterungen",
        "description": "Aktivieren Sie Funktionen, verbinden Sie Begleit-Apps und erweitern Sie die Möglichkeiten von Cephable.",
        "searchPlaceholder": "Sucherweiterungen",
        "noResults": "Ihre Suche ergab keine Treffer für Ihre Dateierweiterungen.",
        "comingSoon": "Demnächst verfügbar",
        "done": "Erledigt",
        "getStarted": "Los geht's!",
        "viewDetails": "Details und Einstellungen anzeigen",
        "enable": "Aktivieren",
        "publisher": {
            "official": "Cephable",
            "officialTitle": "Offiziell – erstellt und gewartet von Cephable",
            "byline": "Von {{publisher}}",
            "thirdPartyTitle": "Drittanbieterintegration durch {{publisher}}"
        },
        "category": {
            "inputControls": {
                "title": "Eingabe & Steuerung",
                "description": "Aktivieren Sie mit Cephable die Steuerungsmöglichkeiten Ihres Geräts."
            },
            "companionApps": {
                "title": "Begleit-Apps und Tools",
                "description": "Erweitere Cephable mit unserer mobilen App und unseren webbasierten Editoren."
            },
            "buildExtend": {
                "title": "Bauen & Erweitern",
                "description": "Erstellen Sie Ihre eigenen Erweiterungen mit der Cephable API und den SDKs."
            },
            "marketplace": {
                "title": "Marktplatz",
                "description": "Neue Fähigkeiten, Werkzeuge und Kontakte sind im Anmarsch."
            }
        },
        "camera": {
            "title": "Kamerasteuerung",
            "description": "Steuern Sie Ihr Gerät durch Gesichts- und Kopfbewegungen mithilfe Ihrer Kamera.",
            "detail": "Die Kamerasteuerung ermöglicht es Ihnen, Ihr Gerät mithilfe von Gesichtsausdrücken und Kopfbewegungen – einschließlich der Kopfsteuerung als Maus – zu bedienen. Aktivieren Sie diese Funktion mit dem Schalter auf der Karte und passen Sie das Verhalten anschließend hier an.",
            "settings": {
                "title": "Mimik und Gestik",
                "description": "In den Einstellungen können Sie festlegen, welche Gesichtsausdrücke und Kopfbewegungen den jeweiligen Aktionen zugeordnet sind."
            },
            "advancedSettings": "Kameraeinstellungen öffnen"
        },
        "gamepad": {
            "title": "Gamepad-Unterstützung",
            "description": "Emulieren Sie einen Xbox-Controller, damit Spiele Ihre Cephable-Eingaben erkennen.",
            "detail": "Für die Gamepad-Unterstützung ist die Installation von ViGEm, einem inoffiziellen Treiber eines Drittanbieters, erforderlich, um einen virtuellen Xbox-Controller zu emulieren, der von Spielen nativ erkannt wird. Installieren oder aktualisieren Sie den Treiber unten. Verfügbar für Windows x64."
        },
        "mobile": {
            "title": "Cephable Mobile App",
            "description": "Nutzen Sie Ihr Smartphone als zusätzlichen Controller mit der Cephable-Mobil-App.",
            "detail": "Laden Sie die Cephable-App herunter, um Ihr Smartphone als Controller zu nutzen. Scannen Sie einen Code oder nutzen Sie die Links, um die App für iOS oder Android herunterzuladen. Eine Vorschau der App finden Sie unten.",
            "screenshotsTitle": "Vorschau",
            "screenshotPlaceholder": "Screenshot",
            "screenshotAlt": "Screenshot der Cephable-Mobil-App {{number}}",
            "scanTitle": "Scannen zum Herunterladen",
            "ios": "iOS – App Store",
            "android": "Android – Google Play",
            "iosAction": "Jetzt im App Store erhältlich",
            "androidAction": "Jetzt bei Google Play herunterladen"
        },
        "controllerCreator": {
            "title": "Ersteller benutzerdefinierter Controller",
            "description": "Entwerfen Sie Ihre eigenen Bildschirm-Controller auf controller.cephable.com.",
            "detail": "Mit dem Custom Controller Creator können Sie Ihre eigenen Bildschirmsteuerungen im Browser entwerfen und teilen.",
            "qrCaption": "controller.cephable.com",
            "action": "Open Controller Creator",
            "screenshotsTitle": "Vorschau",
            "screenshotPlaceholder": "Screenshot des Controller-Erstellers",
            "screenshotAlt": "Screenshot des Custom Controller Creators {{number}}"
        },
        "developer": {
            "title": "Erstellen Sie Ihre eigene Erweiterung",
            "description": "Verwenden Sie die Cephable API und SDKs, um Ihre eigenen Erweiterungen zu erstellen und zu teilen.",
            "detail": "Entwickeln Sie Ihre eigenen Erweiterungen und Integrationen mit Cephable. Erkunden Sie die API und die SDKs und veröffentlichen und teilen Sie Ihre Kreationen auf developers.cephable.com.",
            "api": {
                "title": "Cephable API",
                "description": "Profile, Geräte, Steuerelemente und Echtzeitereignisse programmatisch verwalten."
            },
            "sdk": {
                "title": "SDKs & Beispiele",
                "description": "Mit unseren SDKs, Beispielen und Integrationsleitfäden gelingt der schnelle Einstieg."
            },
            "action": "Gehen Sie zu developers.cephable.com"
        },
        "portal": {
            "title": "Projekte & Teams",
            "description": "Verwalten Sie Ihre Projekte und Teams im Cephable-Portal.",
            "detail": "Mit dem Cephable-Portal können Sie Ihre Projekte, Teams und Organisationseinstellungen an einem Ort verwalten.",
            "projects": {
                "title": "Projekte",
                "description": "Projekte, API-Schlüssel und Integrationen erstellen und verwalten."
            },
            "teams": {
                "title": "Teams",
                "description": "Laden Sie Mitglieder ein, weisen Sie Rollen zu und verwalten Sie den Zugriff innerhalb Ihrer Organisation."
            },
            "action": "Öffne das Cephable-Portal"
        },
        "mcpTools": {
            "title": "MCP-Tools",
            "description": "Verbinden Sie die Tools des Connect Model Context Protocol, um die Funktionalitäten von Cephable zu erweitern."
        },
        "aiSkills": {
            "title": "KI-Fähigkeiten",
            "description": "Füge wiederverwendbare KI-Funktionen hinzu, die Cephable bei Bedarf auslösen kann."
        },
        "workflows": {
            "title": "Wiederverwendbare Arbeitsabläufe",
            "description": "Vorgefertigte Automatisierungs-Workflows teilen und installieren."
        },
        "controlBundles": {
            "title": "Steuerungspakete",
            "description": "Installieren Sie kuratierte Pakete von App- und Spielsteuerungen mit einem Fingertipp."
        },
        "connections": {
            "title": "Spiel- und App-Verbindungen",
            "description": "Entdecke Spiele und Apps, die du mit Cephable steuern kannst, wie zum Beispiel Call of Duty: Black Ops 7."
        }
    },
    "sensitivityValues": {
        "verySensitive": "Sehr empfindlich",
        "high": "Hoch",
        "medium": "Medium",
        "low": "Niedrig",
        "notSensitive": "Nicht empfindlich"
    },
    "summarize": "Zusammenfassen",
    "appControlsPanel": {
        "searchPlaceholder": "Suchbefehle...",
        "searchLabel": "Suchbefehle",
        "favorites": {
            "title": "Favoriten",
            "description": "Favoriten sind Steuerelemente, die Sie häufig verwenden. Sie können einen Befehl als Favorit markieren, indem Sie auf das Sternsymbol daneben klicken."
        },
        "noCommandsFound": "Keine Befehle gefunden",
        "globalCommands": "Global",
        "prefixCommandToast": "Dies ist ein Präfixbefehl – sagen oder tippen Sie das Präfix gefolgt von der Phrase, um ihn auszulösen."
    },
    "collapse": "Zusammenbruch",
    "intelligentTasks": {
        "loading": {
            "loadingModels": "KI-Modelle werden geladen...",
            "extractingModels": "Extraktion von KI-Modellen..."
        }
    },
    "sidebar": {
        "collapse": "Seitenleiste ausklappen",
        "expand": "Seitenleiste erweitern"
    },
    "workspace": {
        "title": "Arbeitsplatz",
        "badge": "Auf dem Gerät · privat",
        "subtitle": "Ihr KI-Assistent läuft vollständig auf diesem Gerät. Starten Sie die Steuerung, erstellen Sie Prozesse, automatisieren Sie Aufgaben oder chatten Sie einfach.",
        "control": {
            "title": "Kontrolle",
            "description": "Sprachbefehle, Tastaturkürzel und Schnellaktionsschaltflächen – funktionieren in jeder App auf Ihrem Gerät.",
            "voice": {
                "title": "Sprachsteuerung",
                "description": "Freisprechfunktion"
            },
            "dictation": {
                "title": "Diktat",
                "description": "Sprechen Sie mit dem Text"
            },
            "computerUse": {
                "title": "Computernutzung",
                "description": "Lassen Sie den Assistenten handeln."
            }
        },
        "create": {
            "title": "Erstellen",
            "description": "Entwerfen, überarbeiten, neu formatieren und übersetzen – direkt in der App, in der Sie gerade arbeiten, mithilfe von kopiertem und markiertem Text.",
            "items": {
                "draftEmail": "E-Mail entwerfen",
                "writeDocument": "Schreiben Sie ein Dokument",
                "summarizeNotes": "In Notizen zusammenfassen",
                "polishWriting": "Meine Schrift polieren",
                "translateText": "Text übersetzen",
                "socialPost": "Verfasse einen Social-Media-Beitrag",
                "cd_brief": "Erstellen Sie ein Kreativbriefing",
                "cd_caption": "Verfasse eine Bildunterschrift und einen Alternativtext.",
                "ar_insights": "Fassen Sie die Ergebnisse zu Erkenntnissen zusammen.",
                "ar_exec": "Verfassen Sie eine Managementzusammenfassung",
                "cc_followup": "Verfassen Sie eine Folge-E-Mail",
                "cc_meetingNotes": "Aus Notizen ein Besprechungsprotokoll erstellen",
                "bd_commit": "Schreibe eine Commit-Nachricht",
                "bd_review": "Fassen Sie eine Code-Überprüfung zusammen",
                "gp_bio": "Schreibe eine Stream-Bio",
                "gp_recap": "Zusammenfassung der gestrigen Sitzung",
                "lt_lesson": "Erstellen Sie einen Unterrichtsplan",
                "lt_studyNotes": "Fassen Sie es in Lernnotizen zusammen.",
                "mo_agenda": "Entwurf einer Sitzungsagenda",
                "mo_update": "Schreiben Sie ein Projektupdate",
                "aa_simplify": "Vereinfachen Sie Ihre Sprache.",
                "aa_describe": "Beschreibe ein Bild in Worten"
            },
            "contextRow": {
                "highlightedText": "Text markieren / in die Zwischenablage kopieren",
                "output": "Eingabe:",
                "input": "Anwendungsgebiete:",
                "background": "Hintergrund",
                "currentapp": "Aktuelle App"
            },
            "prompts": {
                "draftEmail": "Verfassen Sie eine klare, professionelle E-Mail zu diesem Thema.",
                "writeDocument": "Verfassen Sie ein Dokument darüber.",
                "summarizeNotes": "Fassen Sie dies in prägnanten, gut strukturierten Stichpunkten zusammen.",
                "polishWriting": "Überarbeiten Sie den Text so, dass er klarer und präziser ist, wobei Sie meine Bedeutung und meinen Tonfall beibehalten.",
                "socialPost": "Verfasse einen kurzen, ansprechenden Social-Media-Beitrag zu diesem Thema.",
                "cd_brief": "Erstellen Sie ein Kreativkonzept für dieses Projekt.",
                "ar_insights": "Fassen Sie die wichtigsten Ergebnisse und Erkenntnisse aus diesen Daten zusammen.",
                "ar_exec": "Verfassen Sie hierfür eine prägnante Managementzusammenfassung.",
                "cc_followup": "Verfassen Sie eine Folge-E-Mail zu diesem Thema.",
                "cc_meetingNotes": "Verwandeln Sie diese Notizen in übersichtliche Besprechungsprotokolle mit konkreten Handlungsempfehlungen.",
                "bd_commit": "Verfassen Sie eine aussagekräftige Commit-Nachricht für diese Änderungen:",
                "bd_review": "Fassen Sie diese Code-Überprüfung in den wichtigsten Punkten und den erforderlichen Änderungen zusammen.",
                "gp_bio": "Verfasse eine prägnante Bio für meinen Stream/mein Profil.",
                "lt_lesson": "Entwerfen Sie einen Unterrichtsplan zu diesem Thema.",
                "lt_studyNotes": "Fassen Sie dieses Material in Lernnotizen zusammen, die ich wiederholen kann.",
                "mo_agenda": "Erstellen Sie eine Tagesordnung für die Besprechung, die diesen Punkt abdeckt.",
                "mo_update": "Verfassen Sie auf dieser Grundlage einen Projektstatusbericht für die Stakeholder.",
                "aa_simplify": "Schreiben Sie dies in einfacher, leicht verständlicher Sprache."
            }
        },
        "automate": {
            "title": "Automatisieren",
            "description": "Beschreiben Sie eine Aufgabe in einfacher Sprache, und Cephable führt sie in Ihren Anwendungen, Ihren Dateien und sogar in Ihrer Kommandozeile aus.",
            "items": {
                "triage": "Priorisiere meine E-Mails",
                "cd_exportAssets": "Assets umbenennen und ablegen",
                "cd_moodboard": "Referenzen sammeln",
                "cc_triage": "Priorisierung und Entwurf von Antworten",
                "cc_recap": "Zusammenfassung & an das Team senden",
                "bd_scaffold": "Gerüst für ein Projekt",
                "gp_schedule": "Plane einen Stream-Zeitplan",
                "lt_handout": "Erstellen Sie ein Handout",
                "summarizeSend": "Zusammenfassen & per E-Mail senden",
                "researchDoc": "Recherchieren und ein Dokument schreiben",
                "organizeFiles": "Meine Dateien organisieren",
                "cleanUp": "einen Ordner aufräumen",
                "wordDoc": "Erstellen Sie ein Word-Dokument",
                "ar_summarizeSend": "Zusammenfassen & per E-Mail senden",
                "ar_analyzeData": "Eine Tabellenkalkulation analysieren",
                "ar_deck": "Erstelle ein Deck aus Daten",
                "cc_summarizeEmail": "In einer E-Mail zusammenfassen",
                "cc_socialPost": "Beitrag über einen Link",
                "bd_buildTest": "Ein Projekt erstellen und testen",
                "bd_cleanup": "Vorschläge zur Codebereinigung",
                "lt_studyMaterial": "Lernmaterialien erstellen",
                "lt_accommodation": "Erstellen Sie barrierefreie Notizen",
                "lt_research": "Recherchieren und vergleichen",
                "mo_meetingActions": "Notizen in Handlungen umsetzen",
                "mo_organizeFiles": "Meine Dateien organisieren",
                "mo_cleanup": "Downloads aufräumen",
                "aa_translate": "Ein Dokument übersetzen"
            },
            "prompts": {
                "summarizeSend": "Fassen Sie den Inhalt des Ordners <folder> zusammen und senden Sie ihn per E-Mail an <team email>.",
                "researchDoc": "Analysiere die Trends in <Ordner oder Dokument> und fasse deine Ergebnisse in einem neuen Dokument zusammen.",
                "organizeFiles": "Kopieren Sie die Dateien von<source folder> hinein<destination folder> Die",
                "cleanUp": "Entferne alle <Dateitypen, z. B. Screenshots> aus meinem <Ordner>.",
                "wordDoc": "Verwenden<article or notes> um ein Microsoft Word-Dokument zu erstellen, das<does what> Die",
                "triage": "Gehen Sie meinen Posteingang durch und teilen Sie mir mit, was meine Aufmerksamkeit erfordert. Entwerfen Sie anschließend Antworten, wo dies nötig ist.",
                "cd_exportAssets": "Benennen Sie die Design-Assets im Ordner <folder> nach diesem Schema — <benennungsschema> — um und sortieren Sie sie in Ordner.",
                "cd_moodboard": "Suchen Sie online nach Referenzen für <Idee> und fassen Sie diese in einem Dokument zusammen.",
                "ar_summarizeSend": "Fassen Sie den Inhalt des Ordners <folder> zusammen und senden Sie ihn per E-Mail an <team email>.",
                "ar_analyzeData": "Analysiere die <Tabellenkalkulation> und finde heraus, <worauf du achten solltest, z. B. auf Schlüsselverluste>.",
                "ar_deck": "Die Ergebnisse aus dem <Dokument oder Ordner> werden in eine PowerPoint-Präsentation umgewandelt, die <die wichtigsten Punkte> hervorhebt.",
                "cc_triage": "Lesen Sie meinen Posteingang und verfassen Sie Antwortentwürfe für alle Nachrichten, die eine Antwort erfordern.",
                "cc_summarizeEmail": "Verfassen Sie eine E-Mail mit folgender Zusammenfassung:<article or document> und auf die wichtigsten technischen Details hinweisen.",
                "cc_recap": "Verfassen Sie eine Zusammenfassung der <Besprechungsnotizen> und senden Sie diese per E-Mail an <Team-E-Mail>.",
                "cc_socialPost": "Lesen<article or website> und schreiben Sie eine<platform, e.g. Discord> -Schreibe einen freundlichen Beitrag darüber und speichere ihn dann in einer neuen Notiz.",
                "bd_buildTest": "Überprüfen Sie den Code im <Projektordner>, kompilieren Sie ihn und führen Sie die Tests aus. Sollte etwas fehlschlagen, prüfen Sie den Git-Verlauf und teilen Sie mir mit, was wahrscheinlich den Fehler verursacht hat.",
                "bd_cleanup": "Schau dir den Code im <Projektordner> an und sag mir, wie ich ihn übersichtlicher gestalten kann.",
                "bd_scaffold": "Erstelle ein neues <Projekttyp>-Projekt im <Ordner> mit den benötigten Startdateien.",
                "gp_schedule": "Plane einen Streaming-Zeitplan für<time period> Abdeckung<games or activities> Die",
                "lt_studyMaterial": "Verwenden<article or notes> um ein Word-Dokument zu erstellen für<grade level> Studenten mit<reflection questions or a study guide> Die",
                "lt_accommodation": "Erstellen Sie ein Word-Dokument mit Vorlesungsnotizen zum Thema <Thema>, formatiert für einen Studenten mit <Unterstützung>.",
                "lt_handout": "Die Lesetexte im Ordner <folder> sollen zu einem einzigen Handout-Dokument zusammengefasst werden.",
                "lt_research": "Suche online nach <Thema, z. B. Bücher zum Thema Neurodiversität> und erstelle ein Dokument, das jedes Buch zusammenfasst, damit ich es vergleichen kann.",
                "mo_meetingActions": "Lesen Sie die Besprechungsnotizen: Was ist noch zu tun, wer ist verantwortlich und was bedarf weiterer Recherche? Teilen Sie die Notizen in Dateien auf und ordnen Sie diese in einem Ordner.",
                "mo_organizeFiles": "Kopieren Sie die Dateien von<source folder> hinein<destination folder> Die",
                "mo_cleanup": "Entferne alle <Dateitypen, z. B. Installationsdateien> aus meinem Download-Ordner.",
                "aa_translate": "Übersetzen Sie <Dokument> in <Sprache> und speichern Sie es im <Ordner>."
            }
        },
        "history": {
            "title": "Neuere KI-Geschichte",
            "description": "Ihre neuesten intelligenten Aufgaben und Automatisierungen.",
            "viewAll": "Alle Verlaufsseiten anzeigen",
            "empty": "Ihre zuletzt ausgeführten KI-Aufgaben und Automatisierungen werden hier angezeigt."
        },
        "badgeRemote": "Ferngerät · sicher",
        "browser": {
            "openButton": "Browser öffnen",
            "windowTitle": "Cephable-Browser",
            "newTab": "Neuer Tab",
            "reload": "Neu laden",
            "forward": "Nach vorne",
            "openExternal": "Im Standardbrowser öffnen",
            "showWindow": "Versteckten Browser anzeigen",
            "addressPlaceholder": "Suche bei Google oder gib eine URL ein.",
            "clearData": {
                "description": "Löschen Sie den Verlauf, die Cookies, die zwischengespeicherten Daten und die gespeicherten Anmeldedaten des Cephable-Browsers. Dadurch werden Sie von allen Websites im Cephable-Browser abgemeldet.",
                "button": "Browserdaten löschen",
                "cleared": "Browserdaten gelöscht.",
                "error": "Browserdaten konnten nicht gelöscht werden.",
                "confirmTitle": "Browserdaten löschen?",
                "confirmMessage": "Von allen Programmen im Cephable-Browser abmelden?",
                "confirmDetail": "Dadurch werden Verlauf, Cookies, zwischengespeicherte Daten und gespeicherte Anmeldedaten des Cephable-Browsers endgültig gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden.",
                "confirm": "Klare Daten",
                "cancel": "Stornieren"
            },
            "context": {
                "newTab": "Neuer Tab",
                "reload": "Neu laden",
                "duplicate": "Doppelte Registerkarte",
                "close": "Tab schließen",
                "closeOthers": "Andere Tabs schließen",
                "closeRight": "Schließen Sie die Tabs rechts.",
                "back": "Zurück",
                "forward": "Nach vorne",
                "openLinkNewTab": "Link in neuem Tab öffnen",
                "openLinkExternal": "Link im Standardbrowser öffnen",
                "openExternal": "Im Standardbrowser öffnen",
                "openAllExternal": "Alle Tabs im Standardbrowser öffnen"
            },
            "home": {
                "tabTitle": "Heim",
                "title": "Der Cephable-Browser",
                "tagline": "Ein separater Browser, Cephable kann für Sie gesteuert werden.",
                "description": "Hier automatisiert Cephable Webaufgaben für Sie. Es läuft unabhängig von Ihrem gewohnten Browser, sodass Ihre normalen Tabs, Logins und Ihr Surfverhalten unberührt bleiben, während die Automatisierungen hier – sogar im Hintergrund – ausgeführt werden.",
                "searchPlaceholder": "Suchen Sie bei Google oder geben Sie eine URL ein, um loszulegen.",
                "go": "Gehen",
                "features": {
                    "separate": {
                        "title": "Läuft von selbst",
                        "description": "Getrennt von Ihrem Standardbrowser, sodass Automatisierungen Ihr persönliches Surfverhalten niemals stören."
                    },
                    "automate": {
                        "title": "Für die Automatisierung entwickelt",
                        "description": "Cephable kann hier freihändig Seiten öffnen, Formulare ausfüllen und Informationen sammeln."
                    },
                    "handoff": {
                        "title": "jederzeit übergeben",
                        "description": "Öffnen Sie jederzeit eine beliebige Seite in Ihrem Standardbrowser, um die Kontrolle zu übernehmen."
                    }
                }
            }
        }
    },
    "noResults": "Keine Ergebnisse",
    "noResultsSearch": "Ihre Suche ergab keine Treffer.",
    "interrupted": "Unterbrochen",
    "aiHistory": {
        "title": "KI-Geschichte",
        "description": "Lokalen KI-Konversationsverlauf ansehen, durchsuchen und verwalten.",
        "empty": {
            "title": "Noch keine KI-Geschichte",
            "description": "Ihr KI-Konversationsverlauf wird hier angezeigt, nachdem Sie intelligente Aufgaben verwendet haben."
        },
        "search": {
            "placeholder": "Konversationen durchsuchen..."
        },
        "pagination": {
            "range": "Anzeige von {{start}}–{{end}} von {{total}}"
        },
        "source": {
            "create": "Erstellen",
            "automate": "Automatisieren"
        },
        "workflow": {
            "plan": "Planen",
            "steps": "Schritte",
            "files": "Dateien",
            "folders": "Ordner"
        },
        "trace": {
            "thinking": "Denken",
            "toolCalls": "Tool-Aufrufe",
            "roles": {
                "tool": "Ergebnis des Tools"
            },
            "thought": "Gedanke",
            "action": "Aktion",
            "parameters": "Parameter",
            "result": "Ergebnis",
            "reply": "Du hast geantwortet",
            "sources": "Quellen"
        },
        "task": {
            "instructions": "Anweisungen",
            "language": "Sprache",
            "types": {
                "generate": "Erzeugen",
                "rewrite": "Umschreiben",
                "translate": "Übersetzen",
                "summarize": "Zusammenfassen"
            }
        },
        "session": {
            "messages": "Nachrichten",
            "deleteTitle": "Unterhaltung löschen",
            "deleteDescription": "Möchten Sie diese Konversation wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
            "deleteConfirm": "Löschen",
            "deleteCancel": "Stornieren"
        },
        "clear": {
            "title": "Clear AI-Historie",
            "description": "Löschen Sie den gesamten lokal gespeicherten KI-Konversationsverlauf von diesem Gerät.",
            "confirm": {
                "title": "Clear AI-Historie",
                "description": "Sind Sie sicher, dass Sie den gesamten KI-Konversationsverlauf löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.",
                "confirm": "Alles löschen",
                "cancel": "Stornieren"
            },
            "success": "KI-Verlauf erfolgreich gelöscht.",
            "error": "Fehler beim Löschen des KI-Verlaufs."
        },
        "export": {
            "title": "Export",
            "description": "Exportieren Sie Ihren KI-Konversationsverlauf in eine JSONL-Datei.",
            "success": "KI-Verlauf erfolgreich exportiert.",
            "error": "Der Export des KI-Verlaufs ist fehlgeschlagen."
        },
        "retention": {
            "note": "Ihre {{count}} letzten Konversationen werden gespeichert. Favoriten bleiben immer erhalten.",
            "label": "Halten"
        },
        "filter": {
            "label": "Nach Typ filtern",
            "all": "Alle Arten"
        },
        "favorites": {
            "title": "Favoriten",
            "add": "Zu Favoriten hinzufügen",
            "remove": "Aus Favoriten entfernen"
        },
        "select": {
            "selectOne": "Gespräch auswählen",
            "selected": "{{count}} ausgewählt",
            "deleteSelected": "Ausgewählte löschen",
            "clear": "Klar",
            "deleteTitle": "Ausgewählte Konversationen löschen",
            "deleteDescription": "{{count}} ausgewählte Konversationen löschen? Dies kann nicht rückgängig gemacht werden."
        },
        "copy": {
            "label": "Kopie",
            "success": "In die Zwischenablage kopiert.",
            "error": "Fehler beim Kopieren in die Zwischenablage."
        },
        "live": "Live",
        "keychain": {
            "continue": "Weitermachen",
            "title": "Schutz der KI-Geschichte",
            "message": "Cephable verschlüsselt Ihren KI-Verlauf, einschließlich des Workflow-Verlaufs, auf diesem Mac.",
            "detail": "macOS fragt Sie als Nächstes, ob Sie den Zugriff auf „Cephable Safe Storage“ erlauben möchten. Dieser Speicher enthält lediglich den Verschlüsselungsschlüssel, nicht Ihre Arbeitsabläufe oder Aufgabeninhalte. Wählen Sie „Immer erlauben“, damit Ihre verschlüsselte Historie weiterhin verfügbar bleibt und Sie nicht erneut gefragt werden. Wenn Sie dieses Mal „Erlauben“ wählen, kann Cephable darauf zugreifen, macOS kann Sie jedoch bei einem späteren Start erneut fragen."
        }
    },
    "uses": "Verwendung: {{value}}"
}
